import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export type Accompaniment = {
  __typename?: 'Accompaniment';
  id: Scalars['Int'];
  image: Image;
  imageId: Scalars['Int'];
  title: Scalars['String'];
};

export type Action = {
  __typename?: 'Action';
  dailyLimit?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  key: Scalars['String'];
  points: Scalars['Int'];
};

export type AdminAccompanimentOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  imageId?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AdminAccompanimentsWhereInput = {
  id?: InputMaybe<IntFilter>;
  imageId?: InputMaybe<IntFilter>;
  title?: InputMaybe<StringFilter>;
};

export type AdminActionCreateInput = {
  dailyLimit?: InputMaybe<Scalars['Int']>;
  key: Scalars['String'];
  points: Scalars['Int'];
};

export type AdminActionOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  points?: InputMaybe<SortOrder>;
};

export type AdminActionUpdateInputData = {
  dailyLimit?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  points?: InputMaybe<Scalars['Int']>;
};

export type AdminActionsWhereInput = {
  id?: InputMaybe<IntFilter>;
  key?: InputMaybe<StringFilter>;
  points?: InputMaybe<IntFilter>;
};

export type AdminBadgeCreateInput = {
  actionId?: InputMaybe<Scalars['Int']>;
  category: BadgeCategory;
  englishDescription?: Scalars['String'];
  englishName: Scalars['String'];
  imageId: Scalars['Int'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  period: BadgePeriod;
  spanishDescription?: Scalars['String'];
  spanishName: Scalars['String'];
  targetValue: Scalars['Int'];
  type: BadgeType;
};

export type AdminBadgeOrderByWithRelationInput = {
  category?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  englishName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  spanishName?: InputMaybe<SortOrder>;
  targetValue?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type AdminBadgeUpdateInputData = {
  actionId?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<BadgeCategory>;
  englishDescription?: InputMaybe<Scalars['String']>;
  englishName?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  period?: InputMaybe<BadgePeriod>;
  spanishDescription?: InputMaybe<Scalars['String']>;
  spanishName?: InputMaybe<Scalars['String']>;
  targetValue?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<BadgeType>;
};

export type AdminBadgesWhereInput = {
  actionId?: InputMaybe<IntFilter>;
  category?: InputMaybe<BadgeCategoryFilter>;
  englishName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<StringFilter>;
  spanishName?: InputMaybe<StringFilter>;
  type?: InputMaybe<BadgeTypeFilter>;
};

export type AdminBeerAttributeCreateInput = {
  acidity?: InputMaybe<Scalars['Int']>;
  bitterness?: InputMaybe<Scalars['Int']>;
  citric?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['Int']>;
  floral?: InputMaybe<Scalars['Int']>;
  fruity?: InputMaybe<Scalars['Int']>;
  liquorous?: InputMaybe<Scalars['Int']>;
  malty?: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
  special?: InputMaybe<Scalars['Int']>;
};

export type AdminBeerAttributeOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type AdminBeerAttributeUpdateInputData = {
  acidity?: InputMaybe<Scalars['Int']>;
  bitterness?: InputMaybe<Scalars['Int']>;
  citric?: InputMaybe<Scalars['Int']>;
  color?: InputMaybe<Scalars['Int']>;
  floral?: InputMaybe<Scalars['Int']>;
  fruity?: InputMaybe<Scalars['Int']>;
  liquorous?: InputMaybe<Scalars['Int']>;
  malty?: InputMaybe<Scalars['Int']>;
  special?: InputMaybe<Scalars['Int']>;
};

export type AdminBeerAttributesWhereInput = {
  id?: InputMaybe<IntFilter>;
  productId?: InputMaybe<IntFilter>;
};

export type AdminBeerDetailCreateInput = {
  category?: InputMaybe<BeerDetailCategory>;
  description: Scalars['String'];
  graduation: Scalars['Float'];
  ibu: Scalars['Float'];
};

export type AdminBeerDetailOrderByWithRelationInput = {
  category?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  graduation?: InputMaybe<SortOrder>;
  ibu?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type AdminBeerDetailUpdateInputData = {
  category?: InputMaybe<BeerDetailCategory>;
  description: Scalars['String'];
  graduation: Scalars['Float'];
  ibu: Scalars['Float'];
};

export type AdminBeerDetailsWhereInput = {
  category?: InputMaybe<BeerDetailCategoryFilter>;
  description?: InputMaybe<StringFilter>;
  graduation?: InputMaybe<FloatFilter>;
  ibu?: InputMaybe<FloatFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AdminBrandCreateInput = {
  abbreviation: Scalars['String'];
  bannerImageId?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  isMainBrand?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  slideImageId?: InputMaybe<Scalars['Int']>;
};

export type AdminBrandOrderByWithRelationInput = {
  abbreviation?: InputMaybe<SortOrder>;
  bannerImageId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  slideImageId?: InputMaybe<SortOrder>;
};

export type AdminBrandUpdateInputData = {
  abbreviation?: InputMaybe<Scalars['String']>;
  bannerImageId?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  isMainBrand?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  slideImageId?: InputMaybe<Scalars['Int']>;
};

export type AdminBrandsWhereInput = {
  abbreviation?: InputMaybe<StringFilter>;
  bannerImageId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  imageId?: InputMaybe<IntFilter>;
  isMainBrand?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
  slideImageId?: InputMaybe<Scalars['Int']>;
};

export type AdminCatalogCreateInput = {
  brandId?: InputMaybe<Scalars['Int']>;
  imageId: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type AdminCatalogOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
};

export type AdminCatalogUpdateInputData = {
  brandId?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AdminCatalogsWhereInput = {
  id?: InputMaybe<IntFilter>;
};

export type AdminImageCreateInput = {
  hdId: Scalars['Int'];
  nhdId: Scalars['Int'];
  sourceId: Scalars['Int'];
  stId: Scalars['Int'];
};

export type AdminImageOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrderCore>;
  hdId?: InputMaybe<SortOrderCore>;
  id?: InputMaybe<SortOrderCore>;
  nhdId?: InputMaybe<SortOrderCore>;
  sourceId?: InputMaybe<SortOrderCore>;
  stId?: InputMaybe<SortOrderCore>;
  updatedAt?: InputMaybe<SortOrderCore>;
};

export type AdminImageUpdateInputData = {
  hdId: Scalars['Int'];
  nhdId: Scalars['Int'];
  sourceId: Scalars['Int'];
  stId: Scalars['Int'];
};

export type AdminImagesWhereInput = {
  createdAt?: InputMaybe<DateFilterCore>;
  hdId?: InputMaybe<IntFilterCore>;
  id?: InputMaybe<IntFilterCore>;
  nhdId?: InputMaybe<IntFilterCore>;
  sourceId?: InputMaybe<IntFilterCore>;
  stId?: InputMaybe<IntFilterCore>;
  updatedAt?: InputMaybe<DateFilterCore>;
};

export type AdminImportPackagedProductCreateInput = {
  shortCode: Scalars['String'];
};

export type AdminLevelCreateInput = {
  englishName: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  pointsThreshold: Scalars['Int'];
  spanishName: Scalars['String'];
};

export type AdminLevelOrderByWithRelationInput = {
  englishName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  pointsThreshold?: InputMaybe<SortOrder>;
  spanishName?: InputMaybe<SortOrder>;
};

export type AdminLevelUpdateInputData = {
  englishName?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  pointsThreshold?: InputMaybe<Scalars['Int']>;
  spanishName?: InputMaybe<Scalars['String']>;
};

export type AdminLevelsWhereInput = {
  englishName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  pointsThreshold?: InputMaybe<IntFilter>;
  spanishName?: InputMaybe<StringFilter>;
};

export type AdminMediaCreateInput = {
  blobUrl: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AdminMediaOrderByWithRelationInput = {
  blobUrl?: InputMaybe<SortOrderCore>;
  createdAt?: InputMaybe<SortOrderCore>;
  id?: InputMaybe<SortOrderCore>;
  name?: InputMaybe<SortOrderCore>;
  type?: InputMaybe<SortOrderCore>;
  updatedAt?: InputMaybe<SortOrderCore>;
};

export type AdminMediaUpdateInputData = {
  blobUrl: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type AdminMediasWhereInput = {
  blobUrl?: InputMaybe<StringFilterCore>;
  createdAt?: InputMaybe<DateFilterCore>;
  id?: InputMaybe<IntFilterCore>;
  name?: InputMaybe<StringFilterCore>;
  type?: InputMaybe<StringFilterCore>;
  updatedAt?: InputMaybe<DateFilterCore>;
};

export type AdminNewsCreateInput = {
  contentId: Scalars['Int'];
  description: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  thumbnailId: Scalars['Int'];
  title: Scalars['String'];
};

export type AdminNewsOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AdminNewsUpdateInputData = {
  contentId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  thumbnailId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AdminNewssWhereInput = {
  contentId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AdminNotificationImportOrderByWithRelationInput = {
  attempts?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  success?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AdminNotificationImportsWhereInput = {
  date?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<IntFilter>;
  title?: InputMaybe<Scalars['String']>;
};

export type AdminPackagedBeerDetailCreateInput = {
  container: PackagedBeerDetailsContainer;
  packagedProductId: Scalars['Int'];
  unitsNb?: InputMaybe<Scalars['Int']>;
  volume: Scalars['Float'];
};

export type AdminPackagedBeerDetailUpdateInputData = {
  container: PackagedBeerDetailsContainer;
  unitsNb?: InputMaybe<Scalars['Int']>;
  volume: Scalars['Float'];
};

export type AdminPackagedLampDetailUpdateInputData = {
  consumption?: InputMaybe<Scalars['Float']>;
  dimensions?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type AdminPackagedLampDetailsCreateInput = {
  consumption?: InputMaybe<Scalars['Float']>;
  dimensions?: InputMaybe<Scalars['String']>;
  packagedProductId: Scalars['Int'];
  weight?: InputMaybe<Scalars['Int']>;
};

export type AdminPackagedPosDisplayDetailUpdateInputData = {
  dimensions?: InputMaybe<Scalars['String']>;
  units?: InputMaybe<Scalars['Int']>;
};

export type AdminPackagedPosDisplayDetailsCreateInput = {
  dimensions?: InputMaybe<Scalars['String']>;
  packagedProductId: Scalars['Int'];
  units?: InputMaybe<Scalars['Int']>;
};

export type AdminPackagedProductCreateInput = {
  commercialName: Scalars['String'];
  croppedImageId?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  isMain?: Scalars['Boolean'];
  name: Scalars['String'];
  productId: Scalars['Int'];
  slideId?: InputMaybe<Scalars['Int']>;
  staticSlideTypeId?: InputMaybe<Scalars['Int']>;
};

export type AdminPackagedProductOrderByWithRelationInput = {
  commercialName?: InputMaybe<SortOrder>;
  croppedImageId?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageId?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isMain?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  slideId?: InputMaybe<SortOrder>;
};

export type AdminPackagedProductUpdateInputData = {
  commercialName?: InputMaybe<Scalars['String']>;
  croppedImageId?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['String']>;
  imageId?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  productId: Scalars['Int'];
  slideId?: InputMaybe<Scalars['Int']>;
  staticSlideTypeId?: InputMaybe<Scalars['Int']>;
};

export type AdminPackagedProductWhereUniqueInput = {
  id: Scalars['Int'];
};

export type AdminPackagedProductsWhereInput = {
  AND?: InputMaybe<Array<AdminPackagedProductsWhereInput>>;
  NOT?: InputMaybe<Array<AdminPackagedProductsWhereInput>>;
  OR?: InputMaybe<Array<AdminPackagedProductsWhereInput>>;
  commercialName?: InputMaybe<StringFilter>;
  croppedImageId?: InputMaybe<IntFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  imageId?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
  product?: InputMaybe<AdminProductsWhereInput>;
  productId?: InputMaybe<IntFilter>;
  slideId?: InputMaybe<IntFilter>;
  staticSlideTypeId?: InputMaybe<IntFilter>;
};

export type AdminPackagedShowcaseDetailUpdateInputData = {
  bottleUnits?: InputMaybe<Scalars['Int']>;
  canUnits?: InputMaybe<Scalars['Int']>;
  consumptionPerDay: Scalars['Float'];
  dimensions?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<PackagedShowcaseDetailsFormat>;
  volume: Scalars['Float'];
  weight?: InputMaybe<Scalars['Int']>;
};

export type AdminPackagedShowcaseDetailsCreateInput = {
  bottleUnits?: InputMaybe<Scalars['Int']>;
  canUnits?: InputMaybe<Scalars['Int']>;
  consumptionPerDay: Scalars['Float'];
  dimensions?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<PackagedShowcaseDetailsFormat>;
  packagedProductId: Scalars['Int'];
  volume: Scalars['Float'];
  weight?: InputMaybe<Scalars['Int']>;
};

export type AdminPackagedTapColumnDetailUpdateInputData = {
  dimensions?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  isIlluminated: Scalars['Boolean'];
  tapBase?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type AdminPackagedTapColumnDetailsCreateInput = {
  dimensions?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  isIlluminated: Scalars['Boolean'];
  packagedProductId: Scalars['Int'];
  tapBase?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type AdminProductAccompanimentCreateInput = {
  accompanimentId: Scalars['Int'];
  productId: Scalars['Int'];
};

export type AdminProductAccompanimentOrderByWithRelationInput = {
  accompanimentId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
};

export type AdminProductAccompanimentsWhereInput = {
  accompanimentId?: InputMaybe<IntFilter>;
  productId?: InputMaybe<IntFilter>;
};

export type AdminProductCreateInput = {
  augmentedRealityUrl?: InputMaybe<Scalars['String']>;
  beerDetailsId?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['Int']>;
  category: ProductCategory;
  imageId?: InputMaybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  kegSlideImageId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  productCode?: InputMaybe<Scalars['String']>;
  shortCode?: InputMaybe<Scalars['String']>;
  slideId?: InputMaybe<Scalars['Int']>;
  tags: Array<Scalars['String']>;
};

export type AdminProductOrderByWithRelationInput = {
  brandId?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  productCode?: InputMaybe<SortOrder>;
  slideId?: InputMaybe<SortOrder>;
};

export type AdminProductUpdateInputData = {
  augmentedRealityUrl?: InputMaybe<Scalars['String']>;
  beerDetailsId?: InputMaybe<Scalars['Int']>;
  brandId?: InputMaybe<Scalars['Int']>;
  category: ProductCategory;
  chartImageId?: InputMaybe<Scalars['Int']>;
  imageId?: InputMaybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  kegSlideImageId?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  productCode?: InputMaybe<Scalars['String']>;
  shortCode?: InputMaybe<Scalars['String']>;
  slideId?: InputMaybe<Scalars['Int']>;
  tags: Array<Scalars['String']>;
};

export type AdminProductsWhereInput = {
  AND?: InputMaybe<Array<AdminProductsWhereInput>>;
  NOT?: InputMaybe<Array<AdminProductsWhereInput>>;
  OR?: InputMaybe<Array<AdminProductsWhereInput>>;
  brandId?: InputMaybe<IntFilter>;
  category?: InputMaybe<ProductCategoryFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
  packagedProducts?: InputMaybe<PackagedProductListRelationFilterInput>;
  productCode?: InputMaybe<StringFilter>;
  tags?: InputMaybe<TagsFilterInput>;
};

export type AdminProposalThemeCreateInput = {
  brandId?: InputMaybe<Scalars['Int']>;
  firstSlideImageId: Scalars['Int'];
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  shortFirstSlideImageId?: InputMaybe<Scalars['Int']>;
};

export type AdminProposalThemeOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type AdminProposalThemeUpdateInputData = {
  brandId?: InputMaybe<Scalars['Int']>;
  firstSlideImageId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  shortFirstSlideImageId?: InputMaybe<Scalars['Int']>;
};

export type AdminProposalThemesWhereInput = {
  id?: InputMaybe<IntFilter>;
};

export type AdminProvinceOrderByWithRelationInput = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type AdminProvinceWhereUniqueInput = {
  id: Scalars['Int'];
};

export type AdminProvincesWhereInput = {
  id?: InputMaybe<IntFilter>;
};

export type AdminReleaseNoteCreateInput = {
  content: Scalars['String'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type AdminReleaseNoteOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  version?: InputMaybe<SortOrder>;
};

export type AdminReleaseNoteUpdateInputData = {
  content?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['String']>;
};

export type AdminReleaseNotesWhereInput = {
  id?: InputMaybe<IntFilter>;
};

export type AdminSlideCreateInput = {
  product: ProductCreateNestedOneWithoutSlideInput;
  slideImageId: Scalars['Int'];
  status: SlideStatus;
};

export type AdminSlideOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  slideImageId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type AdminSlideUpdateInputData = {
  slideImageId?: InputMaybe<Scalars['Int']>;
  slidePartProductId?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<SlideStatus>;
};

export type AdminSlidesWhereInput = {
  createdAt?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntFilter>;
  slideImageId?: InputMaybe<IntFilter>;
  status?: InputMaybe<SlideStatusFilter>;
};

export type AdminStaticSlideCreateInput = {
  enabledByDefault: Scalars['Boolean'];
  imageId: Scalars['Int'];
  order?: InputMaybe<Scalars['Int']>;
  provinces?: InputMaybe<ProvinceCreateNestedManyWithoutStaticSlideTypesInput>;
  typeId: Scalars['Int'];
};

export type AdminStaticSlideOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  typeId?: InputMaybe<SortOrder>;
};

export type AdminStaticSlideTypeCreateInput = {
  editable?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  packagedProducts?: InputMaybe<PackagedProductCreateNestedManyWithoutStaticSlideTypeInput>;
  productCategory?: InputMaybe<ProductCategory>;
  provinces?: InputMaybe<ProvinceCreateNestedManyWithoutStaticSlideTypesInput>;
  type: Scalars['String'];
};

export type AdminStaticSlideTypeOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type AdminStaticSlideTypeUpdateInputData = {
  editable?: InputMaybe<Scalars['Boolean']>;
  order?: InputMaybe<Scalars['Int']>;
  packagedProducts?: InputMaybe<PackagedProductUdapteNestedManyWithoutStaticSlideTypeInput>;
  productCategory?: InputMaybe<ProductCategory>;
  provinces?: InputMaybe<ProvinceUpdateNestedManyWithoutStaticSlideTypesInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type AdminStaticSlideTypesWhereInput = {
  editable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IntFilter>;
  type?: InputMaybe<StringFilter>;
};

export type AdminStaticSlideUpdateInputData = {
  enabledByDefault?: InputMaybe<Scalars['Boolean']>;
  imageId?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['Int']>;
  provinces?: InputMaybe<ProvinceUpdateNestedManyWithoutStaticSlideTypesInput>;
  typeId?: InputMaybe<Scalars['Int']>;
};

export type AdminStaticSlidesWhereInput = {
  id?: InputMaybe<IntFilter>;
  typeId?: InputMaybe<IntFilter>;
};

export type AdminTrainingCreateInput = {
  contentId: Scalars['Int'];
  description: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  thumbnailId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type AdminTrainingOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AdminTrainingUpdateInputData = {
  contentId?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  thumbnailId?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AdminTrainingsWhereInput = {
  contentId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AdminUserCreateInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  hasAccessToPilotFeatures?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  managerId?: InputMaybe<Scalars['String']>;
  oktaId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
  role: Role;
  title?: InputMaybe<Scalars['String']>;
  userCode: Scalars['String'];
};

export type AdminUserOrderByWithRelationInput = {
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  hasAccessToPilotFeatures?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  managerId?: InputMaybe<SortOrder>;
  oktaId?: InputMaybe<SortOrder>;
  role?: InputMaybe<SortOrder>;
  userCode?: InputMaybe<SortOrder>;
};

export type AdminUserRankingOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AdminUserRankingsWhereInput = {
  contentId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AdminUserUpdateInputData = {
  firstName?: InputMaybe<Scalars['String']>;
  hasAccessToPilotFeatures?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  managerId?: InputMaybe<Scalars['String']>;
  oktaId?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profilePicture?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  title?: InputMaybe<Scalars['String']>;
  userCode?: InputMaybe<Scalars['String']>;
};

export type AdminUserWhereInput = {
  id?: InputMaybe<IntFilter>;
};

export type AdminUsersWhereInput = {
  AND?: InputMaybe<Array<AdminUsersWhereInput>>;
  NOT?: InputMaybe<Array<AdminUsersWhereInput>>;
  OR?: InputMaybe<Array<AdminUsersWhereInput>>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  hasAccessToPilotFeatures?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IntFilter>;
  lastName?: InputMaybe<StringFilter>;
  managerId?: InputMaybe<StringFilter>;
  oktaId?: InputMaybe<StringFilter>;
  role?: InputMaybe<UserRoleFilter>;
  userCode?: InputMaybe<StringFilter>;
};

export type Badge = {
  __typename?: 'Badge';
  action?: Maybe<Action>;
  actionId?: Maybe<Scalars['Int']>;
  category: BadgeCategory;
  createdAt: Scalars['DateTime'];
  englishDescription: Scalars['String'];
  englishName: Scalars['String'];
  id: Scalars['Int'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  key: Scalars['String'];
  period?: Maybe<BadgePeriod>;
  spanishDescription: Scalars['String'];
  spanishName: Scalars['String'];
  targetValue: Scalars['Int'];
  type: BadgeType;
  updatedAt: Scalars['DateTime'];
  userBadge?: Maybe<UserBadge>;
};

export enum BadgeCategory {
  Campaigns = 'CAMPAIGNS',
  Proposals = 'PROPOSALS',
  Sales = 'SALES',
  Visits = 'VISITS',
  Volume = 'VOLUME'
}

export type BadgeCategoryFilter = {
  equals?: InputMaybe<BadgeCategory>;
  in?: InputMaybe<Array<BadgeCategory>>;
  notIn?: InputMaybe<Array<BadgeCategory>>;
};

export type BadgeOrderByWithRelationInput = {
  category?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  englishName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  spanishName?: InputMaybe<SortOrder>;
  targetValue?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum BadgePeriod {
  Monthly = 'MONTHLY',
  None = 'NONE',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY'
}

export enum BadgeType {
  OneTime = 'ONE_TIME',
  Recurring = 'RECURRING'
}

export type BadgeTypeFilter = {
  equals?: InputMaybe<BadgeType>;
  in?: InputMaybe<Array<BadgeType>>;
  notIn?: InputMaybe<Array<BadgeType>>;
};

export type BadgesWhereInput = {
  category?: InputMaybe<BadgeCategoryFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<BadgeTypeFilter>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  count: Scalars['Int'];
};

export type BeerAttribute = {
  __typename?: 'BeerAttribute';
  acidity?: Maybe<Scalars['Int']>;
  bitterness?: Maybe<Scalars['Int']>;
  citric?: Maybe<Scalars['Int']>;
  color?: Maybe<Scalars['Int']>;
  floral?: Maybe<Scalars['Int']>;
  fruity?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  liquorous?: Maybe<Scalars['Int']>;
  malty?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  special?: Maybe<Scalars['Int']>;
};

export enum BeerDetailCategory {
  BlackAndDunkel = 'BLACK_AND_DUNKEL',
  Cider = 'CIDER',
  Craft = 'CRAFT',
  Extra = 'EXTRA',
  Flavor = 'FLAVOR',
  GlutenFree = 'GLUTEN_FREE',
  International = 'INTERNATIONAL',
  Mixed = 'MIXED',
  NationalNonAlcoholic = 'NATIONAL_NON_ALCOHOLIC',
  NationalWithAlcohol = 'NATIONAL_WITH_ALCOHOL',
  SummerRedWine = 'SUMMER_RED_WINE',
  Vermouth = 'VERMOUTH',
  Water = 'WATER'
}

export type BeerDetailCategoryFilter = {
  in?: InputMaybe<Array<BeerDetailCategory>>;
};

export type BeerDetailCreateInput = {
  description: Scalars['String'];
  graduation: Scalars['Float'];
  /** International Bitterness Units */
  ibu: Scalars['Float'];
};

export type BeerDetails = {
  __typename?: 'BeerDetails';
  category?: Maybe<BeerDetailCategory>;
  description: Scalars['String'];
  graduation: Scalars['Float'];
  /** International Bitterness Units */
  ibu: Scalars['Float'];
  id: Scalars['Int'];
};

export type BeerDetailsCreateNestedInput = {
  create?: InputMaybe<BeerDetailCreateInput>;
};

export type BookmarkedConnectData = {
  connect?: InputMaybe<Array<IdInput>>;
  disconnect?: InputMaybe<Array<IdInput>>;
};

export type BookmarkedProductsInput = {
  bookmarkedProducts: BookmarkedConnectData;
};

export type Brand = {
  __typename?: 'Brand';
  abbreviation: Scalars['String'];
  bannerImage?: Maybe<Image>;
  bannerImageId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['Int']>;
  isMainBrand: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  products: Array<Product>;
  slideImage?: Maybe<Image>;
  slideImageId?: Maybe<Scalars['Int']>;
};

export type BrandConnectNestedInput = {
  connect: BrandWhereUniqueInput;
};

export type BrandCreateInput = {
  abbreviation: Scalars['String'];
  name: Scalars['String'];
};

export type BrandDeleteInput = {
  id: Scalars['Int'];
};

export type BrandOrderByWithRelationInput = {
  abbreviation?: InputMaybe<SortOrder>;
  bannerImageId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  slideImageId?: InputMaybe<SortOrder>;
};

export type BrandWhereInput = {
  AND?: InputMaybe<Array<BrandWhereInput>>;
  abbreviation?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isMainBrand?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
};

export type BrandWhereUniqueInput = {
  id: Scalars['Int'];
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type Catalog = {
  __typename?: 'Catalog';
  brand?: Maybe<Brand>;
  brandId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  image?: Maybe<Image>;
  imageId: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type ChartDataInput = {
  comparisonValue: Scalars['Float'];
  comparisonValueUnits: Scalars['Float'];
  currentValue: Scalars['Float'];
  currentValueUnits: Scalars['Float'];
  title: Scalars['String'];
  titleUnit: Scalars['String'];
  unit: Scalars['String'];
  unitLiters: Scalars['String'];
};

export enum ClientType {
  Client = 'CLIENT',
  ClientWithoutKegbase = 'CLIENT_WITHOUT_KEGBASE',
  CompetitorClient = 'COMPETITOR_CLIENT',
  NotClient = 'NOT_CLIENT'
}

export type ClientTypeFilter = {
  in?: InputMaybe<Array<ClientType>>;
  notIn?: InputMaybe<Array<ClientType>>;
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isPrincipal?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Contract = {
  __typename?: 'Contract';
  endDate: Scalars['DateTime'];
  id: Scalars['Int'];
  payedAmount: Scalars['Float'];
  startDate: Scalars['DateTime'];
  totalAmount: Scalars['Float'];
  type?: Maybe<ContractType>;
};

export enum ContractType {
  Advertising = 'ADVERTISING',
  Loan = 'LOAN'
}

export type Coordinates = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CustomCommercialCondition = {
  __typename?: 'CustomCommercialCondition';
  name: Scalars['String'];
  price: Scalars['Float'];
  proposalId: Scalars['Int'];
  unitsNb: Scalars['Int'];
};

export type CustomCommercialConditionsInput = {
  name: Scalars['String'];
  price: Scalars['Float'];
  unitsNb: Scalars['Int'];
};

export type DateFilter = {
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
};

export type DateFilterCore = {
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
};

export type DeleteUserProposalTemplateInput = {
  proposalId: Scalars['Int'];
};

export type DetailsUnion = BeerDetails;

export enum DiscountType {
  EuroPerLiter = 'EURO_PER_LITER',
  EuroPerUnit = 'EURO_PER_UNIT',
  Percentage = 'PERCENTAGE',
  XY = 'X_Y'
}

export type DynamicSlide = {
  __typename?: 'DynamicSlide';
  id: Scalars['Int'];
  order: Scalars['Int'];
  pointOfSaleId?: Maybe<Scalars['Int']>;
  slide: Image;
  slideId: Scalars['Int'];
  type: PointOfSaleSlideType;
};

export type EnumPackagedBeerDetailsContainerFilter = {
  equals?: InputMaybe<PackagedBeerDetailsContainer>;
  in?: InputMaybe<Array<PackagedBeerDetailsContainer>>;
  notIn?: InputMaybe<Array<PackagedBeerDetailsContainer>>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type GetNextBestActionInput = {
  externalId: Scalars['String'];
};

export type GrowthIndicatorsInput = {
  beer?: InputMaybe<Scalars['Float']>;
  bottle?: InputMaybe<Scalars['Float']>;
  keg?: InputMaybe<Scalars['Float']>;
  water?: InputMaybe<Scalars['Float']>;
};

export type GuaranteeInput = {
  firstGuarantee?: InputMaybe<TypeAmountInput>;
  secondGuarantee?: InputMaybe<TypeAmountInput>;
};

export enum GuaranteeType {
  Bank = 'BANK',
  None = 'NONE',
  Personal = 'PERSONAL'
}

export type HiddenConnectData = {
  connect?: InputMaybe<Array<IdInput>>;
  disconnect?: InputMaybe<Array<IdInput>>;
};

export type HiddenProductsInput = {
  hiddenProducts: HiddenConnectData;
};

export type IdInput = {
  id: Scalars['Int'];
};

export type IdName = {
  __typename?: 'IdName';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  hd: Media;
  hdId: Scalars['Int'];
  id: Scalars['Int'];
  nhd: Media;
  nhdId: Scalars['Int'];
  slideParts: Array<SlidePart>;
  slides: Array<Slide>;
  source: Media;
  sourceId: Scalars['Int'];
  src: Scalars['String'];
  st: Media;
  stId: Scalars['Int'];
};

export type ImagesPresentation = {
  __typename?: 'ImagesPresentation';
  pdf?: Maybe<Media>;
  pdfId: Scalars['Int'];
  title: Scalars['String'];
};

export type ImportMonthLiters = {
  import?: InputMaybe<Scalars['Float']>;
  liters?: InputMaybe<Scalars['Float']>;
  month?: InputMaybe<Scalars['Float']>;
};

export type ImportNotificationResponse = {
  __typename?: 'ImportNotificationResponse';
  errors: Array<Scalars['String']>;
  imported: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type ImportUserRankingResponse = {
  __typename?: 'ImportUserRankingResponse';
  errors: Array<Scalars['String']>;
  imported: Scalars['Int'];
  success: Scalars['Boolean'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
};

export type IntFilterCore = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
};

export type Kpi = {
  __typename?: 'KPI';
  averagePricePerHectoliter: Scalars['Float'];
  averagePricePerHectoliterByManager: Scalars['Float'];
};

export type Level = {
  __typename?: 'Level';
  englishName: Scalars['String'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  pointsThreshold: Scalars['Int'];
  spanishName: Scalars['String'];
};

export type LevelWhereInput = {
  AND?: InputMaybe<Array<LevelWhereInput>>;
  englishName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  pointsThreshold?: InputMaybe<IntFilter>;
  spanishName?: InputMaybe<StringFilter>;
};

export type Loan = {
  import?: InputMaybe<Scalars['Float']>;
  liters?: InputMaybe<Scalars['Float']>;
  litersPerYear?: InputMaybe<Scalars['Float']>;
  month?: InputMaybe<Scalars['Float']>;
};

export type Location = {
  __typename?: 'Location';
  address: Scalars['String'];
  id: Scalars['Int'];
  isBuyer: Scalars['Boolean'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  pointOfSaleId: Scalars['Int'];
};

export type LocationWhereInput = {
  AND?: InputMaybe<Array<LocationWhereInput>>;
  NOT?: InputMaybe<Array<LocationWhereInput>>;
  OR?: InputMaybe<Array<LocationWhereInput>>;
  address?: InputMaybe<StringFilter>;
  isBuyer?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<FloatFilter>;
  longitude?: InputMaybe<FloatFilter>;
  pointOfSale?: InputMaybe<PointOfSaleWhereInput>;
};

export type Media = {
  __typename?: 'Media';
  blobUrl: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  type: Scalars['String'];
};

export type MonthLiters = {
  liters?: InputMaybe<Scalars['Float']>;
  month?: InputMaybe<Scalars['Float']>;
};

export type MonthlyPointOfSaleVolumeCustomInput = {
  endMonth?: InputMaybe<Scalars['Int']>;
  endYear?: InputMaybe<Scalars['Int']>;
  startMonth?: InputMaybe<Scalars['Int']>;
  startYear?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addProposalProducts?: Maybe<Array<ProposalSlide>>;
  adminApplyPrices: PriceApplyResult;
  adminCreateAction: Action;
  adminCreateBadge: Badge;
  adminCreateBeerAttribute: BeerAttribute;
  adminCreateBeerDetail: BeerDetails;
  adminCreateBrand: Brand;
  adminCreateCatalog: Catalog;
  adminCreateImage: Image;
  adminCreateLevel: Level;
  adminCreateMedia: Media;
  adminCreateNews: News;
  adminCreatePackagedBeerDetail: PackagedBeerDetails;
  adminCreatePackagedLampDetail: PackagedLampDetails;
  adminCreatePackagedPosDisplayDetail: PackagedPosDisplayDetails;
  adminCreatePackagedProduct: PackagedProduct;
  adminCreatePackagedShowcaseDetail: PackagedShowcaseDetails;
  adminCreatePackagedTapColumnDetail: PackagedTapColumnDetails;
  adminCreateProduct: Product;
  adminCreateProductAccompaniment: ProductAccompaniment;
  adminCreateProposalTheme: ProposalTheme;
  adminCreateReleaseNote: ReleaseNote;
  adminCreateSlide: Slide;
  adminCreateStaticSlide: StaticSlide;
  adminCreateStaticSlideType: StaticSlideTypeNew;
  adminCreateTraining: Training;
  adminCreateUser: User;
  adminDeleteAction: Action;
  adminDeleteBadge: Badge;
  adminDeleteBeerDetail: BeerDetails;
  adminDeleteBrand: Brand;
  adminDeleteCatalog: Catalog;
  adminDeleteImage: Image;
  adminDeleteLevel: Level;
  adminDeleteMedia: Media;
  adminDeleteNews: News;
  adminDeletePackagedBeerDetail: PackagedBeerDetails;
  adminDeletePackagedLampDetail: PackagedLampDetails;
  adminDeletePackagedPosDisplayDetail: PackagedPosDisplayDetails;
  adminDeletePackagedProduct: PackagedProduct;
  adminDeletePackagedShowcaseDetail: PackagedShowcaseDetails;
  adminDeletePackagedTapColumnDetail: PackagedTapColumnDetails;
  adminDeleteProduct: Product;
  adminDeleteProductAccompaniment: ProductAccompaniment;
  adminDeleteProposalTheme: ProposalTheme;
  adminDeleteReleaseNote: ReleaseNote;
  adminDeleteSlide: Slide;
  adminDeleteStaticSlide: StaticSlide;
  adminDeleteStaticSlideType: StaticSlideTypeNew;
  adminDeleteTraining: Training;
  adminDeleteUser: User;
  adminImportNotification: ImportNotificationResponse;
  adminImportPackagedProduct: Array<Scalars['String']>;
  adminRevertPrices: PriceApplyResult;
  adminUpdateAction: Action;
  adminUpdateAllCommercialNames: Scalars['Boolean'];
  adminUpdateBadge: Badge;
  adminUpdateBeerAttribute: BeerAttribute;
  adminUpdateBeerDetail: BeerDetails;
  adminUpdateBrand: Brand;
  adminUpdateCatalog: Catalog;
  adminUpdateImage: Image;
  adminUpdateLevel: Level;
  adminUpdateMedia: Media;
  adminUpdateNews: News;
  adminUpdatePackagedBeerDetail: PackagedBeerDetails;
  adminUpdatePackagedLampDetail: PackagedLampDetails;
  adminUpdatePackagedPosDisplayDetail: PackagedPosDisplayDetails;
  adminUpdatePackagedProduct: PackagedProduct;
  adminUpdatePackagedShowcaseDetail: PackagedShowcaseDetails;
  adminUpdatePackagedTapColumnDetail: PackagedTapColumnDetails;
  adminUpdateProduct: Product;
  adminUpdateProposalTheme: ProposalTheme;
  adminUpdateReleaseNote: ReleaseNote;
  adminUpdateSlide: Slide;
  adminUpdateStaticSlide: StaticSlide;
  adminUpdateStaticSlideType: StaticSlideTypeNew;
  adminUpdateTraining: Training;
  adminUpdateUser: User;
  adminUpdateUsers: BatchPayload;
  bookmarkProducts?: Maybe<Product>;
  createBrand: Brand;
  createIfNotExist: User;
  createNews: News;
  createNotBeerSlides: Array<PointOfSaleSlide>;
  createNotBeerSlidesNew: Array<DynamicSlide>;
  createPointOfSaleSlides: Array<PointOfSaleSlide>;
  createPointOfSaleVisit: Scalars['String'];
  createProductBeer: Product;
  createProposal: Proposal;
  createSherpaPointOfSale: PointOfSale;
  createShortProposal: Proposal;
  createSlide: Slide;
  createTraining: Training;
  deleteBrand: Brand;
  deleteNews: BatchPayload;
  deleteSlides: Slide;
  deleteStaticSlides: BatchPayload;
  deleteTrainings: BatchPayload;
  deleteUserProposalTemplate: UserProposalTemplate;
  generateCommercialConditions: Array<ProposalSlide>;
  generateProposalPdf: Proposal;
  hideProducts?: Maybe<Product>;
  imagesPresentation: ImagesPresentation;
  importPointOfSaleFromSherpa: PointOfSale;
  importUserRankings: ImportUserRankingResponse;
  markAllNotificationsAsRead: Scalars['Boolean'];
  markNotificationAsRead: Notification;
  pointOfSaleVolumeDetails: Scalars['String'];
  recordAction: UserActionHistory;
  removeProposalProducts: Array<ProposalAssortment>;
  saveUserProposalTemplate: UserProposalTemplate;
  updateContact: Scalars['Boolean'];
  updateManyProposals: BatchPayload;
  updateNba: Scalars['Boolean'];
  updatePointOfSaleVisit: Scalars['String'];
  updateProposal: Proposal;
  updateProposalProducts: Array<ProposalAssortment>;
  updateProposalSherpaState: Proposal;
  updateProposalSlides: Array<ProposalSlide>;
  updateSherpaPointOfSale: PointOfSale;
  updateSlide: Slide;
  updateUserPreference: UserPreference;
  upsertCommercialConditions: Array<ProposalSlide>;
  upsertSpecialOffers: Array<ProposalSlide>;
};


export type MutationAddProposalProductsArgs = {
  brandId: Scalars['Int'];
  products: Array<ProductIdAndType>;
  proposalId: Scalars['Int'];
  themeId?: InputMaybe<Scalars['Int']>;
};


export type MutationAdminApplyPricesArgs = {
  label: Scalars['String'];
  mediaId: Scalars['Int'];
  note?: InputMaybe<Scalars['String']>;
  prune?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAdminCreateActionArgs = {
  data: AdminActionCreateInput;
};


export type MutationAdminCreateBadgeArgs = {
  data: AdminBadgeCreateInput;
};


export type MutationAdminCreateBeerAttributeArgs = {
  data: AdminBeerAttributeCreateInput;
};


export type MutationAdminCreateBeerDetailArgs = {
  data: AdminBeerDetailCreateInput;
};


export type MutationAdminCreateBrandArgs = {
  data: AdminBrandCreateInput;
};


export type MutationAdminCreateCatalogArgs = {
  data: AdminCatalogCreateInput;
};


export type MutationAdminCreateImageArgs = {
  data: AdminImageCreateInput;
};


export type MutationAdminCreateLevelArgs = {
  data: AdminLevelCreateInput;
};


export type MutationAdminCreateMediaArgs = {
  data: AdminMediaCreateInput;
};


export type MutationAdminCreateNewsArgs = {
  data: AdminNewsCreateInput;
};


export type MutationAdminCreatePackagedBeerDetailArgs = {
  data: AdminPackagedBeerDetailCreateInput;
};


export type MutationAdminCreatePackagedLampDetailArgs = {
  data: AdminPackagedLampDetailsCreateInput;
};


export type MutationAdminCreatePackagedPosDisplayDetailArgs = {
  data: AdminPackagedPosDisplayDetailsCreateInput;
};


export type MutationAdminCreatePackagedProductArgs = {
  data: AdminPackagedProductCreateInput;
};


export type MutationAdminCreatePackagedShowcaseDetailArgs = {
  data: AdminPackagedShowcaseDetailsCreateInput;
};


export type MutationAdminCreatePackagedTapColumnDetailArgs = {
  data: AdminPackagedTapColumnDetailsCreateInput;
};


export type MutationAdminCreateProductArgs = {
  data: AdminProductCreateInput;
};


export type MutationAdminCreateProductAccompanimentArgs = {
  data: AdminProductAccompanimentCreateInput;
};


export type MutationAdminCreateProposalThemeArgs = {
  data: AdminProposalThemeCreateInput;
};


export type MutationAdminCreateReleaseNoteArgs = {
  data: AdminReleaseNoteCreateInput;
};


export type MutationAdminCreateSlideArgs = {
  data: AdminSlideCreateInput;
};


export type MutationAdminCreateStaticSlideArgs = {
  data: AdminStaticSlideCreateInput;
};


export type MutationAdminCreateStaticSlideTypeArgs = {
  data: AdminStaticSlideTypeCreateInput;
};


export type MutationAdminCreateTrainingArgs = {
  data: AdminTrainingCreateInput;
};


export type MutationAdminCreateUserArgs = {
  data: AdminUserCreateInput;
};


export type MutationAdminDeleteActionArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteBadgeArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteBeerDetailArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteBrandArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteCatalogArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteImageArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteLevelArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteMediaArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteNewsArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeletePackagedBeerDetailArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeletePackagedLampDetailArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeletePackagedPosDisplayDetailArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeletePackagedProductArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeletePackagedShowcaseDetailArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeletePackagedTapColumnDetailArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteProductArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteProductAccompanimentArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteProposalThemeArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteReleaseNoteArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteSlideArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteStaticSlideArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteStaticSlideTypeArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteTrainingArgs = {
  id: Scalars['Int'];
};


export type MutationAdminDeleteUserArgs = {
  id: Scalars['Int'];
};


export type MutationAdminImportNotificationArgs = {
  date?: InputMaybe<Scalars['DateTime']>;
  fileId: Scalars['Int'];
  title: Scalars['String'];
};


export type MutationAdminImportPackagedProductArgs = {
  data: AdminImportPackagedProductCreateInput;
};


export type MutationAdminRevertPricesArgs = {
  revisionId: Scalars['Int'];
};


export type MutationAdminUpdateActionArgs = {
  data: AdminActionUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateBadgeArgs = {
  data: AdminBadgeUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateBeerAttributeArgs = {
  data: AdminBeerAttributeUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateBeerDetailArgs = {
  data: AdminBeerDetailUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateBrandArgs = {
  data: AdminBrandUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateCatalogArgs = {
  data: AdminCatalogUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateImageArgs = {
  data: AdminImageUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateLevelArgs = {
  data: AdminLevelUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateMediaArgs = {
  data: AdminMediaUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateNewsArgs = {
  data: AdminNewsUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdatePackagedBeerDetailArgs = {
  data: AdminPackagedBeerDetailUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdatePackagedLampDetailArgs = {
  data: AdminPackagedLampDetailUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdatePackagedPosDisplayDetailArgs = {
  data: AdminPackagedPosDisplayDetailUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdatePackagedProductArgs = {
  data: AdminPackagedProductUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdatePackagedShowcaseDetailArgs = {
  data: AdminPackagedShowcaseDetailUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdatePackagedTapColumnDetailArgs = {
  data: AdminPackagedTapColumnDetailUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateProductArgs = {
  data: AdminProductUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateProposalThemeArgs = {
  data: AdminProposalThemeUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateReleaseNoteArgs = {
  data: AdminReleaseNoteUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateSlideArgs = {
  data: AdminSlideUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateStaticSlideArgs = {
  data: AdminStaticSlideUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateStaticSlideTypeArgs = {
  data: AdminStaticSlideTypeUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateTrainingArgs = {
  data: AdminTrainingUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateUserArgs = {
  data: AdminUserUpdateInputData;
  id: Scalars['Int'];
};


export type MutationAdminUpdateUsersArgs = {
  data: AdminUserUpdateInputData;
  where: AdminUserWhereInput;
};


export type MutationBookmarkProductsArgs = {
  data: BookmarkedProductsInput;
};


export type MutationCreateBrandArgs = {
  brand: BrandCreateInput;
};


export type MutationCreateIfNotExistArgs = {
  email: Scalars['String'];
  oktaId: Scalars['String'];
  updateOktaId?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateNewsArgs = {
  data: NewsCreateInput;
};


export type MutationCreateNotBeerSlidesArgs = {
  proposalId: Scalars['Int'];
};


export type MutationCreateNotBeerSlidesNewArgs = {
  proposalId: Scalars['Int'];
};


export type MutationCreatePointOfSaleSlidesArgs = {
  monthlyPointOfSaleVolumeCustomInput?: InputMaybe<MonthlyPointOfSaleVolumeCustomInput>;
  pointOfSaleId: Scalars['Int'];
  type?: InputMaybe<Array<PointOfSaleSlideType>>;
};


export type MutationCreatePointOfSaleVisitArgs = {
  data: PointOfSaleVisitInput;
  where: PointOfSaleUniqueInput;
};


export type MutationCreateProductBeerArgs = {
  beerDetails: BeerDetailsCreateNestedInput;
  brand: BrandConnectNestedInput;
  category?: InputMaybe<ProductCategory>;
  name: Scalars['String'];
  productCode?: InputMaybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
};


export type MutationCreateProposalArgs = {
  displayedTitle?: InputMaybe<Scalars['String']>;
  expireAt: Scalars['DateTime'];
  isShortProposal?: Scalars['Boolean'];
  pointOfSaleId?: InputMaybe<Scalars['Int']>;
  provinceNumber?: InputMaybe<Scalars['Int']>;
  sherpaExternalId?: InputMaybe<Scalars['String']>;
  themeId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};


export type MutationCreateSherpaPointOfSaleArgs = {
  data: PointOfSaleCreateInput;
};


export type MutationCreateShortProposalArgs = {
  displayedTitle?: InputMaybe<Scalars['String']>;
  isDirectBilling: Scalars['Boolean'];
  isTankDirectBilling?: InputMaybe<Scalars['Boolean']>;
  pointOfSaleId?: InputMaybe<Scalars['Int']>;
  products: Array<ShortProposalProductInput>;
  provinceNumber?: InputMaybe<Scalars['Int']>;
  specialOffers?: InputMaybe<Array<UpsertSpecialOfferInput>>;
};


export type MutationCreateSlideArgs = {
  product?: InputMaybe<ProductCreateNestedOneWithoutSlideInput>;
  slideImageId: Scalars['Int'];
  slideParts?: InputMaybe<SlidePartCreateNestedManyWithoutSlideInput>;
  status: SlideStatus;
};


export type MutationCreateTrainingArgs = {
  data: TrainingCreateInput;
};


export type MutationDeleteBrandArgs = {
  brand: BrandDeleteInput;
};


export type MutationDeleteNewsArgs = {
  where: NewsWhereInput;
};


export type MutationDeleteSlidesArgs = {
  where?: InputMaybe<SlideWhereInput>;
};


export type MutationDeleteStaticSlidesArgs = {
  where: StaticSlideWhereInput;
};


export type MutationDeleteTrainingsArgs = {
  where: TrainingWhereInput;
};


export type MutationDeleteUserProposalTemplateArgs = {
  input: DeleteUserProposalTemplateInput;
};


export type MutationGenerateCommercialConditionsArgs = {
  proposalId: Scalars['Int'];
};


export type MutationGenerateProposalPdfArgs = {
  where: WhereProposalInput;
};


export type MutationHideProductsArgs = {
  data: HiddenProductsInput;
};


export type MutationImagesPresentationArgs = {
  imageIds: Array<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};


export type MutationImportPointOfSaleFromSherpaArgs = {
  externalId: Scalars['String'];
};


export type MutationImportUserRankingsArgs = {
  fileId: Scalars['Int'];
};


export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['Float'];
};


export type MutationPointOfSaleVolumeDetailsArgs = {
  data: PointOfSaleVolumeDetailsInput;
};


export type MutationRecordActionArgs = {
  data: RecordActionInput;
};


export type MutationRemoveProposalProductsArgs = {
  products: Array<ProductIdAndType>;
  proposalId: Scalars['Int'];
};


export type MutationSaveUserProposalTemplateArgs = {
  input: SaveUserProposalTemplateInput;
};


export type MutationUpdateContactArgs = {
  data: UpdateContactInput;
};


export type MutationUpdateManyProposalsArgs = {
  data: UpdateProposalDataInput;
  where: WhereManyProposalInput;
};


export type MutationUpdateNbaArgs = {
  input: UpdateNextBestActionInput;
};


export type MutationUpdatePointOfSaleVisitArgs = {
  data: PointOfSaleVisitInput;
  externalId: Scalars['String'];
};


export type MutationUpdateProposalArgs = {
  data: UpdateProposalDataInput;
  id: Scalars['Int'];
};


export type MutationUpdateProposalProductsArgs = {
  brandId: Scalars['Int'];
  products: Array<ProductIdAndType>;
  proposalId: Scalars['Int'];
  themeId?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateProposalSherpaStateArgs = {
  proposalId: Scalars['Int'];
  state: SherpaProposalState;
};


export type MutationUpdateProposalSlidesArgs = {
  proposalId: Scalars['Int'];
  slides: Array<ProposalSlideInput>;
};


export type MutationUpdateSherpaPointOfSaleArgs = {
  data: PointOfSaleUpdateInput;
  externalId: Scalars['String'];
};


export type MutationUpdateSlideArgs = {
  slide: SlideUpdateInput;
  where: SlideWhereUniqueInput;
};


export type MutationUpdateUserPreferenceArgs = {
  updateUserPreferenceInput: UpdateUserPreferenceInput;
};


export type MutationUpsertCommercialConditionsArgs = {
  commercialConditions: Array<UpsertCommercialConditionInput>;
  customCommercialCondition?: InputMaybe<Array<CustomCommercialConditionsInput>>;
  generateSlides: Scalars['Boolean'];
  isDirectBilling: Scalars['Boolean'];
  isTankDirectBilling?: InputMaybe<Scalars['Boolean']>;
  proposalId: Scalars['Int'];
  provinceNumber?: InputMaybe<Scalars['Int']>;
  recapFields?: InputMaybe<RecapFields>;
  synthesis?: InputMaybe<SynthesisInput>;
};


export type MutationUpsertSpecialOffersArgs = {
  proposalId: Scalars['Int'];
  specialOffers: Array<UpsertSpecialOfferInput>;
};

export type News = {
  __typename?: 'News';
  content?: Maybe<Media>;
  contentId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  image: Image;
  media: Media;
  order: Scalars['Int'];
  thumbnail?: Maybe<Image>;
  thumbnailId: Scalars['Int'];
  title: Scalars['String'];
};

export type NewsCreateInput = {
  contentId: Scalars['Int'];
  description: Scalars['String'];
  thumbnailId: Scalars['Int'];
  title: Scalars['String'];
};

export type NewsOrderByWithRelationInput = {
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type NewsWhereInput = {
  id: IntFilter;
};

export type NextBestAction = {
  __typename?: 'NextBestAction';
  category: Scalars['String'];
  channel: Scalars['String'];
  id: Scalars['Float'];
};

export enum NextBestActionStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type Notification = {
  __typename?: 'Notification';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  pointOfSaleId?: Maybe<Scalars['Int']>;
  proposal?: Maybe<Proposal>;
  proposalId?: Maybe<Scalars['Int']>;
  read: Scalars['Boolean'];
  releaseNote?: Maybe<ReleaseNote>;
  releaseNoteId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type: NotificationType;
  userId: Scalars['Int'];
};

export type NotificationImport = {
  __typename?: 'NotificationImport';
  attempts: Scalars['Int'];
  date: Scalars['String'];
  id: Scalars['Int'];
  success: Scalars['Int'];
  title: Scalars['String'];
};

export type NotificationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
};

export enum NotificationType {
  BackofficeImport = 'BACKOFFICE_IMPORT',
  ProposalUpdate = 'PROPOSAL_UPDATE',
  ReleaseNote = 'RELEASE_NOTE',
  RiskOfChurn = 'RISK_OF_CHURN'
}

export type NotificationWhereInput = {
  read?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<NotificationType>;
};

export type PackagedBeerDetails = {
  __typename?: 'PackagedBeerDetails';
  container: PackagedBeerDetailsContainer;
  id: Scalars['Int'];
  packagedProductId: Scalars['Int'];
  unitsNb?: Maybe<Scalars['Int']>;
  volume: Scalars['Float'];
};

export enum PackagedBeerDetailsContainer {
  Bottle = 'BOTTLE',
  Keg = 'KEG',
  Tank = 'TANK'
}

export type PackagedBeerDetailsNullableRelationFilter = {
  is?: InputMaybe<PackagedBeerDetailsWhereInput>;
  isNot?: InputMaybe<PackagedBeerDetailsWhereInput>;
};

export type PackagedBeerDetailsWhereInput = {
  AND?: InputMaybe<Array<PackagedBeerDetailsWhereInput>>;
  NOT?: InputMaybe<Array<PackagedBeerDetailsWhereInput>>;
  OR?: InputMaybe<Array<PackagedBeerDetailsWhereInput>>;
  container?: InputMaybe<EnumPackagedBeerDetailsContainerFilter>;
  id?: InputMaybe<IntFilter>;
  packagedProduct?: InputMaybe<PackagedProductRelationFilter>;
  packagedProductId?: InputMaybe<IntFilter>;
  volume?: InputMaybe<FloatFilter>;
};

export type PackagedDetails = {
  __typename?: 'PackagedDetails';
  volume: Scalars['Float'];
};

export type PackagedDetailsUnion = PackagedBeerDetails | PackagedLampDetails | PackagedPosDisplayDetails | PackagedShowcaseDetails | PackagedTapColumnDetails;

export type PackagedLampDetails = {
  __typename?: 'PackagedLampDetails';
  consumption?: Maybe<Scalars['Float']>;
  dimensions?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  weight?: Maybe<Scalars['Int']>;
};

export type PackagedPosDisplayDetails = {
  __typename?: 'PackagedPosDisplayDetails';
  dimensions?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  units?: Maybe<Scalars['Int']>;
};

export type PackagedProduct = {
  __typename?: 'PackagedProduct';
  commercialName: Scalars['String'];
  croppedImage?: Maybe<Image>;
  croppedImageId?: Maybe<Scalars['Int']>;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  isMain: Scalars['Boolean'];
  name: Scalars['String'];
  packagedBeerDetails?: Maybe<PackagedBeerDetails>;
  packagedDetails: PackagedDetailsUnion;
  packagedLampDetails?: Maybe<PackagedLampDetails>;
  packagedPosDisplayDetails?: Maybe<PackagedPosDisplayDetails>;
  packagedProductPrice?: Maybe<PackagedProductPrice>;
  packagedShowcaseDetails?: Maybe<PackagedShowcaseDetails>;
  packagedTapColumnDetails?: Maybe<PackagedTapColumnDetails>;
  product: Product;
  productId: Scalars['Int'];
  slide?: Maybe<Slide>;
  slideId?: Maybe<Scalars['Int']>;
  staticSlideType?: Maybe<StaticSlideTypeNew>;
  staticSlideTypeId?: Maybe<Scalars['Int']>;
};


export type PackagedProductPackagedProductPriceArgs = {
  pointOfSaleId?: InputMaybe<Scalars['Float']>;
  provinceNumber?: InputMaybe<Scalars['Int']>;
};

export type PackagedProductCreateNestedManyWithoutStaticSlideTypeInput = {
  connect: Array<AdminPackagedProductWhereUniqueInput>;
};

export type PackagedProductInfo = {
  __typename?: 'PackagedProductInfo';
  name: Scalars['String'];
  packagedDetails: PackagedDetails;
};

export type PackagedProductListRelationFilterInput = {
  every?: InputMaybe<PackagedProductWhereInput>;
  none?: InputMaybe<PackagedProductWhereInput>;
  some?: InputMaybe<PackagedProductWhereInput>;
};

export type PackagedProductPrice = {
  __typename?: 'PackagedProductPrice';
  directBilling?: Maybe<Scalars['Float']>;
  greenTax?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  packagedProductId: Scalars['Int'];
  price: Scalars['Float'];
  provinceNumber?: Maybe<Scalars['Int']>;
  taxes?: Maybe<Scalars['Float']>;
};

export type PackagedProductPriceListRelationFilter = {
  every?: InputMaybe<PackagedProductPriceWhereInput>;
  none?: InputMaybe<PackagedProductPriceWhereInput>;
  some?: InputMaybe<PackagedProductPriceWhereInput>;
};

export type PackagedProductPriceWhereInput = {
  id?: InputMaybe<IntFilter>;
  packagedProductId?: InputMaybe<IntFilter>;
  price?: InputMaybe<FloatFilter>;
  provinceNumber?: InputMaybe<IntFilter>;
};

export type PackagedProductRelationFilter = {
  is?: InputMaybe<PackagedProductWhereInput>;
  isNot?: InputMaybe<PackagedProductWhereInput>;
};

export type PackagedProductUdapteNestedManyWithoutStaticSlideTypeInput = {
  connect?: InputMaybe<Array<AdminPackagedProductWhereUniqueInput>>;
  set?: InputMaybe<Array<AdminPackagedProductWhereUniqueInput>>;
};

export type PackagedProductWhereInput = {
  AND?: InputMaybe<Array<PackagedProductWhereInput>>;
  NOT?: InputMaybe<Array<PackagedProductWhereInput>>;
  OR?: InputMaybe<Array<PackagedProductWhereInput>>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isMain?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
  packagedBeerDetails?: InputMaybe<PackagedBeerDetailsNullableRelationFilter>;
  packagedProductPrice?: InputMaybe<PackagedProductPriceListRelationFilter>;
  product?: InputMaybe<ProductRelationFilter>;
  productId?: InputMaybe<IntFilter>;
  sales?: InputMaybe<SaleListRelationFilter>;
};

export type PackagedShowcaseDetails = {
  __typename?: 'PackagedShowcaseDetails';
  bottleUnits?: Maybe<Scalars['Int']>;
  canUnits?: Maybe<Scalars['Int']>;
  consumptionPerDay?: Maybe<Scalars['Float']>;
  dimensions?: Maybe<Scalars['String']>;
  format?: Maybe<PackagedShowcaseDetailsFormat>;
  id: Scalars['Int'];
  volume?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Int']>;
};

export enum PackagedShowcaseDetailsFormat {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type PackagedTapColumnDetails = {
  __typename?: 'PackagedTapColumnDetails';
  dimensions?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  isIlluminated: Scalars['Boolean'];
  tapBase?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

export type PointOfSale = {
  __typename?: 'PointOfSale';
  averagePricePerHectoliter?: Maybe<Scalars['Float']>;
  beerCompliancePercentage?: Maybe<Scalars['Float']>;
  beerLiterAnnualSalesPotential?: Maybe<Scalars['Float']>;
  beerTAM: Scalars['Float'];
  brand?: Maybe<Brand>;
  brandId: Scalars['Float'];
  childPointOfSales: Array<PointOfSale>;
  classificationType: Scalars['String'];
  clientType: ClientType;
  companyName: Scalars['String'];
  competitionVolume?: Maybe<Scalars['Float']>;
  competitorsVolume?: Maybe<Scalars['Float']>;
  contact?: Maybe<Contact>;
  contractEnding?: Maybe<Scalars['DateTime']>;
  contracts: Array<Contract>;
  email: Scalars['String'];
  externalId: Scalars['String'];
  id: Scalars['Int'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  laLiga?: Maybe<Scalars['Boolean']>;
  lastSaleDate?: Maybe<Scalars['DateTime']>;
  lastVisitDate?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Location>;
  name: Scalars['String'];
  ownerAveragePriceByHectoliters: Scalars['Float'];
  ownerExternalId: Scalars['String'];
  ownerName: Scalars['String'];
  parentPointOfSaleId?: Maybe<Scalars['Int']>;
  phone?: Maybe<Scalars['String']>;
  provinceNumber: Scalars['Float'];
  readers: Array<User>;
  rentabilibar: Scalars['Boolean'];
  sales: Array<Sale>;
  segment?: Maybe<Segment>;
  segmentType?: Maybe<SegmentType>;
  slides: Array<PointOfSaleSlide>;
  taxId: Scalars['String'];
  type: Scalars['String'];
  typeName: Scalars['String'];
  underContract: Scalars['Boolean'];
  waterCompliancePercentage?: Maybe<Scalars['Float']>;
  waterTAM: Scalars['Float'];
};

export type PointOfSaleCreateInput = {
  brandAbbreviation: Scalars['String'];
  city: Scalars['String'];
  classificationValue: Scalars['String'];
  companyName: Scalars['String'];
  email: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  street: Scalars['String'];
  taxId: Scalars['String'];
  typeValue: Scalars['String'];
};

export type PointOfSaleListRelationFilter = {
  every?: InputMaybe<PointOfSaleWhereInput>;
  none?: InputMaybe<PointOfSaleWhereInput>;
  some?: InputMaybe<PointOfSaleWhereInput>;
};

export type PointOfSaleOrderByWithRelationInput = {
  isActive?: InputMaybe<SortOrder>;
};

export type PointOfSaleSlide = {
  __typename?: 'PointOfSaleSlide';
  id: Scalars['Int'];
  order: Scalars['Int'];
  pointOfSaleId: Scalars['Int'];
  slide: Image;
  slideId: Scalars['Int'];
  type: PointOfSaleSlideType;
};

export enum PointOfSaleSlideType {
  Contract = 'CONTRACT',
  DynamicAssortment = 'DYNAMIC_ASSORTMENT',
  MonthlyVolume = 'MONTHLY_VOLUME',
  MonthlyVolumePerProduct = 'MONTHLY_VOLUME_PER_PRODUCT',
  NotBeerProducts = 'NOT_BEER_PRODUCTS'
}

export type PointOfSaleSlideTypeFilter = {
  in?: InputMaybe<Array<PointOfSaleSlideType>>;
};

export type PointOfSaleSlideWhereInput = {
  AND?: InputMaybe<Array<PointOfSaleSlideWhereInput>>;
  NOT?: InputMaybe<Array<PointOfSaleSlideWhereInput>>;
  OR?: InputMaybe<Array<PointOfSaleSlideWhereInput>>;
  id?: InputMaybe<IntFilter>;
  pointOfSaleId?: InputMaybe<StringFilter>;
  slideId?: InputMaybe<IntFilter>;
  type?: InputMaybe<Array<PointOfSaleSlideTypeFilter>>;
};

export type PointOfSaleUniqueInput = {
  id: Scalars['Int'];
};

export type PointOfSaleUpdateInput = {
  brandAbbreviation?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  classificationType?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  typeValue?: InputMaybe<Scalars['String']>;
};

export type PointOfSaleVisit = {
  __typename?: 'PointOfSaleVisit';
  companion: Scalars['Boolean'];
  contactUser?: Maybe<User>;
  contactUserExternalId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  externalId: Scalars['String'];
  mode: VisitMode;
  name: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  status: VisitStatus;
  topic: Array<VisitTopic>;
  type: VisitType;
  wholesaleContactExternalId?: Maybe<Scalars['String']>;
};

export type PointOfSaleVisitInput = {
  companion?: InputMaybe<Scalars['Boolean']>;
  contactUserExternalId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  durationInMinutes: Scalars['Int'];
  mode: VisitMode;
  startDate: Scalars['DateTime'];
  status: VisitStatus;
  topic: Array<VisitTopic>;
  type: VisitType;
  wholesaleContactExternalId?: InputMaybe<Scalars['String']>;
};

export type PointOfSaleVisitWhereInput = {
  externalId: Scalars['String'];
  startDate?: InputMaybe<DateFilter>;
};

export type PointOfSaleVolumeDetailsInput = {
  chartData: Array<ChartDataInput>;
  currentYear: Scalars['Int'];
  firstMonth: Scalars['Int'];
  growthIndicators: GrowthIndicatorsInput;
  isWater?: InputMaybe<Scalars['Boolean']>;
  lastMonth: Scalars['Int'];
  pastYear: Scalars['Int'];
  pointOfSaleId: Scalars['Int'];
  pointOfSaleName: Scalars['String'];
  unit: Scalars['String'];
};

export type PointOfSaleWhereInput = {
  AND?: InputMaybe<Array<PointOfSaleWhereInput>>;
  NOT?: InputMaybe<Array<PointOfSaleWhereInput>>;
  OR?: InputMaybe<Array<PointOfSaleWhereInput>>;
  address?: InputMaybe<StringFilter>;
  alreadyProposed?: InputMaybe<Scalars['Boolean']>;
  beerLiterAnnualSalesPotential?: InputMaybe<FloatFilter>;
  beerTAM?: InputMaybe<FloatFilter>;
  brand?: InputMaybe<BrandWhereInput>;
  brandId?: InputMaybe<IntFilter>;
  childrenPointsOfSales?: InputMaybe<PointOfSaleListRelationFilter>;
  classificationType?: InputMaybe<Scalars['String']>;
  clientType?: InputMaybe<ClientTypeFilter>;
  companyName?: InputMaybe<StringFilter>;
  coordinates?: InputMaybe<Coordinates>;
  distance?: InputMaybe<IntFilter>;
  externalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  laLiga?: InputMaybe<Scalars['Boolean']>;
  lastVisitDate?: InputMaybe<DateFilter>;
  location?: InputMaybe<LocationWhereInput>;
  name?: InputMaybe<StringFilter>;
  parentPointOfSale?: InputMaybe<PointOfSaleWhereInput>;
  parentPointOfSaleId?: InputMaybe<IntFilter>;
  remainingMonths?: InputMaybe<IntFilter>;
  rentabilibar?: InputMaybe<Scalars['Boolean']>;
  sales?: InputMaybe<SaleListRelationFilter>;
  segment?: InputMaybe<SegmentFilter>;
  segmentType?: InputMaybe<SegmentTypeFilter>;
  soldProducts?: InputMaybe<SoldProductRelationFilter>;
  taxId?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
  underContract?: InputMaybe<Scalars['Boolean']>;
  waterTAM?: InputMaybe<FloatFilter>;
};

export type PriceApplyResult = {
  __typename?: 'PriceApplyResult';
  errors: Array<Scalars['String']>;
  ok: Scalars['Boolean'];
  revision?: Maybe<PriceRevisionSummary>;
};

export type PriceChange = {
  __typename?: 'PriceChange';
  currentPrice?: Maybe<Scalars['Float']>;
  deltaPercent?: Maybe<Scalars['Float']>;
  externalId: Scalars['String'];
  kind: PriceChangeKind;
  newPrice?: Maybe<Scalars['Float']>;
  productName: Scalars['String'];
  provinceNumber: Scalars['Int'];
  unitsNb: Scalars['Int'];
};

export enum PriceChangeKind {
  Added = 'ADDED',
  Removable = 'REMOVABLE',
  Unchanged = 'UNCHANGED',
  Updated = 'UPDATED'
}

export type PriceDryRunReport = {
  __typename?: 'PriceDryRunReport';
  added: Scalars['Int'];
  changes: Array<PriceChange>;
  driftWarning?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  ok: Scalars['Boolean'];
  removable: Scalars['Int'];
  removableRows: Array<PriceChange>;
  rowsInFile: Scalars['Int'];
  unchanged: Scalars['Int'];
  unknownProducts: Array<Scalars['String']>;
  updated: Scalars['Int'];
  warnings: Array<Scalars['String']>;
};

export type PriceRevisionSummary = {
  __typename?: 'PriceRevisionSummary';
  appliedBy: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  isCurrent: Scalars['Boolean'];
  label: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  revertedFromId?: Maybe<Scalars['Int']>;
  rowCount: Scalars['Int'];
  rowsAdded: Scalars['Int'];
  rowsRemoved: Scalars['Int'];
  rowsUpdated: Scalars['Int'];
};

export type Product = {
  __typename?: 'Product';
  accompaniments: Array<Accompaniment>;
  adminKegSlideImage?: Maybe<Image>;
  augmentedRealityUrl?: Maybe<Scalars['String']>;
  beerDetailsId?: Maybe<Scalars['Int']>;
  brand: Brand;
  brandId: Scalars['Int'];
  category: ProductCategory;
  details?: Maybe<DetailsUnion>;
  id: Scalars['Int'];
  image?: Maybe<Image>;
  imageId?: Maybe<Scalars['Int']>;
  isActive: Scalars['Boolean'];
  isBookmarked: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isPriceCustomizable: Scalars['Boolean'];
  kegSlideImage?: Maybe<Image>;
  kegSlideImageId?: Maybe<Scalars['Int']>;
  lampDetailsId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  packagedProducts: Array<PackagedProduct>;
  posDisplayDetailsId?: Maybe<Scalars['Int']>;
  productCode?: Maybe<Scalars['String']>;
  productCodeV2?: Maybe<Scalars['String']>;
  shortCode?: Maybe<Scalars['String']>;
  showcaseDetailsId?: Maybe<Scalars['Int']>;
  slide?: Maybe<Slide>;
  slideId?: Maybe<Scalars['Int']>;
  tags: Array<Scalars['String']>;
  tapColumnDetailsId?: Maybe<Scalars['Int']>;
};


export type ProductPackagedProductsArgs = {
  container?: InputMaybe<PackagedBeerDetailsContainer>;
  provinceNumber?: InputMaybe<Scalars['Int']>;
};

export type ProductAccompaniment = {
  __typename?: 'ProductAccompaniment';
  accompanimentId: Scalars['Int'];
  id: Scalars['Int'];
  productId: Scalars['Int'];
};

export enum ProductCategory {
  Beer = 'BEER',
  BottleRack = 'BOTTLE_RACK',
  Custom = 'CUSTOM',
  Lamp = 'LAMP',
  PosDisplay = 'POS_DISPLAY',
  Showcase = 'SHOWCASE',
  SpecialDecoration = 'SPECIAL_DECORATION',
  TapColumn = 'TAP_COLUMN',
  Terrace = 'TERRACE',
  Water = 'WATER'
}

export type ProductCategoryFilter = {
  in?: InputMaybe<Array<ProductCategory>>;
};

export type ProductCreateNestedOneWithoutSlideInput = {
  connect?: InputMaybe<ProductWhereUniqueInput>;
};

export type ProductIdAndType = {
  /** Mandatory for products of type "BEER" */
  container?: InputMaybe<PackagedBeerDetailsContainer>;
  order?: InputMaybe<Scalars['Int']>;
  productId: Scalars['Int'];
};

export type ProductOrderByWithRelationInput = {
  category?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  productCode?: InputMaybe<SortOrder>;
  slideId?: InputMaybe<SortOrder>;
};

export type ProductRelationFilter = {
  is?: InputMaybe<ProductsWhereInput>;
  isNot?: InputMaybe<ProductsWhereInput>;
};

export type ProductWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ProductsWhereInput = {
  AND?: InputMaybe<Array<ProductsWhereInput>>;
  NOT?: InputMaybe<Array<ProductsWhereInput>>;
  OR?: InputMaybe<Array<ProductsWhereInput>>;
  category?: InputMaybe<ProductCategoryFilter>;
  id?: InputMaybe<IntFilter>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPriceCustomizable?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<StringFilter>;
  packagedProducts?: InputMaybe<PackagedProductListRelationFilterInput>;
};

export type Proposal = {
  __typename?: 'Proposal';
  brandId?: Maybe<Scalars['Int']>;
  commercialConditions?: Maybe<Array<ProposalCommercialCondition>>;
  createdAt: Scalars['DateTime'];
  customCommercialCondition?: Maybe<Array<CustomCommercialCondition>>;
  displayedTitle?: Maybe<Scalars['String']>;
  expireAt?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use firstSlideTmp instead when possible */
  firstSlide?: Maybe<StaticSlide>;
  firstSlideTmp?: Maybe<Image>;
  format: ProposalFormat;
  id: Scalars['Int'];
  isDirectBilling: Scalars['Boolean'];
  isShortProposal: Scalars['Boolean'];
  isTankDirectBilling: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  pdf?: Maybe<Media>;
  pdfId?: Maybe<Scalars['Int']>;
  pointOfSale?: Maybe<PointOfSale>;
  pointOfSaleId?: Maybe<Scalars['Int']>;
  pptx?: Maybe<Media>;
  pptxId?: Maybe<Scalars['Int']>;
  proposalAssortments?: Maybe<Array<ProposalAssortment>>;
  proposalSlides?: Maybe<Array<ProposalSlide>>;
  provinceNumber?: Maybe<Scalars['Int']>;
  sherpaExternalId?: Maybe<Scalars['String']>;
  sherpaState?: Maybe<SherpaProposalState>;
  specialOffers?: Maybe<Array<SpecialOffer>>;
  state: ProposalStates;
  synthesis?: Maybe<ProposalSynthesis>;
  themeId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['Int'];
  uuid: Scalars['String'];
};

export type ProposalAssortment = {
  __typename?: 'ProposalAssortment';
  /** Mandatory for products of type "BEER" */
  container?: Maybe<PackagedBeerDetailsContainer>;
  id: Scalars['Int'];
  order?: Maybe<Scalars['Int']>;
  productId: Scalars['Int'];
  proposalId: Scalars['Int'];
};

export type ProposalCommercialCondition = {
  __typename?: 'ProposalCommercialCondition';
  amortizationType?: Maybe<RecallType>;
  amortizationValue?: Maybe<Scalars['Float']>;
  amortizationX?: Maybe<Scalars['Int']>;
  amortizationY?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  discountType?: Maybe<DiscountType>;
  discountValue?: Maybe<Scalars['Float']>;
  freePackagedProductUnitsNb?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  packagedProduct?: Maybe<PackagedProduct>;
  packagedProductId: Scalars['Int'];
  packagedProductPrice: Scalars['Float'];
  packagedProductUnitsNb: Scalars['Int'];
  proposalId: Scalars['Int'];
  recallType?: Maybe<RecallType>;
  recallValue?: Maybe<Scalars['Float']>;
  recallX?: Maybe<Scalars['Int']>;
  recallY?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export enum ProposalFormat {
  Landscape = 'LANDSCAPE',
  Portrait = 'PORTRAIT'
}

export type ProposalSlide = {
  __typename?: 'ProposalSlide';
  id: Scalars['Int'];
  image?: Maybe<Image>;
  imageId: Scalars['Int'];
  order: Scalars['Int'];
  proposalId: Scalars['Int'];
  type: ProposalSlideType;
};

export type ProposalSlideInput = {
  imageId: Scalars['Int'];
  order: Scalars['Int'];
  staticSlideTypeId?: InputMaybe<Scalars['Int']>;
  type: ProposalSlideType;
};

export enum ProposalSlideType {
  BarPlus = 'BAR_PLUS',
  Beer = 'BEER',
  Catalog = 'CATALOG',
  CommercialConditions = 'COMMERCIAL_CONDITIONS',
  Contract = 'CONTRACT',
  DynamicAssortment = 'DYNAMIC_ASSORTMENT',
  FinancialSolutions = 'FINANCIAL_SOLUTIONS',
  MonthlyVolume = 'MONTHLY_VOLUME',
  MonthlyVolumePerProduct = 'MONTHLY_VOLUME_PER_PRODUCT',
  NotBeerProducts = 'NOT_BEER_PRODUCTS',
  Rentabilibar = 'RENTABILIBAR',
  SpecialOffer = 'SPECIAL_OFFER',
  StaticSlide = 'STATIC_SLIDE',
  Sustainability = 'SUSTAINABILITY',
  TapColumns = 'TAP_COLUMNS',
  Waters = 'WATERS'
}

export enum ProposalStates {
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Template = 'TEMPLATE'
}

export type ProposalSynthesis = {
  __typename?: 'ProposalSynthesis';
  adsFirstGuaranteePercent?: Maybe<Scalars['Float']>;
  adsFirstGuaranteeType?: Maybe<GuaranteeType>;
  adsImport?: Maybe<Scalars['Float']>;
  adsLiters?: Maybe<Scalars['Float']>;
  adsMonth?: Maybe<Scalars['Float']>;
  adsSecondGuaranteePercent?: Maybe<Scalars['Float']>;
  adsSecondGuaranteeType?: Maybe<GuaranteeType>;
  contributionOther?: Maybe<Scalars['Float']>;
  discount?: Maybe<Scalars['Float']>;
  discountOther?: Maybe<Scalars['Float']>;
  discountRappelLiters?: Maybe<Scalars['Float']>;
  discountRappelMonth?: Maybe<Scalars['Float']>;
  estimatedFreeLiters?: Maybe<Scalars['Float']>;
  estimatedLiters?: Maybe<Scalars['Float']>;
  firstGuaranteePercent?: Maybe<Scalars['Float']>;
  firstGuaranteeType?: Maybe<GuaranteeType>;
  id: Scalars['Int'];
  loanImport?: Maybe<Scalars['Float']>;
  loanLiters?: Maybe<Scalars['Float']>;
  loanLitersPerYear?: Maybe<Scalars['Float']>;
  loanMonth?: Maybe<Scalars['Float']>;
  marketingSupport?: Maybe<Scalars['Float']>;
  noChargeProducts?: Maybe<Scalars['Float']>;
  notes?: Maybe<Scalars['String']>;
  plvSupport?: Maybe<Scalars['Float']>;
  pointOfSaleSupport?: Maybe<Scalars['Float']>;
  proposalId: Scalars['Int'];
  rappel?: Maybe<Scalars['Float']>;
  rappelImport?: Maybe<Scalars['Float']>;
  rappelLiters?: Maybe<Scalars['Float']>;
  rappelMonth?: Maybe<Scalars['Float']>;
  secondGuaranteePercent?: Maybe<Scalars['Float']>;
  secondGuaranteeType?: Maybe<GuaranteeType>;
  specialDecoration?: Maybe<Scalars['Float']>;
};

export type ProposalTheme = {
  __typename?: 'ProposalTheme';
  brandId?: Maybe<Scalars['Int']>;
  firstSlideImage?: Maybe<Image>;
  firstSlideImageId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Int'];
  shortFirstSlideImage?: Maybe<Image>;
  shortFirstSlideImageId?: Maybe<Scalars['Int']>;
};

export type Province = {
  __typename?: 'Province';
  code: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type ProvinceCreateNestedManyWithoutStaticSlideTypesInput = {
  connect: Array<AdminProvinceWhereUniqueInput>;
};

export type ProvinceListRelationFilterInput = {
  every?: InputMaybe<ProvinceWhereInput>;
  none?: InputMaybe<ProvinceWhereInput>;
  some?: InputMaybe<ProvinceWhereInput>;
};

export type ProvinceUpdateNestedManyWithoutStaticSlideTypesInput = {
  connect?: InputMaybe<Array<AdminProvinceWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<AdminProvinceWhereUniqueInput>>;
  set?: InputMaybe<Array<AdminProvinceWhereUniqueInput>>;
};

export type ProvinceWhereInput = {
  AND?: InputMaybe<Array<ProvinceWhereInput>>;
  NOT?: InputMaybe<Array<ProvinceWhereInput>>;
  OR?: InputMaybe<Array<ProvinceWhereInput>>;
  code?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
};

export type Query = {
  __typename?: 'Query';
  accompaniments: Array<Accompaniment>;
  adminAccompaniments: Array<Accompaniment>;
  adminAccompanimentsCount: Scalars['Int'];
  adminAction: Action;
  adminActions: Array<Action>;
  adminActionsCount: Scalars['Int'];
  adminBadge: Badge;
  adminBadges: Array<Badge>;
  adminBadgesCount: Scalars['Int'];
  adminBeerAttributes: Array<BeerAttribute>;
  adminBeerAttributesCount: Scalars['Int'];
  adminBeerDetail: BeerDetails;
  adminBeerDetails: Array<BeerDetails>;
  adminBeerDetailsCount: Scalars['Int'];
  adminBrand: Brand;
  adminBrands: Array<Brand>;
  adminBrandsCount: Scalars['Int'];
  adminCatalog: Catalog;
  adminCatalogs: Array<Catalog>;
  adminCatalogsCount: Scalars['Int'];
  adminImage: Image;
  adminImages: Array<Image>;
  adminImagesCount: Scalars['Int'];
  adminLevel: Level;
  adminLevels: Array<Level>;
  adminLevelsCount: Scalars['Int'];
  adminMedia: Media;
  adminMedias: Array<Media>;
  adminMediasCount: Scalars['Int'];
  adminNews: News;
  adminNewss: Array<News>;
  adminNewssCount: Scalars['Int'];
  adminNotificationImport: NotificationImport;
  adminNotificationImports: Array<NotificationImport>;
  adminNotificationImportsCount: Scalars['Int'];
  adminPackagedBeerDetail: PackagedBeerDetails;
  adminPackagedLampDetail: PackagedLampDetails;
  adminPackagedPosDisplayDetail: PackagedPosDisplayDetails;
  adminPackagedProduct: PackagedProduct;
  adminPackagedProducts: Array<PackagedProduct>;
  adminPackagedProductsCount: Scalars['Int'];
  adminPackagedShowcaseDetail: PackagedShowcaseDetails;
  adminPackagedTapColumnDetail: PackagedTapColumnDetails;
  adminPriceDryRun: PriceDryRunReport;
  adminPriceRevisions: Array<PriceRevisionSummary>;
  adminProduct: Product;
  adminProductAccompaniments: Array<ProductAccompaniment>;
  adminProductAccompanimentsCount: Scalars['Int'];
  adminProducts: Array<Product>;
  adminProductsCount: Scalars['Int'];
  adminProposalTheme: ProposalTheme;
  adminProposalThemes: Array<ProposalTheme>;
  adminProposalThemesCount: Scalars['Int'];
  adminProvince: Province;
  adminProvinces: Array<Province>;
  adminProvincesCount: Scalars['Int'];
  adminReleaseNote: ReleaseNote;
  adminReleaseNotes: Array<ReleaseNote>;
  adminReleaseNotesCount: Scalars['Int'];
  adminSlide: Slide;
  adminSlides: Array<Slide>;
  adminSlidesCount: Scalars['Int'];
  adminStaticSlide: StaticSlide;
  adminStaticSlideType: StaticSlideTypeNew;
  adminStaticSlideTypes: Array<StaticSlideTypeNew>;
  adminStaticSlideTypesCount: Scalars['Int'];
  adminStaticSlides: Array<StaticSlide>;
  adminStaticSlidesCount: Scalars['Int'];
  adminTraining: Training;
  adminTrainings: Array<Training>;
  adminTrainingsCount: Scalars['Int'];
  adminUser: User;
  adminUserRanking: UserRanking;
  adminUserRankings: Array<UserRanking>;
  adminUserRankingsCount: Scalars['Int'];
  adminUsers: Array<User>;
  adminUsersCount: Scalars['Int'];
  badges: Array<Badge>;
  beerAttributes: Array<BeerAttribute>;
  brands: Array<Brand>;
  catalogs: Array<Catalog>;
  countPointOfSales: Scalars['Int'];
  getUserProposalTemplates: Array<UserProposalTemplate>;
  image: Image;
  images: Array<Image>;
  lastAcceptedSherpaConditions: Array<SherpaLastAcceptedCondition>;
  lastSalesBatchDate?: Maybe<Scalars['DateTime']>;
  level?: Maybe<Level>;
  levels: Array<Level>;
  locations: Array<Location>;
  me: User;
  media: Media;
  news: Array<News>;
  nextBestActions?: Maybe<Array<NextBestAction>>;
  notifications: Array<Notification>;
  packagedProductPrices: Array<PackagedProductPrice>;
  packagedProducts: Array<PackagedProduct>;
  pointOfSale: PointOfSale;
  pointOfSaleClassification: Array<SelectionItem>;
  pointOfSaleType: Array<SelectionItem>;
  pointOfSaleVisitWholesaleContact: Array<SelectionItem>;
  pointOfSaleVisits: Array<PointOfSaleVisit>;
  pointOfSales: Array<PointOfSale>;
  pointOfSalesSlides: Array<PointOfSaleSlide>;
  products: Array<Product>;
  proposal: Proposal;
  proposalAssortments: Array<ProposalAssortment>;
  proposalCommercialConditions: Array<ProposalCommercialCondition>;
  proposalSlides: Array<ProposalSlide>;
  proposalThemes: Array<ProposalTheme>;
  proposals: Array<Proposal>;
  proposalsCount: Scalars['Int'];
  provinces: Array<Province>;
  recommendedAssortment: Array<RecommendedPackagedProduct>;
  recommendedAssortmentBatchExecution: RecommendedAssortmentBatchExecution;
  releaseNote: ReleaseNote;
  reporting: Reporting;
  sherpaProposal?: Maybe<SherpaProposal>;
  sherpaProposalStatus?: Maybe<SherpaProposalState>;
  sherpaProposals: Array<SherpaProposalSummary>;
  slides: Array<Slide>;
  staticSlideTypes: Array<StaticSlideTypeNew>;
  staticSlides: Array<StaticSlide>;
  trainings: Array<Training>;
  unreadNotificationsCount: Scalars['Int'];
  user: User;
  userRanking?: Maybe<UserRanking>;
  userScores: Array<UserScore>;
  users: Array<User>;
  wonBadges: Array<Badge>;
  writeAllNbaToCsv: Scalars['String'];
};


export type QueryAdminAccompanimentsArgs = {
  orderBy?: InputMaybe<AdminAccompanimentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminAccompanimentsWhereInput>;
};


export type QueryAdminAccompanimentsCountArgs = {
  orderBy?: InputMaybe<AdminAccompanimentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminAccompanimentsWhereInput>;
};


export type QueryAdminActionArgs = {
  id: Scalars['Int'];
};


export type QueryAdminActionsArgs = {
  orderBy?: InputMaybe<AdminActionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminActionsWhereInput>;
};


export type QueryAdminActionsCountArgs = {
  orderBy?: InputMaybe<AdminActionOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminActionsWhereInput>;
};


export type QueryAdminBadgeArgs = {
  id: Scalars['Int'];
};


export type QueryAdminBadgesArgs = {
  orderBy?: InputMaybe<AdminBadgeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminBadgesWhereInput>;
};


export type QueryAdminBadgesCountArgs = {
  orderBy?: InputMaybe<AdminBadgeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminBadgesWhereInput>;
};


export type QueryAdminBeerAttributesArgs = {
  orderBy?: InputMaybe<AdminBeerAttributeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminBeerAttributesWhereInput>;
};


export type QueryAdminBeerAttributesCountArgs = {
  orderBy?: InputMaybe<AdminBeerAttributeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminBeerAttributesWhereInput>;
};


export type QueryAdminBeerDetailArgs = {
  id: Scalars['Int'];
};


export type QueryAdminBeerDetailsArgs = {
  orderBy?: InputMaybe<AdminBeerDetailOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminBeerDetailsWhereInput>;
};


export type QueryAdminBeerDetailsCountArgs = {
  orderBy?: InputMaybe<AdminBeerDetailOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminBeerDetailsWhereInput>;
};


export type QueryAdminBrandArgs = {
  id: Scalars['Int'];
};


export type QueryAdminBrandsArgs = {
  orderBy?: InputMaybe<AdminBrandOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminBrandsWhereInput>;
};


export type QueryAdminBrandsCountArgs = {
  orderBy?: InputMaybe<AdminBrandOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminBrandsWhereInput>;
};


export type QueryAdminCatalogArgs = {
  id: Scalars['Int'];
};


export type QueryAdminCatalogsArgs = {
  orderBy?: InputMaybe<AdminCatalogOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminCatalogsWhereInput>;
};


export type QueryAdminCatalogsCountArgs = {
  orderBy?: InputMaybe<AdminCatalogOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminCatalogsWhereInput>;
};


export type QueryAdminImageArgs = {
  id: Scalars['Int'];
};


export type QueryAdminImagesArgs = {
  orderBy?: InputMaybe<AdminImageOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminImagesWhereInput>;
};


export type QueryAdminImagesCountArgs = {
  orderBy?: InputMaybe<AdminImageOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminImagesWhereInput>;
};


export type QueryAdminLevelArgs = {
  id: Scalars['Int'];
};


export type QueryAdminLevelsArgs = {
  orderBy?: InputMaybe<AdminLevelOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminLevelsWhereInput>;
};


export type QueryAdminLevelsCountArgs = {
  orderBy?: InputMaybe<AdminLevelOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminLevelsWhereInput>;
};


export type QueryAdminMediaArgs = {
  id: Scalars['Int'];
};


export type QueryAdminMediasArgs = {
  orderBy?: InputMaybe<AdminMediaOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminMediasWhereInput>;
};


export type QueryAdminMediasCountArgs = {
  orderBy?: InputMaybe<AdminMediaOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminMediasWhereInput>;
};


export type QueryAdminNewsArgs = {
  id: Scalars['Int'];
};


export type QueryAdminNewssArgs = {
  orderBy?: InputMaybe<AdminNewsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminNewssWhereInput>;
};


export type QueryAdminNewssCountArgs = {
  orderBy?: InputMaybe<AdminNewsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminNewssWhereInput>;
};


export type QueryAdminNotificationImportArgs = {
  id: Scalars['Int'];
};


export type QueryAdminNotificationImportsArgs = {
  orderBy?: InputMaybe<AdminNotificationImportOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminNotificationImportsWhereInput>;
};


export type QueryAdminNotificationImportsCountArgs = {
  orderBy?: InputMaybe<AdminNotificationImportOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminNotificationImportsWhereInput>;
};


export type QueryAdminPackagedBeerDetailArgs = {
  id: Scalars['Int'];
};


export type QueryAdminPackagedLampDetailArgs = {
  id: Scalars['Int'];
};


export type QueryAdminPackagedPosDisplayDetailArgs = {
  id: Scalars['Int'];
};


export type QueryAdminPackagedProductArgs = {
  id: Scalars['Int'];
};


export type QueryAdminPackagedProductsArgs = {
  orderBy?: InputMaybe<AdminPackagedProductOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminPackagedProductsWhereInput>;
};


export type QueryAdminPackagedProductsCountArgs = {
  orderBy?: InputMaybe<AdminPackagedProductOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminPackagedProductsWhereInput>;
};


export type QueryAdminPackagedShowcaseDetailArgs = {
  id: Scalars['Int'];
};


export type QueryAdminPackagedTapColumnDetailArgs = {
  id: Scalars['Int'];
};


export type QueryAdminPriceDryRunArgs = {
  mediaId: Scalars['Int'];
};


export type QueryAdminPriceRevisionsArgs = {
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminProductArgs = {
  id: Scalars['Int'];
};


export type QueryAdminProductAccompanimentsArgs = {
  orderBy?: InputMaybe<AdminProductAccompanimentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProductAccompanimentsWhereInput>;
};


export type QueryAdminProductAccompanimentsCountArgs = {
  orderBy?: InputMaybe<AdminProductAccompanimentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProductAccompanimentsWhereInput>;
};


export type QueryAdminProductsArgs = {
  orderBy?: InputMaybe<AdminProductOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProductsWhereInput>;
};


export type QueryAdminProductsCountArgs = {
  orderBy?: InputMaybe<AdminProductOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProductsWhereInput>;
};


export type QueryAdminProposalThemeArgs = {
  id: Scalars['Int'];
};


export type QueryAdminProposalThemesArgs = {
  orderBy?: InputMaybe<AdminProposalThemeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProposalThemesWhereInput>;
};


export type QueryAdminProposalThemesCountArgs = {
  orderBy?: InputMaybe<AdminProposalThemeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProposalThemesWhereInput>;
};


export type QueryAdminProvinceArgs = {
  id: Scalars['Int'];
};


export type QueryAdminProvincesArgs = {
  orderBy?: InputMaybe<AdminProvinceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProvincesWhereInput>;
};


export type QueryAdminProvincesCountArgs = {
  orderBy?: InputMaybe<AdminProvinceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProvincesWhereInput>;
};


export type QueryAdminReleaseNoteArgs = {
  id: Scalars['Int'];
};


export type QueryAdminReleaseNotesArgs = {
  orderBy?: InputMaybe<AdminReleaseNoteOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminReleaseNotesWhereInput>;
};


export type QueryAdminReleaseNotesCountArgs = {
  orderBy?: InputMaybe<AdminReleaseNoteOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminReleaseNotesWhereInput>;
};


export type QueryAdminSlideArgs = {
  id: Scalars['Int'];
};


export type QueryAdminSlidesArgs = {
  orderBy?: InputMaybe<AdminSlideOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminSlidesWhereInput>;
};


export type QueryAdminSlidesCountArgs = {
  orderBy?: InputMaybe<AdminSlideOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminSlidesWhereInput>;
};


export type QueryAdminStaticSlideArgs = {
  id: Scalars['Int'];
};


export type QueryAdminStaticSlideTypeArgs = {
  id: Scalars['Int'];
};


export type QueryAdminStaticSlideTypesArgs = {
  orderBy?: InputMaybe<AdminStaticSlideTypeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminStaticSlideTypesWhereInput>;
};


export type QueryAdminStaticSlideTypesCountArgs = {
  orderBy?: InputMaybe<AdminStaticSlideTypeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminStaticSlideTypesWhereInput>;
};


export type QueryAdminStaticSlidesArgs = {
  orderBy?: InputMaybe<AdminStaticSlideOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminStaticSlidesWhereInput>;
};


export type QueryAdminStaticSlidesCountArgs = {
  orderBy?: InputMaybe<AdminStaticSlideOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminStaticSlidesWhereInput>;
};


export type QueryAdminTrainingArgs = {
  id: Scalars['Int'];
};


export type QueryAdminTrainingsArgs = {
  orderBy?: InputMaybe<AdminTrainingOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminTrainingsWhereInput>;
};


export type QueryAdminTrainingsCountArgs = {
  orderBy?: InputMaybe<AdminTrainingOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminTrainingsWhereInput>;
};


export type QueryAdminUserArgs = {
  id: Scalars['Int'];
};


export type QueryAdminUserRankingArgs = {
  id: Scalars['Int'];
};


export type QueryAdminUserRankingsArgs = {
  orderBy?: InputMaybe<AdminUserRankingOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminUserRankingsWhereInput>;
};


export type QueryAdminUserRankingsCountArgs = {
  orderBy?: InputMaybe<AdminUserRankingOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminUserRankingsWhereInput>;
};


export type QueryAdminUsersArgs = {
  orderBy?: InputMaybe<AdminUserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminUsersWhereInput>;
};


export type QueryAdminUsersCountArgs = {
  orderBy?: InputMaybe<AdminUserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminUsersWhereInput>;
};


export type QueryBadgesArgs = {
  orderBy?: InputMaybe<BadgeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BadgesWhereInput>;
};


export type QueryBrandsArgs = {
  orderBy?: InputMaybe<BrandOrderByWithRelationInput>;
  where?: InputMaybe<BrandWhereInput>;
};


export type QueryCatalogsArgs = {
  orderBy?: InputMaybe<AdminCatalogOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminCatalogsWhereInput>;
};


export type QueryCountPointOfSalesArgs = {
  isOwner?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryGetUserProposalTemplatesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryImageArgs = {
  id: Scalars['Int'];
};


export type QueryImagesArgs = {
  ids: Array<Scalars['Int']>;
};


export type QueryLastAcceptedSherpaConditionsArgs = {
  pointOfSaleId: Scalars['Int'];
};


export type QueryLevelArgs = {
  id: Scalars['Float'];
};


export type QueryLevelsArgs = {
  where?: InputMaybe<LevelWhereInput>;
};


export type QueryLocationsArgs = {
  isOwner?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryMediaArgs = {
  id: Scalars['Int'];
};


export type QueryNewsArgs = {
  orderBy?: InputMaybe<NewsOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryNextBestActionsArgs = {
  input: GetNextBestActionInput;
};


export type QueryNotificationsArgs = {
  orderBy?: InputMaybe<NotificationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryPackagedProductPricesArgs = {
  where?: InputMaybe<PackagedProductPriceWhereInput>;
};


export type QueryPackagedProductsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PackagedProductWhereInput>;
};


export type QueryPointOfSaleArgs = {
  where: PointOfSaleUniqueInput;
};


export type QueryPointOfSaleVisitWholesaleContactArgs = {
  where: PointOfSaleUniqueInput;
};


export type QueryPointOfSaleVisitsArgs = {
  where?: InputMaybe<PointOfSaleVisitWhereInput>;
};


export type QueryPointOfSalesArgs = {
  isOwner?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<PointOfSaleOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userLocation?: InputMaybe<UserLocationInput>;
  where?: InputMaybe<PointOfSaleWhereInput>;
};


export type QueryPointOfSalesSlidesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PointOfSaleSlideWhereInput>;
};


export type QueryProductsArgs = {
  orderBy?: InputMaybe<ProductOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProductsWhereInput>;
};


export type QueryProposalArgs = {
  where: WhereProposalInput;
};


export type QueryProposalAssortmentsArgs = {
  where: WhereProposalAssortmentInput;
};


export type QueryProposalCommercialConditionsArgs = {
  where: WhereProposalCommercialConditionInput;
};


export type QueryProposalSlidesArgs = {
  where: WhereProposalSlideInput;
};


export type QueryProposalThemesArgs = {
  orderBy?: InputMaybe<AdminProposalThemeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProposalThemesWhereInput>;
};


export type QueryProposalsArgs = {
  pointOfSaleId?: InputMaybe<IntFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<ProposalStates>;
  take?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<StringFilter>;
  where?: InputMaybe<WhereManyProposalInput>;
};


export type QueryProposalsCountArgs = {
  pointOfSaleId?: InputMaybe<IntFilter>;
  skip?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<ProposalStates>;
  take?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<StringFilter>;
  where?: InputMaybe<WhereManyProposalInput>;
};


export type QueryProvincesArgs = {
  orderBy?: InputMaybe<AdminProvinceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminProvincesWhereInput>;
};


export type QueryRecommendedAssortmentArgs = {
  pointOfSaleId: Scalars['Int'];
};


export type QueryReleaseNoteArgs = {
  where: ReleaseNoteWhereUniqueInput;
};


export type QuerySherpaProposalArgs = {
  sherpaExternalId: Scalars['String'];
};


export type QuerySherpaProposalStatusArgs = {
  sherpaExternalId: Scalars['String'];
};


export type QuerySherpaProposalsArgs = {
  pointOfSaleExternalId: Scalars['String'];
};


export type QuerySlidesArgs = {
  where?: InputMaybe<SlideWhereInput>;
};


export type QueryStaticSlideTypesArgs = {
  orderBy?: InputMaybe<StaticSlideTypeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StaticSlideTypeWhereInput>;
};


export type QueryStaticSlidesArgs = {
  orderBy?: InputMaybe<StaticSlideOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StaticSlideWhereInput>;
};


export type QueryTrainingsArgs = {
  orderBy?: InputMaybe<TrainingOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  auth0Id?: InputMaybe<Scalars['String']>;
  oktaId?: InputMaybe<Scalars['String']>;
};


export type QueryUserScoresArgs = {
  orderBy?: InputMaybe<UserScoreOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserScoreWhereInput>;
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<AdminUserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AdminUsersWhereInput>;
};


export type QueryWonBadgesArgs = {
  orderBy?: InputMaybe<BadgeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BadgesWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export enum QueryModeCore {
  Default = 'default',
  Insensitive = 'insensitive'
}

export enum RecallType {
  EuroPerLiterLoan = 'EURO_PER_LITER_LOAN',
  EuroPerUnitLoan = 'EURO_PER_UNIT_LOAN',
  LiterRecall = 'LITER_RECALL',
  PercentageLoan = 'PERCENTAGE_LOAN',
  PercentageRecall = 'PERCENTAGE_RECALL',
  Support = 'SUPPORT',
  UnitRecall = 'UNIT_RECALL',
  XYLoan = 'X_Y_LOAN',
  XYRecall = 'X_Y_RECALL'
}

export type RecapFields = {
  ads?: InputMaybe<ImportMonthLiters>;
  contributionOther: Scalars['Float'];
  discountOther?: InputMaybe<Scalars['Float']>;
  discountRappel?: InputMaybe<MonthLiters>;
  guarantee?: InputMaybe<GuaranteeInput>;
  loan?: InputMaybe<Loan>;
  rappel?: InputMaybe<ImportMonthLiters>;
};

export type RecommendedAssortmentBatchExecution = {
  __typename?: 'RecommendedAssortmentBatchExecution';
  date: Scalars['DateTime'];
  success: Scalars['Boolean'];
};

export type RecommendedPackagedProduct = {
  __typename?: 'RecommendedPackagedProduct';
  category?: Maybe<BeerDetailCategory>;
  highlyRecommended?: Maybe<Scalars['Boolean']>;
  originName?: Maybe<Scalars['String']>;
  packagedProduct: PackagedProduct;
  soldInLastFourMonths: Scalars['Boolean'];
  /** @deprecated Use soldInLastTwoMonth instead */
  soldInLastMonth: Scalars['Boolean'];
  /** @deprecated Use soldInLastFourMonths instead */
  soldInLastThreeMonths: Scalars['Boolean'];
  soldInLastTwoMonth: Scalars['Boolean'];
  volumePrediction?: Maybe<Scalars['Float']>;
};

export type RecordActionInput = {
  actionKey: Scalars['String'];
  pointOfSaleId?: InputMaybe<Scalars['Int']>;
};

export type ReleaseNote = {
  __typename?: 'ReleaseNote';
  content: Scalars['String'];
  id: Scalars['Int'];
  title: Scalars['String'];
  version: Scalars['String'];
};

export type ReleaseNoteWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['String']>;
};

export type Reporting = {
  __typename?: 'Reporting';
  url: Scalars['String'];
};

export enum Role {
  God = 'GOD',
  User = 'USER'
}

export type Sale = {
  __typename?: 'Sale';
  date: Scalars['DateTime'];
  id: Scalars['Int'];
  packagedProduct: PackagedProduct;
  packagedProductId: Scalars['Int'];
  pointOfSaleId: Scalars['Int'];
  unitsNb: Scalars['Int'];
};

export type SaleListRelationFilter = {
  every?: InputMaybe<SaleWhereInput>;
  none?: InputMaybe<SaleWhereInput>;
  some?: InputMaybe<SaleWhereInput>;
};

export type SaleWhereInput = {
  AND?: InputMaybe<Array<SaleWhereInput>>;
  NOT?: InputMaybe<Array<SaleWhereInput>>;
  OR?: InputMaybe<Array<SaleWhereInput>>;
  date?: InputMaybe<DateFilter>;
  id?: InputMaybe<IntFilter>;
  packagedProduct?: InputMaybe<PackagedProductRelationFilter>;
  packagedProductId?: InputMaybe<IntFilter>;
  unitsNb?: InputMaybe<IntFilter>;
};

export type SaveUserProposalTemplateInput = {
  proposalId: Scalars['Int'];
};

export enum Segment {
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  C5 = 'C5'
}

export type SegmentFilter = {
  in?: InputMaybe<Array<Segment>>;
};

export enum SegmentType {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D'
}

export type SegmentTypeFilter = {
  in?: InputMaybe<Array<SegmentType>>;
};

export type SelectionItem = {
  __typename?: 'SelectionItem';
  label: Scalars['String'];
  value: Scalars['String'];
};

export enum SherpaConditionType {
  Amortization = 'AMORTIZATION',
  Deferred = 'DEFERRED',
  Fixed = 'FIXED',
  FreeProducts = 'FREE_PRODUCTS'
}

export enum SherpaContractType {
  Advertising = 'ADVERTISING',
  AnnualRappel = 'ANNUAL_RAPPEL',
  Loan = 'LOAN'
}

export type SherpaLastAcceptedCondition = {
  __typename?: 'SherpaLastAcceptedCondition';
  conditionType: SherpaConditionType;
  discountType?: Maybe<DiscountType>;
  endDate?: Maybe<Scalars['DateTime']>;
  packagedProduct?: Maybe<PackagedProduct>;
  packagedProductExternalId: Scalars['String'];
  packagedProductPrice?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type SherpaProposal = {
  __typename?: 'SherpaProposal';
  commercialConditions: Array<SherpaProposalCommercialCondition>;
  createdAt: Scalars['DateTime'];
  employeeNumber?: Maybe<Scalars['String']>;
  expireAt?: Maybe<Scalars['DateTime']>;
  pointOfSaleExternalId: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  sherpaExternalId: Scalars['String'];
  supportSummary: SherpaProposalSupportSummary;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SherpaProposalCommercialCondition = {
  __typename?: 'SherpaProposalCommercialCondition';
  advertisingContract?: Maybe<SherpaProposalContract>;
  amortizationType?: Maybe<RecallType>;
  amortizationValue?: Maybe<Scalars['Float']>;
  amortizationX?: Maybe<Scalars['Int']>;
  amortizationY?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  contract?: Maybe<SherpaProposalContract>;
  discountType?: Maybe<DiscountType>;
  discountValue?: Maybe<Scalars['Float']>;
  freePackagedProductUnitsNb?: Maybe<Scalars['Int']>;
  isNew: Scalars['Boolean'];
  packagedProductCode: Scalars['String'];
  packagedProductPrice?: Maybe<Scalars['Float']>;
  packagedProductUnitsNb: Scalars['Int'];
  recallType?: Maybe<RecallType>;
  recallValue?: Maybe<Scalars['Float']>;
  recallX?: Maybe<Scalars['Int']>;
  recallY?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type SherpaProposalContract = {
  __typename?: 'SherpaProposalContract';
  advertisingBankGuaranteeAmount?: Maybe<Scalars['Float']>;
  advertisingPersonalGuaranteeAmount?: Maybe<Scalars['Float']>;
  contractExternalId: Scalars['String'];
  durationMonths?: Maybe<Scalars['Float']>;
  loanAmount?: Maybe<Scalars['Float']>;
  loanBankGuaranteeAmount?: Maybe<Scalars['Float']>;
  loanPersonalGuaranteeAmount?: Maybe<Scalars['Float']>;
  mortgageCoveredAmount?: Maybe<Scalars['Float']>;
  operationType?: Maybe<SherpaContractType>;
};

export enum SherpaProposalState {
  Accepted = 'ACCEPTED',
  Negotiation = 'NEGOTIATION',
  NotApproved = 'NOT_APPROVED',
  Rejected = 'REJECTED',
  ReApproved = 'RE_APPROVED'
}

export type SherpaProposalSummary = {
  __typename?: 'SherpaProposalSummary';
  createdAt: Scalars['DateTime'];
  employeeNumber?: Maybe<Scalars['String']>;
  expireAt?: Maybe<Scalars['DateTime']>;
  pointOfSaleExternalId: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  sherpaExternalId: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type SherpaProposalSupportSummary = {
  __typename?: 'SherpaProposalSupportSummary';
  marketingSupport: Scalars['Float'];
  plvSupport: Scalars['Float'];
  pointOfSaleSupport: Scalars['Float'];
  specialDecoration: Scalars['Float'];
};

export type ShortProposalProductInput = {
  commercialCondition?: InputMaybe<UpsertCommercialConditionInput>;
  format?: InputMaybe<PackagedShowcaseDetailsFormat>;
  productId: Scalars['Int'];
};

export type Slide = {
  __typename?: 'Slide';
  id: Scalars['Int'];
  image: Image;
  product?: Maybe<Product>;
  slideImage: Image;
  slideImageId: Scalars['Int'];
  slidePartChart?: Maybe<SlidePart>;
  slidePartProduct?: Maybe<SlidePart>;
  slideParts: Array<SlidePart>;
  status: SlideStatus;
};

export type SlidePart = {
  __typename?: 'SlidePart';
  backgroundColor: Scalars['String'];
  id: Scalars['ID'];
  image: Image;
  imageId: Scalars['Int'];
  slide: Slide;
  slideId: Scalars['Int'];
  slidePartType: SlidePartType;
};

export type SlidePartCreateManySlideInput = {
  backgroundColor: Scalars['String'];
  imageId: Scalars['Int'];
  slidePartType: SlidePartType;
};

export type SlidePartCreateManySlideInputEnvelope = {
  data: Array<SlidePartCreateManySlideInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SlidePartCreateNestedManyWithoutSlideInput = {
  createMany?: InputMaybe<SlidePartCreateManySlideInputEnvelope>;
};

export enum SlidePartType {
  Accompaniements = 'ACCOMPANIEMENTS',
  PolarChart = 'POLAR_CHART',
  Product = 'PRODUCT',
  StockImage = 'STOCK_IMAGE',
  Text1 = 'TEXT1',
  Text2 = 'TEXT2',
  Text3 = 'TEXT3'
}

export enum SlideStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type SlideStatusFilter = {
  in?: InputMaybe<Array<SlideStatus>>;
};

export type SlideUpdateInput = {
  product?: InputMaybe<ProductCreateNestedOneWithoutSlideInput>;
  slideImageId?: InputMaybe<Scalars['Int']>;
  slideParts?: InputMaybe<SlidePartCreateNestedManyWithoutSlideInput>;
  status?: InputMaybe<SlideStatus>;
};

export type SlideWhereInput = {
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  product?: InputMaybe<ProductsWhereInput>;
};

export type SlideWhereUniqueInput = {
  id: Scalars['Int'];
};

export type SoldProductRelationFilter = {
  every?: InputMaybe<SoldProductWhereInput>;
  none?: InputMaybe<SoldProductWhereInput>;
  some?: InputMaybe<SoldProductWhereInput>;
};

export type SoldProductWhereInput = {
  AND?: InputMaybe<Array<SoldProductWhereInput>>;
  NOT?: InputMaybe<Array<SoldProductWhereInput>>;
  OR?: InputMaybe<Array<SoldProductWhereInput>>;
  container?: InputMaybe<PackagedBeerDetailsContainer>;
  lastSaleDate?: InputMaybe<DateFilter>;
  productId?: InputMaybe<Scalars['Int']>;
  productIdNew?: InputMaybe<IntFilter>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SortOrderCore {
  Asc = 'asc',
  Desc = 'desc'
}

export type SpecialOffer = {
  __typename?: 'SpecialOffer';
  id: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  packagedProductIdX: Scalars['Int'];
  packagedProductIdY: Scalars['Int'];
  packagedProductIdZ?: Maybe<Scalars['Int']>;
  packagedProductX: PackagedProduct;
  packagedProductY: PackagedProduct;
  packagedProductZ?: Maybe<PackagedProduct>;
  proposalId: Scalars['Int'];
  type: SpecialOfferType;
  unitNbX: Scalars['Int'];
  unitNbY: Scalars['Int'];
  unitNbZ?: Maybe<Scalars['Int']>;
};

export enum SpecialOfferType {
  BuyXGetY = 'BUY_X_GET_Y',
  BuyXGetYZ = 'BUY_X_GET_Y_Z',
  BuyXYGetZ = 'BUY_X_Y_GET_Z'
}

export type StaticSlide = {
  __typename?: 'StaticSlide';
  brandId?: Maybe<Scalars['Int']>;
  enabledByDefault: Scalars['Boolean'];
  id: Scalars['Int'];
  image: Image;
  imageId: Scalars['Int'];
  order: Scalars['Int'];
  provinces?: Maybe<Array<Province>>;
  staticSlideType?: Maybe<StaticSlideTypeNew>;
  type: Scalars['String'];
  typeId: Scalars['Int'];
};

export type StaticSlideOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
};

export type StaticSlideTypeNew = {
  __typename?: 'StaticSlideTypeNew';
  editable: Scalars['Boolean'];
  id: Scalars['Int'];
  order: Scalars['Int'];
  packagedProducts?: Maybe<Array<PackagedProduct>>;
  productCategory?: Maybe<ProductCategory>;
  provinces?: Maybe<Array<Province>>;
  staticSlides: Array<StaticSlide>;
  type: Scalars['String'];
};


export type StaticSlideTypeNewStaticSlidesArgs = {
  orderBy?: InputMaybe<StaticSlideOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StaticSlideWhereInput>;
};

export type StaticSlideTypeOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type StaticSlideTypeWhereInput = {
  AND?: InputMaybe<Array<StaticSlideTypeWhereInput>>;
  NOT?: InputMaybe<Array<StaticSlideTypeWhereInput>>;
  OR?: InputMaybe<Array<StaticSlideTypeWhereInput>>;
  editable?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IntFilter>;
  packagedProducts?: InputMaybe<PackagedProductListRelationFilterInput>;
  provinces?: InputMaybe<ProvinceListRelationFilterInput>;
  type?: InputMaybe<StringFilter>;
};

export type StaticSlideWhereInput = {
  enabledByDefault?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<IntFilter>;
  order?: InputMaybe<IntFilter>;
  provinces?: InputMaybe<ProvinceListRelationFilterInput>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  mode?: InputMaybe<QueryMode>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringFilterCore = {
  contains?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  mode?: InputMaybe<QueryModeCore>;
};

export type SynthesisInput = {
  adsFirstGuaranteePercent?: InputMaybe<Scalars['Float']>;
  adsFirstGuaranteeType?: InputMaybe<GuaranteeType>;
  adsImport?: InputMaybe<Scalars['Float']>;
  adsLiters?: InputMaybe<Scalars['Float']>;
  adsMonth?: InputMaybe<Scalars['Float']>;
  adsSecondGuaranteePercent?: InputMaybe<Scalars['Float']>;
  adsSecondGuaranteeType?: InputMaybe<GuaranteeType>;
  contributionOther?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<Scalars['Float']>;
  discountOther?: InputMaybe<Scalars['Float']>;
  discountRappelLiters?: InputMaybe<Scalars['Float']>;
  discountRappelMonth?: InputMaybe<Scalars['Float']>;
  estimatedFreeLiters?: InputMaybe<Scalars['Float']>;
  estimatedLiters?: InputMaybe<Scalars['Float']>;
  firstGuaranteePercent?: InputMaybe<Scalars['Float']>;
  firstGuaranteeType?: InputMaybe<GuaranteeType>;
  loanImport?: InputMaybe<Scalars['Float']>;
  loanLiters?: InputMaybe<Scalars['Float']>;
  loanLitersPerYear?: InputMaybe<Scalars['Float']>;
  loanMonth?: InputMaybe<Scalars['Float']>;
  marketingSupport?: InputMaybe<Scalars['Float']>;
  noChargeProducts?: InputMaybe<Scalars['Float']>;
  notes?: InputMaybe<Scalars['String']>;
  plvSupport?: InputMaybe<Scalars['Float']>;
  pointOfSaleSupport?: InputMaybe<Scalars['Float']>;
  rappel?: InputMaybe<Scalars['Float']>;
  rappelImport?: InputMaybe<Scalars['Float']>;
  rappelLiters?: InputMaybe<Scalars['Float']>;
  rappelMonth?: InputMaybe<Scalars['Float']>;
  secondGuaranteePercent?: InputMaybe<Scalars['Float']>;
  secondGuaranteeType?: InputMaybe<GuaranteeType>;
  specialDecoration?: InputMaybe<Scalars['Float']>;
};

export type TagsFilterInput = {
  equals?: InputMaybe<Array<Scalars['String']>>;
  has?: InputMaybe<Scalars['String']>;
  hasEvery?: InputMaybe<Array<Scalars['String']>>;
  hasSome?: InputMaybe<Array<Scalars['String']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type Training = {
  __typename?: 'Training';
  content?: Maybe<Media>;
  contentId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  image?: Maybe<Image>;
  media: Media;
  order: Scalars['Int'];
  thumbnail?: Maybe<Image>;
  thumbnailId?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainingCreateInput = {
  contentId: Scalars['Int'];
  description: Scalars['String'];
  thumbnailId?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type TrainingOrderByWithRelationInput = {
  order?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type TrainingWhereInput = {
  id: IntFilter;
};

export type TypeAmountInput = {
  amount: Scalars['Float'];
  type?: InputMaybe<GuaranteeType>;
};

export type UpdateContactInput = {
  email?: InputMaybe<Scalars['String']>;
  externalId: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobilePhone?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateNextBestActionInput = {
  comment?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  status: NextBestActionStatus;
};

export type UpdateProposalDataInput = {
  displayedTitle?: InputMaybe<Scalars['String']>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  sherpaExternalId?: InputMaybe<Scalars['String']>;
  sherpaState?: InputMaybe<SherpaProposalState>;
  state?: InputMaybe<ProposalStates>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateUserPreferenceInput = {
  displayLitersInProposal?: InputMaybe<Scalars['Boolean']>;
  isDirectBilling?: InputMaybe<Scalars['Boolean']>;
  isTankDirectBilling?: InputMaybe<Scalars['Boolean']>;
  volumesDisplayPeriod?: InputMaybe<VolumesDisplayPeriod>;
};

export type UpsertCommercialConditionInput = {
  amortizationType?: InputMaybe<RecallType>;
  amortizationValue?: InputMaybe<Scalars['Float']>;
  amortizationX?: InputMaybe<Scalars['Int']>;
  amortizationY?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  customPrice?: InputMaybe<Scalars['Float']>;
  discountType?: InputMaybe<DiscountType>;
  discountValue?: InputMaybe<Scalars['Float']>;
  freePackagedProductUnitsNb?: InputMaybe<Scalars['Int']>;
  packagedProductId: Scalars['Int'];
  packagedProductUnitsNb: Scalars['Int'];
  recallType?: InputMaybe<RecallType>;
  recallValue?: InputMaybe<Scalars['Float']>;
  recallX?: InputMaybe<Scalars['Int']>;
  recallY?: InputMaybe<Scalars['Int']>;
  x?: InputMaybe<Scalars['Int']>;
  y?: InputMaybe<Scalars['Int']>;
};

export type UpsertSpecialOfferInput = {
  notes?: InputMaybe<Scalars['String']>;
  packagedProductIdX: Scalars['Int'];
  packagedProductIdY: Scalars['Int'];
  packagedProductIdZ?: InputMaybe<Scalars['Int']>;
  type: SpecialOfferType;
  unitNbX: Scalars['Int'];
  unitNbY: Scalars['Int'];
  unitNbZ?: InputMaybe<Scalars['Int']>;
};

export type User = {
  __typename?: 'User';
  activityArea?: Maybe<Scalars['String']>;
  auth0Id?: Maybe<Scalars['String']>;
  canManagePrices: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hasAccessToPilotFeatures: Scalars['Boolean'];
  id: Scalars['Int'];
  isActive: Scalars['Boolean'];
  kpi: Kpi;
  lastName?: Maybe<Scalars['String']>;
  managerId?: Maybe<Scalars['String']>;
  oktaId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  profilePicture?: Maybe<Scalars['String']>;
  proposalStreak: Scalars['Int'];
  role: Role;
  seesAllPointOfSales: Scalars['Boolean'];
  title: Scalars['String'];
  userCode: Scalars['String'];
  userManagerId?: Maybe<Scalars['Int']>;
  userPreference?: Maybe<UserPreference>;
  userPreferenceId: Scalars['Int'];
  userScore?: Maybe<UserScore>;
  userScoreId?: Maybe<Scalars['Int']>;
};

export type UserActionHistory = {
  __typename?: 'UserActionHistory';
  action?: Maybe<Action>;
  actionKey: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  pointOfSaleId?: Maybe<Scalars['Int']>;
  userId: Scalars['Int'];
};

export type UserBadge = {
  __typename?: 'UserBadge';
  badgeId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  currentValue: Scalars['Int'];
  id: Scalars['Int'];
  isWon: Scalars['Boolean'];
  lastWonAt?: Maybe<Scalars['DateTime']>;
  timesWon: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['Int'];
};

export type UserLocationInput = {
  distance: SortOrder;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type UserPreference = {
  __typename?: 'UserPreference';
  displayLitersInProposal: Scalars['Boolean'];
  id: Scalars['Int'];
  isDirectBilling: Scalars['Boolean'];
  isTankDirectBilling: Scalars['Boolean'];
  volumesDisplayPeriod: VolumesDisplayPeriod;
};

export type UserProposalTemplate = {
  __typename?: 'UserProposalTemplate';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  proposal: Proposal;
  proposalId: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserRanking = {
  __typename?: 'UserRanking';
  count: Scalars['Int'];
  email: Scalars['String'];
  id: Scalars['Int'];
  rank: Scalars['Int'];
  teamCount: Scalars['Int'];
  teamRank: Scalars['Int'];
  usageFrequency: Scalars['Int'];
  userId?: Maybe<Scalars['Int']>;
};

export type UserRelationFilterInput = {
  activityArea?: InputMaybe<StringFilter>;
};

export type UserRoleFilter = {
  in?: InputMaybe<Array<Role>>;
};

export type UserScore = {
  __typename?: 'UserScore';
  id: Scalars['Int'];
  totalPoints: Scalars['Int'];
  user?: Maybe<User>;
};

export type UserScoreOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  totalPoints?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserScoreWhereInput = {
  id?: InputMaybe<IntFilter>;
  totalPoints?: InputMaybe<IntFilter>;
  user?: InputMaybe<UserRelationFilterInput>;
  userId?: InputMaybe<IntFilter>;
};

export enum VisitMode {
  Phone = 'PHONE',
  Physicaly = 'PHYSICALY'
}

export enum VisitStatus {
  Executed = 'EXECUTED',
  NotRealized = 'NOT_REALIZED',
  Planned = 'PLANNED'
}

export enum VisitTopic {
  Agreements = 'AGREEMENTS',
  Bar = 'BAR',
  CensusUpdate = 'CENSUS_UPDATE',
  Courtesy = 'COURTESY',
  Dcmc = 'DCMC',
  DiscountNegotiation = 'DISCOUNT_NEGOTIATION',
  FinancialChannelInfo = 'FINANCIAL_CHANNEL_INFO',
  LaLiga = 'LA_LIGA',
  OtherIncidences = 'OTHER_INCIDENCES',
  Referencing = 'REFERENCING',
  Rentabilibar = 'RENTABILIBAR',
  RentabilibarOrders = 'RENTABILIBAR_ORDERS',
  StpActivity = 'STP_ACTIVITY',
  VoldisExpress = 'VOLDIS_EXPRESS'
}

export enum VisitType {
  ClientAttracion = 'CLIENT_ATTRACION',
  ClientDefense = 'CLIENT_DEFENSE',
  ClientDevelopment = 'CLIENT_DEVELOPMENT'
}

export enum VolumesDisplayPeriod {
  FixedYear = 'FIXED_YEAR',
  LastTwelveMonths = 'LAST_TWELVE_MONTHS'
}

export type WhereManyProposalInput = {
  AND?: InputMaybe<Array<WhereManyProposalInput>>;
  NOT?: InputMaybe<Array<WhereManyProposalInput>>;
  OR?: InputMaybe<Array<WhereManyProposalInput>>;
  id?: InputMaybe<IntFilter>;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  pointOfSale?: InputMaybe<PointOfSaleWhereInput>;
  pointOfSaleId?: InputMaybe<IntFilter>;
  sherpaExternalId?: InputMaybe<StringFilter>;
  sherpaState?: InputMaybe<SherpaProposalState>;
  state?: InputMaybe<ProposalStates>;
  title?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type WhereProposalAssortmentInput = {
  proposalId: IntFilter;
};

export type WhereProposalCommercialConditionInput = {
  proposalId: IntFilter;
};

export type WhereProposalInput = {
  id: Scalars['Int'];
};

export type WhereProposalSlideInput = {
  proposalId: IntFilter;
};

export type AccompanimentFragment = { title: string, image: ImageFragment };

export type GetProductAccompanimentQueryVariables = Exact<{
  productId: Scalars['Int'];
}>;


export type GetProductAccompanimentQuery = { products: Array<{ accompaniments: Array<AccompanimentFragment> }> };

export type GetProductsAccompanimentQueryVariables = Exact<{
  productIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetProductsAccompanimentQuery = { products: Array<{ id: number, accompaniments: Array<AccompanimentFragment> }> };

export type RecordActionMutationVariables = Exact<{
  data: RecordActionInput;
}>;


export type RecordActionMutation = { recordAction: { id: number } };

export type BadgeFragment = { id: number, englishName: string, spanishName: string, englishDescription: string, spanishDescription: string, category: BadgeCategory, targetValue: number, period?: BadgePeriod | null, image?: ImageFragment | null, userBadge?: { currentValue: number, lastWonAt?: any | null } | null };

export type GetBadgesQueryVariables = Exact<{
  where?: InputMaybe<BadgesWhereInput>;
}>;


export type GetBadgesQuery = { badges: Array<BadgeFragment> };

export type GetWonBadgesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWonBadgesQuery = { wonBadges: Array<BadgeFragment> };

export type BrandFragment = { id: number, name: string, isMainBrand: boolean, abbreviation: string, order: number, bannerImage?: ImageFragment | null, image?: ImageFragment | null };

export type BrandWithProductsFragment = { id: number, name: string, isMainBrand: boolean, abbreviation: string, order: number, products: Array<ProductFragment> };

export type MiniBrandFragment = { id: number, name: string, isMainBrand: boolean, abbreviation: string, order: number, image?: ImageFragment | null };

export type GetAllBrandsQueryVariables = Exact<{
  where?: InputMaybe<BrandWhereInput>;
}>;


export type GetAllBrandsQuery = { brands: Array<BrandFragment> };

export type GetAllMiniBrandsQueryVariables = Exact<{
  where?: InputMaybe<BrandWhereInput>;
}>;


export type GetAllMiniBrandsQuery = { brands: Array<MiniBrandFragment> };

export type GetAllBrandsWithProductsQueryVariables = Exact<{
  where?: InputMaybe<BrandWhereInput>;
}>;


export type GetAllBrandsWithProductsQuery = { brands: Array<BrandWithProductsFragment> };

export type CreateImagesPresentationMutationVariables = Exact<{
  imageIds: Array<Scalars['Int']> | Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
}>;


export type CreateImagesPresentationMutation = { imagesPresentation: { title: string, pdf?: MediaFragment | null } };

export type GetAllCatalogsQueryVariables = Exact<{
  where?: InputMaybe<AdminCatalogsWhereInput>;
}>;


export type GetAllCatalogsQuery = { catalogs: Array<{ id: number, title?: string | null, brandId?: number | null, image?: ImageFragment | null, brand?: BrandFragment | null }> };

export type SetCommercialConditionsMutationVariables = Exact<{
  proposalId: Scalars['Int'];
  isDirectBilling: Scalars['Boolean'];
  isTankDirectBilling?: InputMaybe<Scalars['Boolean']>;
  generateSlides: Scalars['Boolean'];
  commercialConditions: Array<UpsertCommercialConditionInput> | UpsertCommercialConditionInput;
  resumeFields?: InputMaybe<SynthesisInput>;
  customCommercialCondition?: InputMaybe<Array<CustomCommercialConditionsInput> | CustomCommercialConditionsInput>;
  provinceNumber?: InputMaybe<Scalars['Int']>;
}>;


export type SetCommercialConditionsMutation = { upsertCommercialConditions: Array<ProposalSlideFragment> };

export type ContactFragment = { id: number, firstName?: string | null, lastName?: string | null, phone?: string | null, mobilePhone?: string | null, email?: string | null, externalId?: string | null };

export type ContractFragment = { id: number, startDate: any, endDate: any, payedAmount: number, totalAmount: number, type?: ContractType | null };

export type BeerDetailsFragment = { id: number, description: string, graduation: number, ibu: number, category?: BeerDetailCategory | null };

export type PackagedBeerDetailsFragment = { id: number, packagedProductId: number, volume: number, container: PackagedBeerDetailsContainer, unitsNb?: number | null };

export type PackagedLampDetailsFragment = { id: number, weight?: number | null, consumption?: number | null, dimensions?: string | null };

export type PackagedPosDisplayDetailsFragment = { id: number, units?: number | null, dimensions?: string | null };

export type PackagedShowcaseDetailsFragment = { id: number, weight?: number | null, consumptionPerDay?: number | null, canUnits?: number | null, bottleUnits?: number | null, dimensions?: string | null, format?: PackagedShowcaseDetailsFormat | null, volumeCase?: number | null };

export type PackagedTapColumnDetailsFragment = { id: number, weight?: number | null, height?: number | null, isIlluminated: boolean, dimensions?: string | null, tapBase?: string | null };

export type IdNameFragment = { id: number, name: string };

export type ImageFragment = { id: number, source: MediaFragment };

export type ImageLowestFragment = { id: number, st: MediaFragment };

export type ImageLowFragment = { id: number, nhd: MediaFragment };

export type ImageHighFragment = { id: number, hd: MediaFragment };

export type KpiFragment = { averagePricePerHectoliter: number, averagePricePerHectoliterByManager: number };

export type LevelFragment = { id: number, pointsThreshold: number, spanishName: string, englishName: string, order: number };

export type GetLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLevelsQuery = { levels: Array<LevelFragment> };

export type LocationFragment = { id: number, address: string, latitude?: number | null, longitude?: number | null, pointOfSaleId: number, isBuyer: boolean };

export type GetAllLocationsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Array<PointOfSaleWhereInput> | PointOfSaleWhereInput>;
  segmentType?: InputMaybe<SegmentTypeFilter>;
  segment?: InputMaybe<SegmentFilter>;
  brandId?: InputMaybe<IntFilter>;
  rentabilibar?: InputMaybe<Scalars['Boolean']>;
  beerTAM?: InputMaybe<FloatFilter>;
  laLiga?: InputMaybe<Scalars['Boolean']>;
  underContract?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  soldProducts?: InputMaybe<SoldProductRelationFilter>;
  latitude?: InputMaybe<FloatFilter>;
  longitude?: InputMaybe<FloatFilter>;
  address?: InputMaybe<StringFilter>;
  clientType?: InputMaybe<ClientTypeFilter>;
  OR?: InputMaybe<Array<LocationWhereInput> | LocationWhereInput>;
  and?: InputMaybe<Array<PointOfSaleWhereInput> | PointOfSaleWhereInput>;
}>;


export type GetAllLocationsQuery = { locations: Array<LocationFragment> };

export type BookmarkProductsMutationVariables = Exact<{
  data: BookmarkedProductsInput;
}>;


export type BookmarkProductsMutation = { bookmarkProducts?: { id: number } | null };

export type HideProductsMutationVariables = Exact<{
  data: HiddenProductsInput;
}>;


export type HideProductsMutation = { hideProducts?: { id: number } | null };

export type MeFragment = { id: number, hasAccessToPilotFeatures: boolean, externalId: string, kpi: KpiFragment };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { me: UserFragment };

export type MediaFragment = { id: number, name: string, blobUrl: string, type: string };

export type GetMediaQueryVariables = Exact<{
  mediaId: Scalars['Int'];
}>;


export type GetMediaQuery = { media: MediaFragment };

export type UpdateNbaMutationVariables = Exact<{
  input: UpdateNextBestActionInput;
}>;


export type UpdateNbaMutation = { updateNba: boolean };

export type GetNextBestActionsQueryVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type GetNextBestActionsQuery = { nextBestActions?: Array<{ id: number, category: string, channel: string }> | null };

export type NewFragment = { id: number, order: number, title: string, description: string, createdAt: any, media: MediaFragment, image: ImageFragment, thumbnail?: ImageFragment | null };

export type GetAllNewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllNewsQuery = { news: Array<NewFragment> };

export type MarkOneNotificationAsReadMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type MarkOneNotificationAsReadMutation = { markNotificationAsRead: { id: number, read: boolean } };

export type GetAllNotificationsQueryVariables = Exact<{
  where?: InputMaybe<NotificationWhereInput>;
}>;


export type GetAllNotificationsQuery = { notifications: Array<{ id: number, createdAt: any, type: NotificationType, read: boolean, title?: string | null, content?: string | null, proposalId?: number | null, pointOfSaleId?: number | null, releaseNote?: { id: number, content: string, title: string, version: string } | null }> };

export type GetOneNotificationsQueryVariables = Exact<{
  where?: InputMaybe<NotificationWhereInput>;
}>;


export type GetOneNotificationsQuery = { notifications: Array<{ id: number, type: NotificationType, read: boolean, proposalId?: number | null, pointOfSaleId?: number | null, releaseNote?: { id: number, content: string, title: string, version: string } | null }> };

export type GetUnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationsCountQuery = { unreadNotificationsCount: number };

export type GetPackagedProductPriceQueryVariables = Exact<{
  where?: InputMaybe<PackagedProductPriceWhereInput>;
}>;


export type GetPackagedProductPriceQuery = { packagedProductPrices: Array<{ packagedProductId: number, price: number }> };

export type GetPackagedProductsQueryVariables = Exact<{
  where?: InputMaybe<PackagedProductWhereInput>;
}>;


export type GetPackagedProductsQuery = { packagedProducts: Array<{ id: number, productId: number, externalId?: string | null, product: { brandId: number }, packagedDetails: PackagedBeerDetailsFragment | {} }> };

export type GetPackagedProductMicroQueryVariables = Exact<{
  where?: InputMaybe<PackagedProductWhereInput>;
}>;


export type GetPackagedProductMicroQuery = { packagedProducts: Array<{ id: number, name: string, commercialName: string, externalId?: string | null }> };

export type AssortmentPointOfSaleFragment = { id: number, externalId: string, ownerExternalId: string, provinceNumber: number, sales: Array<SaleFragment>, brand?: BrandFragment | null };

export type PointOfSaleMiniFragment = { id: number, name: string, taxId: string, segmentType?: SegmentType | null, segment?: Segment | null, underContract: boolean, lastVisitDate?: any | null, averagePricePerHectoliter?: number | null, isActive: boolean, externalId: string, ownerExternalId: string, laLiga?: boolean | null, rentabilibar: boolean, ownerName: string, email: string, provinceNumber: number, parentPointOfSaleId?: number | null, brand?: BrandFragment | null, location?: LocationFragment | null, sales: Array<SaleMiniFragment>, contact?: ContactFragment | null, childPointOfSales: Array<{ id: number }> };

export type PointOfSaleFragment = (
  { beerLiterAnnualSalesPotential?: number | null, beerTAM: number, waterTAM: number, phone?: string | null, taxId: string, contracts: Array<ContractFragment>, sales: Array<SaleFragment> }
  & PointOfSaleMiniFragment
);

export type PointOfSaleMapFragment = { id: number, name: string, segmentType?: SegmentType | null, segment?: Segment | null, underContract: boolean, isActive: boolean, ownerExternalId: string, lastVisitDate?: any | null, parentPointOfSaleId?: number | null, brand?: BrandFragment | null, location?: LocationFragment | null, sales: Array<{ id: number }>, childPointOfSales: Array<{ id: number }> };

export type PointOfSaleOverviewFragment = { id: number, beerCompliancePercentage?: number | null, waterCompliancePercentage?: number | null, segment?: Segment | null, laLiga?: boolean | null, rentabilibar: boolean, underContract: boolean, beerLiterAnnualSalesPotential?: number | null, lastVisitDate?: any | null, externalId: string, companyName: string, typeName: string, taxId: string, ownerName: string, phone?: string | null, email: string, ownerExternalId: string, competitionVolume?: number | null, classificationType: string, lastSaleDate?: any | null, type: string, parentPointOfSaleId?: number | null, location?: LocationFragment | null, contracts: Array<ContractFragment>, brand?: MiniBrandFragment | null, contact?: ContactFragment | null, childPointOfSales: Array<{ id: number }> };

export type PointOfSaleMicroFragment = { id: number, isActive: boolean, name: string, externalId: string, ownerExternalId: string, brand?: BrandFragment | null, childPointOfSales: Array<{ id: number }> };

export type PointOfSaleVolumeFragment = { id: number, name: string, ownerExternalId: string, sales: Array<SaleVolumeFragment> };

export type PointOfSaleKpiFragment = { id: number, ownerExternalId: string, averagePricePerHectoliter?: number | null, ownerAveragePriceByHectoliters: number, contracts: Array<ContractFragment> };

export type PointOfSaleListItemFragment = { id: number, name: string, isActive: boolean, underContract: boolean, lastVisitDate?: any | null, parentPointOfSaleId?: number | null, brand?: BrandFragment | null, location?: LocationFragment | null, childPointOfSales: Array<{ id: number }> };

export type ImportPointOfSaleMutationVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type ImportPointOfSaleMutation = { importPointOfSaleFromSherpa: PointOfSaleMiniFragment };

export type UpdateSherpaPointOfSaleMutationVariables = Exact<{
  externalId: Scalars['String'];
  data: PointOfSaleUpdateInput;
}>;


export type UpdateSherpaPointOfSaleMutation = { updateSherpaPointOfSale: { externalId: string } };

export type UpdatePosMainContactMutationVariables = Exact<{
  data: UpdateContactInput;
}>;


export type UpdatePosMainContactMutation = { updateContact: boolean };

export type CreateSherpaPointOfSaleMutationVariables = Exact<{
  data: PointOfSaleCreateInput;
}>;


export type CreateSherpaPointOfSaleMutation = { createSherpaPointOfSale: PointOfSaleMiniFragment };

export type PointOfSaleVolumeDetailsMutationVariables = Exact<{
  data: PointOfSaleVolumeDetailsInput;
}>;


export type PointOfSaleVolumeDetailsMutation = { pointOfSaleVolumeDetails: string };

export type GetAllPosQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAllPosQuery = { pointOfSales: Array<PointOfSaleMiniFragment> };

export type GetPosQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPosQuery = { pointOfSales: Array<PointOfSaleFragment> };

export type GetAssortmentPointOfSaleQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetAssortmentPointOfSaleQuery = { pointOfSales: Array<AssortmentPointOfSaleFragment> };

export type GetSingleMapPosQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetSingleMapPosQuery = { pointOfSales: Array<PointOfSaleMapFragment> };

export type GetPosOverviewQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPosOverviewQuery = { pointOfSale: PointOfSaleOverviewFragment };

export type GetPosMicroQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPosMicroQuery = { pointOfSale: PointOfSaleMicroFragment };

export type GetPosVolumeQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPosVolumeQuery = { pointOfSale: PointOfSaleVolumeFragment };

export type GetPosKpiQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPosKpiQuery = { pointOfSale: PointOfSaleKpiFragment };

export type GetPosComplianceQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPosComplianceQuery = { pointOfSale: { beerCompliancePercentage?: number | null, waterCompliancePercentage?: number | null } };

export type GetPointOfSalesQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetPointOfSalesQuery = { pointOfSales: Array<PointOfSaleMiniFragment> };

export type GetPointOfSalesExternalQueryVariables = Exact<{
  externalId: Scalars['String'];
}>;


export type GetPointOfSalesExternalQuery = { pointOfSales: Array<PointOfSaleMiniFragment> };

export type GetMultiplePointOfSalesQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetMultiplePointOfSalesQuery = { pointOfSales: Array<PointOfSaleMiniFragment> };

export type GetPointOfSalesTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointOfSalesTypesQuery = { pointOfSaleType: Array<{ value: string, label: string }> };

export type GetPointOfSalesClassificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointOfSalesClassificationQuery = { pointOfSaleClassification: Array<{ value: string, label: string }> };

export type GetPointOfSaleListQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  isOwner?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Array<PointOfSaleWhereInput> | PointOfSaleWhereInput>;
  segmentType?: InputMaybe<SegmentTypeFilter>;
  segment?: InputMaybe<SegmentFilter>;
  brandId?: InputMaybe<IntFilter>;
  rentabilibar?: InputMaybe<Scalars['Boolean']>;
  beerTAM?: InputMaybe<FloatFilter>;
  laLiga?: InputMaybe<Scalars['Boolean']>;
  underContract?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  and?: InputMaybe<Array<PointOfSaleWhereInput> | PointOfSaleWhereInput>;
  soldProducts?: InputMaybe<SoldProductRelationFilter>;
  userLocation?: InputMaybe<UserLocationInput>;
  location?: InputMaybe<LocationWhereInput>;
  clientType?: InputMaybe<ClientTypeFilter>;
  lastVisitDate?: InputMaybe<DateFilter>;
}>;


export type GetPointOfSaleListQuery = { pointOfSales: Array<PointOfSaleListItemFragment> };

export type PointOfSaleSlideFragment = { id: number, pointOfSaleId: number, type: PointOfSaleSlideType, slideId: number, order: number, slide: ImageFragment };

export type PointOfSaleSlideNewFragment = { slideId: number, order: number, slide: ImageFragment };

export type ProposalSlideFragment = { id: number, proposalId: number, imageId: number, type: ProposalSlideType, image?: ImageFragment | null };

export type CreatePointOfSaleSlidesMutationVariables = Exact<{
  pointOfSaleId: Scalars['Int'];
  type?: InputMaybe<Array<PointOfSaleSlideType> | PointOfSaleSlideType>;
  monthlyFiltres?: InputMaybe<MonthlyPointOfSaleVolumeCustomInput>;
}>;


export type CreatePointOfSaleSlidesMutation = { createPointOfSaleSlides: Array<PointOfSaleSlideFragment> };

export type CreateNotBeerSlidesMutationVariables = Exact<{
  proposalId: Scalars['Int'];
}>;


export type CreateNotBeerSlidesMutation = { createNotBeerSlides: Array<PointOfSaleSlideFragment> };

export type CreateNotBeerSlidesNewMutationVariables = Exact<{
  proposalId: Scalars['Int'];
}>;


export type CreateNotBeerSlidesNewMutation = { createNotBeerSlidesNew: Array<PointOfSaleSlideNewFragment> };

export type UpdateProposalSlidesMutationVariables = Exact<{
  proposalId: Scalars['Int'];
  slides: Array<ProposalSlideInput> | ProposalSlideInput;
}>;


export type UpdateProposalSlidesMutation = { updateProposalSlides: Array<{ id: number }> };

export type AddProposalProductsMutationVariables = Exact<{
  proposalId: Scalars['Int'];
  themeId?: InputMaybe<Scalars['Int']>;
  brandId: Scalars['Int'];
  products: Array<ProductIdAndType> | ProductIdAndType;
}>;


export type AddProposalProductsMutation = { addProposalProducts?: Array<ProposalSlideFragment> | null };

export type UpdateProposalProductsMutationVariables = Exact<{
  kegBaseId: Scalars['Int'];
  themeId?: InputMaybe<Scalars['Int']>;
  proposalId: Scalars['Int'];
  products: Array<ProductIdAndType> | ProductIdAndType;
}>;


export type UpdateProposalProductsMutation = { updateProposalProducts: Array<{ id: number }> };

export type PointOfSaleVisitFragment = { externalId: string, name: string, status: VisitStatus, mode: VisitMode, type: VisitType, topic: Array<VisitTopic>, startDate?: any | null, endDate?: any | null, description?: string | null, companion: boolean, wholesaleContactExternalId?: string | null, contactUserExternalId?: string | null };

export type CreatePointOfSaleVisitMutationVariables = Exact<{
  pointOfSaleId: Scalars['Int'];
  data: PointOfSaleVisitInput;
}>;


export type CreatePointOfSaleVisitMutation = { createPointOfSaleVisit: string };

export type UpdatePointOfSaleVisitMutationVariables = Exact<{
  visitExternalId: Scalars['String'];
  data: PointOfSaleVisitInput;
}>;


export type UpdatePointOfSaleVisitMutation = { updatePointOfSaleVisit: string };

export type PointOfSaleVisitsQueryVariables = Exact<{
  externalId: Scalars['String'];
  startDate?: InputMaybe<DateFilter>;
}>;


export type PointOfSaleVisitsQuery = { pointOfSaleVisits: Array<PointOfSaleVisitFragment> };

export type PointOfSaleVisitWholesaleContactQueryVariables = Exact<{
  posId: Scalars['Int'];
}>;


export type PointOfSaleVisitWholesaleContactQuery = { pointOfSaleVisitWholesaleContact: Array<{ label: string, externalId: string }> };

export type PackagedProductWithoutProductFragment = { id: number, productId: number, externalId?: string | null, name: string, commercialName: string, imageId?: number | null, isMain: boolean, isActive: boolean, image?: ImageFragment | null, slide?: SlideFragment | null, croppedImage?: ImageFragment | null, packagedDetails: PackagedBeerDetailsFragment | PackagedLampDetailsFragment | PackagedPosDisplayDetailsFragment | PackagedShowcaseDetailsFragment | PackagedTapColumnDetailsFragment };

export type PackagedProductWithoutProductWithPriceFragment = { id: number, productId: number, externalId?: string | null, name: string, commercialName: string, imageId?: number | null, isMain: boolean, isActive: boolean, packagedProductPrice?: { price: number, provinceNumber?: number | null, directBilling?: number | null, greenTax?: number | null, taxes?: number | null } | null, image?: ImageFragment | null, slide?: SlideFragment | null, croppedImage?: ImageFragment | null, packagedDetails: PackagedBeerDetailsFragment | PackagedLampDetailsFragment | PackagedPosDisplayDetailsFragment | PackagedShowcaseDetailsFragment | PackagedTapColumnDetailsFragment };

export type PackagedProductFragment = (
  { product: ProductWithoutPackagedFragment }
  & PackagedProductWithoutProductFragment
);

export type PackagedProductBeerFragment = { id: number, name: string, commercialName: string, productId: number, isMain: boolean, isActive: boolean, product: ProductWithoutPackagedWithoutImagesWithoutBrandFragment, packagedDetails: PackagedBeerDetailsFragment | {} };

export type PackagedProductBeerWithImageFragment = { id: number, name: string, commercialName: string, productId: number, imageId?: number | null, isMain: boolean, isActive: boolean, image?: ImageFragment | null, slide?: SlideFragment | null, croppedImage?: ImageFragment | null, packagedDetails: PackagedBeerDetailsFragment | {} };

export type ProductFragment = { id: number, name: string, shortCode?: string | null, productCode?: string | null, tags: Array<string>, category: ProductCategory, isBookmarked: boolean, isHidden: boolean, isPriceCustomizable: boolean, augmentedRealityUrl?: string | null, brand: MiniBrandFragment, slide?: SlideFragment | null, kegSlideImage?: ImageFragment | null, image?: ImageFragment | null, packagedProducts: Array<PackagedProductWithoutProductFragment>, details?: BeerDetailsFragment | null };

export type ProductWithPricesFragment = { id: number, name: string, shortCode?: string | null, productCode?: string | null, tags: Array<string>, category: ProductCategory, isPriceCustomizable: boolean, brand: MiniBrandFragment, slide?: MiniSlideFragment | null, image?: ImageFragment | null, packagedProducts: Array<PackagedProductWithoutProductWithPriceFragment>, details?: BeerDetailsFragment | null };

export type PriceFragmentFragment = { packagedProducts: Array<{ packagedProductPrice?: { price: number, provinceNumber?: number | null, directBilling?: number | null, greenTax?: number | null, taxes?: number | null } | null }> };

export type ProductWithoutPackagedFragment = { id: number, name: string, shortCode?: string | null, productCode?: string | null, tags: Array<string>, category: ProductCategory, augmentedRealityUrl?: string | null, isPriceCustomizable: boolean, brand: MiniBrandFragment, slide?: SlideFragment | null, image?: ImageFragment | null, details?: BeerDetailsFragment | null };

export type ProductWithoutPackagedWithoutImagesWithoutBrandFragment = { id: number, name: string, shortCode?: string | null, productCode?: string | null, tags: Array<string>, category: ProductCategory, augmentedRealityUrl?: string | null, isPriceCustomizable: boolean, details?: BeerDetailsFragment | null };

export type ProductWithoutSlideFragment = { id: number, name: string, isPriceCustomizable: boolean, brand: MiniBrandFragment, packagedProducts: Array<PackagedProductWithoutProductFragment> };

export type MiniProductWithCategoryFragment = { id: number, name: string, category: ProductCategory, isPriceCustomizable: boolean, packagedProducts: Array<PackagedProductWithoutProductFragment> };

export type GetProductsQueryVariables = Exact<{
  where?: InputMaybe<ProductsWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetProductsQuery = { products: Array<ProductFragment> };

export type GetProductsWithPricesQueryVariables = Exact<{
  where?: InputMaybe<ProductsWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  pointOfSaleId?: InputMaybe<Scalars['Float']>;
  provinceNumber?: InputMaybe<Scalars['Int']>;
}>;


export type GetProductsWithPricesQuery = { products: Array<ProductWithPricesFragment> };

export type GetProductQueryVariables = Exact<{
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetProductQuery = { products: Array<ProductFragment> };

export type GetProductWithPriceQueryVariables = Exact<{
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  pointOfSaleId?: InputMaybe<Scalars['Float']>;
  provinceNumber?: InputMaybe<Scalars['Int']>;
}>;


export type GetProductWithPriceQuery = { products: Array<ProductWithPricesFragment> };

export type GetProductsWithPriceQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  pointOfSaleId?: InputMaybe<Scalars['Float']>;
  provinceNumber?: InputMaybe<Scalars['Int']>;
}>;


export type GetProductsWithPriceQuery = { products: Array<ProductWithPricesFragment> };

export type GetMiniProductsWithCategoryQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetMiniProductsWithCategoryQuery = { products: Array<MiniProductWithCategoryFragment> };

export type GetProductsWithoutSlidesQueryVariables = Exact<{
  where?: InputMaybe<ProductsWhereInput>;
}>;


export type GetProductsWithoutSlidesQuery = { products: Array<ProductWithoutSlideFragment> };

export type UpsertSpecialOffersMutationVariables = Exact<{
  proposalId: Scalars['Int'];
  specialOffers: Array<UpsertSpecialOfferInput> | UpsertSpecialOfferInput;
}>;


export type UpsertSpecialOffersMutation = { upsertSpecialOffers: Array<ProposalSlideFragment> };

export type ProposalFragment = { id: number, title: string, format: ProposalFormat, createdAt: any, updatedAt: any, expireAt?: any | null, brandId?: number | null, pointOfSaleId?: number | null, uuid: string, sherpaState?: SherpaProposalState | null, sherpaExternalId?: string | null, isShortProposal: boolean, isVisible: boolean, state: ProposalStates, user?: { firstName?: string | null, lastName?: string | null, profilePicture?: string | null } | null, pdf?: MediaFragment | null, proposalSlides?: Array<{ type: ProposalSlideType, image?: { hd: { blobUrl: string } } | null }> | null, firstSlideTmp?: { hd: { blobUrl: string } } | null };

export type ShortProposalFragment = { id: number, pointOfSaleId?: number | null, createdAt: any, updatedAt: any, uuid: string, sherpaState?: SherpaProposalState | null, sherpaExternalId?: string | null, isShortProposal: boolean, state: ProposalStates, pdf?: MediaFragment | null, user?: { firstName?: string | null, lastName?: string | null, profilePicture?: string | null } | null };

export type ProposalInfoFragment = { id: number, title: string, brandId?: number | null, themeId?: number | null, pointOfSaleId?: number | null, sherpaState?: SherpaProposalState | null, sherpaExternalId?: string | null, expireAt?: any | null, provinceNumber?: number | null, isShortProposal: boolean, state: ProposalStates, commercialConditions?: Array<{ freePackagedProductUnitsNb?: number | null, packagedProductId: number, discountValue?: number | null, discountType?: DiscountType | null, recallValue?: number | null, recallType?: RecallType | null, recallX?: number | null, recallY?: number | null, amortizationValue?: number | null, amortizationType?: RecallType | null, amortizationX?: number | null, amortizationY?: number | null, packagedProductPrice: number, packagedProductUnitsNb: number, x?: number | null, y?: number | null, packagedProduct?: { productId: number, product: { category: ProductCategory, isPriceCustomizable: boolean }, packagedDetails: PackagedBeerDetailsFragment | {} } | null }> | null, proposalAssortments?: Array<{ productId: number, container?: PackagedBeerDetailsContainer | null, order?: number | null }> | null, customCommercialCondition?: Array<{ proposalId: number, name: string, price: number, unitsNb: number }> | null, synthesis?: { id: number, proposalId: number, discountOther?: number | null, adsImport?: number | null, adsMonth?: number | null, adsLiters?: number | null, contributionOther?: number | null, loanImport?: number | null, loanMonth?: number | null, loanLiters?: number | null, loanLitersPerYear?: number | null, rappelImport?: number | null, rappelMonth?: number | null, rappelLiters?: number | null, discountRappelMonth?: number | null, discountRappelLiters?: number | null, firstGuaranteeType?: GuaranteeType | null, firstGuaranteePercent?: number | null, secondGuaranteeType?: GuaranteeType | null, secondGuaranteePercent?: number | null, adsFirstGuaranteeType?: GuaranteeType | null, adsFirstGuaranteePercent?: number | null, adsSecondGuaranteeType?: GuaranteeType | null, adsSecondGuaranteePercent?: number | null, rappel?: number | null, discount?: number | null, noChargeProducts?: number | null, marketingSupport?: number | null, pointOfSaleSupport?: number | null, plvSupport?: number | null, specialDecoration?: number | null, estimatedLiters?: number | null, notes?: string | null } | null, proposalSlides?: Array<{ id: number, imageId: number, type: ProposalSlideType, order: number, proposalId: number, image?: ImageFragment | null }> | null };

export type UpdateProposalMutationVariables = Exact<{
  id: Scalars['Int'];
  data: UpdateProposalDataInput;
}>;


export type UpdateProposalMutation = { updateProposal: ProposalFragment };

export type UpdateManyProposalsMutationVariables = Exact<{
  where: WhereManyProposalInput;
  data: UpdateProposalDataInput;
}>;


export type UpdateManyProposalsMutation = { updateManyProposals: { count: number } };

export type GetAllProposalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProposalsQuery = { proposals: Array<ProposalFragment> };

export type GetMeProposalsQueryVariables = Exact<{
  state?: InputMaybe<ProposalStates>;
}>;


export type GetMeProposalsQuery = { proposals: Array<ProposalFragment> };

export type GetPosProposalsQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WhereManyProposalInput>;
}>;


export type GetPosProposalsQuery = { proposals: Array<ProposalFragment> };

export type GetProposalsWithSherpaQueryVariables = Exact<{
  sherpaExternalId: Scalars['String'];
}>;


export type GetProposalsWithSherpaQuery = { proposals: Array<ProposalFragment> };

export type GetProposalByIdQueryVariables = Exact<{
  where: WhereProposalInput;
}>;


export type GetProposalByIdQuery = { proposal: ProposalFragment };

export type GetPosProposalsLastQueryVariables = Exact<{
  posIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetPosProposalsLastQuery = { proposals: Array<ProposalFragment> };

export type GetProposalInformationQueryVariables = Exact<{
  proposalId: Scalars['Int'];
}>;


export type GetProposalInformationQuery = { proposal: ProposalInfoFragment };

export type GetProposalsCountQueryVariables = Exact<{
  where?: InputMaybe<WhereManyProposalInput>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetProposalsCountQuery = { proposalsCount: number };

export type CreateProposalMutationVariables = Exact<{
  title: Scalars['String'];
  pointOfSaleId?: InputMaybe<Scalars['Int']>;
  displayedTitle?: InputMaybe<Scalars['String']>;
  expireAt: Scalars['DateTime'];
  provinceNumber?: InputMaybe<Scalars['Int']>;
  isShortProposal: Scalars['Boolean'];
  sherpaExternalId?: InputMaybe<Scalars['String']>;
}>;


export type CreateProposalMutation = { createProposal: { id: number, pointOfSaleId?: number | null, createdAt: any, updatedAt: any, state: ProposalStates } };

export type CreateProposalMediasMutationVariables = Exact<{
  proposalId: Scalars['Int'];
}>;


export type CreateProposalMediasMutation = { generateProposalPdf: (
    { pdf?: MediaFragment | null, pptx?: MediaFragment | null }
    & ShortProposalFragment
  ) };

export type CreateShortProposalMutationVariables = Exact<{
  pointOfSaleId?: InputMaybe<Scalars['Int']>;
  provinceNumber?: InputMaybe<Scalars['Int']>;
  displayedTitle?: InputMaybe<Scalars['String']>;
  products: Array<ShortProposalProductInput> | ShortProposalProductInput;
  isDirectBilling: Scalars['Boolean'];
  isTankDirectBilling?: InputMaybe<Scalars['Boolean']>;
  specialOffers?: InputMaybe<Array<UpsertSpecialOfferInput> | UpsertSpecialOfferInput>;
}>;


export type CreateShortProposalMutation = { createShortProposal: ShortProposalFragment };

export type GetProposalThemeQueryVariables = Exact<{
  where?: InputMaybe<AdminProposalThemesWhereInput>;
  orderBy?: InputMaybe<AdminProposalThemeOrderByWithRelationInput>;
}>;


export type GetProposalThemeQuery = { proposalThemes: Array<{ id: number, order: number, name: string, brandId?: number | null, firstSlideImageId: number }> };

export type ProvinceFragment = { id: number, name: string, code: number };

export type GetProvincesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetProvincesQuery = { provinces: Array<ProvinceFragment> };

export type GetRecommendedAssortmentQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetRecommendedAssortmentQuery = { recommendedAssortment: Array<RecommendedPackagedProductFragment> };

export type RecommendedAssortmentBatchExecutionQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendedAssortmentBatchExecutionQuery = { recommendedAssortmentBatchExecution: { date: any } };

export type RecommendedPackagedProductFragment = { soldInLastFourMonths: boolean, highlyRecommended?: boolean | null, category?: BeerDetailCategory | null, packagedProduct: (
    { product: { brandId: number } }
    & PackagedProductBeerWithImageFragment
  ) };

export type GetReleaseNoteQueryVariables = Exact<{
  where: ReleaseNoteWhereUniqueInput;
}>;


export type GetReleaseNoteQuery = { releaseNote: { id: number, version: string, content: string, title: string } };

export type ReportingFragment = { url: string };

export type GetReportingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportingQuery = { reporting: ReportingFragment };

export type SaleMiniFragment = { packagedProductId: number, unitsNb: number, date: any };

export type SaleFragment = (
  { packagedProduct: PackagedProductFragment }
  & SaleMiniFragment
);

export type SaleVolumeFragment = (
  { packagedProduct: PackagedProductBeerFragment }
  & SaleMiniFragment
);

export type GetLastSalesBatchDateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastSalesBatchDateQuery = { lastSalesBatchDate?: any | null };

export type SherpaProposalSummaryFragment = { title?: string | null, sherpaExternalId: string, pointOfSaleExternalId: string, createdAt: any, updatedAt: any, expireAt?: any | null, employeeNumber?: string | null };

export type SherpaProposalFragment = { title?: string | null, sherpaExternalId: string, pointOfSaleExternalId: string, createdAt: any, updatedAt: any, expireAt?: any | null, employeeNumber?: string | null, reason?: string | null, supportSummary: { marketingSupport: number, pointOfSaleSupport: number, plvSupport: number, specialDecoration: number }, commercialConditions: Array<{ packagedProductCode: string, discountValue?: number | null, discountType?: DiscountType | null, amortizationValue?: number | null, amortizationType?: RecallType | null, amortizationX?: number | null, amortizationY?: number | null, recallValue?: number | null, recallType?: RecallType | null, recallX?: number | null, recallY?: number | null, packagedProductPrice?: number | null, packagedProductUnitsNb: number, x?: number | null, y?: number | null, freePackagedProductUnitsNb?: number | null, isNew: boolean, comments?: string | null, contract?: { contractExternalId: string, operationType?: SherpaContractType | null, loanAmount?: number | null, durationMonths?: number | null, mortgageCoveredAmount?: number | null, loanBankGuaranteeAmount?: number | null, loanPersonalGuaranteeAmount?: number | null, advertisingBankGuaranteeAmount?: number | null, advertisingPersonalGuaranteeAmount?: number | null } | null, advertisingContract?: { contractExternalId: string, operationType?: SherpaContractType | null, loanAmount?: number | null, durationMonths?: number | null, mortgageCoveredAmount?: number | null, loanBankGuaranteeAmount?: number | null, loanPersonalGuaranteeAmount?: number | null, advertisingBankGuaranteeAmount?: number | null, advertisingPersonalGuaranteeAmount?: number | null } | null }> };

export type SherpaConditionFragment = { packagedProductExternalId: string, conditionType: SherpaConditionType, discountType?: DiscountType | null, x?: number | null, y?: number | null, startDate?: any | null, endDate?: any | null, packagedProductPrice?: number | null, packagedProduct?: { id: number, productId: number, name: string, commercialName: string, image?: { source: { blobUrl: string } } | null, packagedDetails: { volume: number, container: PackagedBeerDetailsContainer, unitsNb?: number | null } | {}, product: { productCode?: string | null, image?: { source: { blobUrl: string } } | null } } | null };

export type UpdateProposalSherpaStateMutationVariables = Exact<{
  proposalId: Scalars['Int'];
  state: SherpaProposalState;
}>;


export type UpdateProposalSherpaStateMutation = { updateProposalSherpaState: ProposalFragment };

export type GetAllSherpaProposalsQueryVariables = Exact<{
  pointOfSaleExternalId: Scalars['String'];
}>;


export type GetAllSherpaProposalsQuery = { sherpaProposals: Array<SherpaProposalSummaryFragment> };

export type GetSherpaProposalQueryVariables = Exact<{
  sherpaExternalId: Scalars['String'];
}>;


export type GetSherpaProposalQuery = { sherpaProposal?: SherpaProposalFragment | null };

export type GetSherpaProposalStatusQueryVariables = Exact<{
  sherpaExternalId: Scalars['String'];
}>;


export type GetSherpaProposalStatusQuery = { sherpaProposalStatus?: SherpaProposalState | null };

export type GetLastAcceptedSherpaConditionsQueryVariables = Exact<{
  posId: Scalars['Int'];
}>;


export type GetLastAcceptedSherpaConditionsQuery = { lastAcceptedSherpaConditions: Array<SherpaConditionFragment> };

export type SlideFragment = { id: number, slideImageId: number, status: SlideStatus, image: (
    ImageFragment
    & ImageLowFragment
  ), slideParts: Array<{ id: string, slidePartType: SlidePartType, backgroundColor: string, slideId: number, image: (
      ImageFragment
      & ImageLowFragment
    ) }> };

export type MiniSlideFragment = { id: number, slideImageId: number, image: ImageLowFragment };

export type GetAllSlidesQueryVariables = Exact<{
  where?: InputMaybe<SlideWhereInput>;
}>;


export type GetAllSlidesQuery = { slides: Array<SlideFragment> };

export type GetStaticSlidesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStaticSlidesQuery = { staticSlides: Array<{ id: number, type: string, order: number, imageId: number, image: ImageFragment }> };

export type GetStaticSlideTypesQueryVariables = Exact<{
  where?: InputMaybe<StaticSlideTypeWhereInput>;
  whereSlides?: InputMaybe<StaticSlideWhereInput>;
  orderBy?: InputMaybe<StaticSlideTypeOrderByWithRelationInput>;
}>;


export type GetStaticSlideTypesQuery = { staticSlideTypes: Array<{ id: number, type: string, order: number, editable: boolean, productCategory?: ProductCategory | null, provinces?: Array<{ id: number, name: string, code: number }> | null, staticSlides: Array<{ id: number, type: string, order: number, enabledByDefault: boolean, brandId?: number | null, typeId: number, image: ImageFragment }> }> };

export type TrainingFragment = { id: number, contentId: number, order: number, title: string, description: string, createdAt: any, media: MediaFragment, image?: ImageFragment | null, thumbnail?: ImageFragment | null };

export type GetAllTrainingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTrainingQuery = { trainings: Array<TrainingFragment> };

export type UserFragment = { id: number, firstName?: string | null, lastName?: string | null, role: Role, title: string, email: string, phoneNumber?: string | null, profilePicture?: string | null, hasAccessToPilotFeatures: boolean, activityArea?: string | null, position?: number | null, proposalStreak: number, externalId: string, userScore?: { id: number, totalPoints: number } | null, userPreference?: { isDirectBilling: boolean, isTankDirectBilling: boolean, displayLitersInProposal: boolean, volumesDisplayPeriod: VolumesDisplayPeriod } | null };

export type GetAllUsersQueryVariables = Exact<{
  where?: InputMaybe<AdminUsersWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllUsersQuery = { users: Array<UserFragment> };

export type GetUserScoresQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserScoreWhereInput>;
  orderBy?: InputMaybe<UserScoreOrderByWithRelationInput>;
}>;


export type GetUserScoresQuery = { userScores: Array<{ id: number, totalPoints: number, user?: UserFragment | null }> };

export type UpdateUserPreferenceMutationVariables = Exact<{
  updateUserPreferenceInput: UpdateUserPreferenceInput;
}>;


export type UpdateUserPreferenceMutation = { updateUserPreference: { id: number } };

export const MediaFragmentDoc = gql`
    fragment media on Media {
  id
  name
  blobUrl
  type
}
    `;
export const ImageFragmentDoc = gql`
    fragment image on Image {
  id
  source {
    ...media
  }
}
    ${MediaFragmentDoc}`;
export const AccompanimentFragmentDoc = gql`
    fragment accompaniment on Accompaniment {
  title
  image {
    ...image
  }
}
    ${ImageFragmentDoc}`;
export const BadgeFragmentDoc = gql`
    fragment badge on Badge {
  id
  englishName
  spanishName
  englishDescription
  spanishDescription
  category
  targetValue
  period
  image {
    ...image
  }
  userBadge {
    currentValue
    lastWonAt
  }
}
    ${ImageFragmentDoc}`;
export const MiniBrandFragmentDoc = gql`
    fragment miniBrand on Brand {
  id
  name
  isMainBrand
  abbreviation
  order
  image {
    ...image
  }
}
    ${ImageFragmentDoc}`;
export const ImageLowFragmentDoc = gql`
    fragment imageLow on Image {
  id
  nhd {
    ...media
  }
}
    ${MediaFragmentDoc}`;
export const SlideFragmentDoc = gql`
    fragment slide on Slide {
  id
  slideImageId
  image {
    ...image
    ...imageLow
  }
  status
  slideParts {
    id
    slidePartType
    image {
      ...image
      ...imageLow
    }
    backgroundColor
    slideId
  }
}
    ${ImageFragmentDoc}
${ImageLowFragmentDoc}`;
export const PackagedBeerDetailsFragmentDoc = gql`
    fragment packagedBeerDetails on PackagedBeerDetails {
  id
  packagedProductId
  volume
  container
  unitsNb
}
    `;
export const PackagedShowcaseDetailsFragmentDoc = gql`
    fragment packagedShowcaseDetails on PackagedShowcaseDetails {
  id
  weight
  consumptionPerDay
  volumeCase: volume
  canUnits
  bottleUnits
  dimensions
  format
}
    `;
export const PackagedLampDetailsFragmentDoc = gql`
    fragment packagedLampDetails on PackagedLampDetails {
  id
  weight
  consumption
  dimensions
}
    `;
export const PackagedPosDisplayDetailsFragmentDoc = gql`
    fragment packagedPosDisplayDetails on PackagedPosDisplayDetails {
  id
  units
  dimensions
}
    `;
export const PackagedTapColumnDetailsFragmentDoc = gql`
    fragment packagedTapColumnDetails on PackagedTapColumnDetails {
  id
  weight
  height
  isIlluminated
  dimensions
  tapBase
}
    `;
export const PackagedProductWithoutProductFragmentDoc = gql`
    fragment packagedProductWithoutProduct on PackagedProduct {
  id
  productId
  externalId
  name
  commercialName
  imageId
  isMain
  isActive
  image {
    ...image
  }
  slide {
    ...slide
  }
  croppedImage {
    ...image
  }
  packagedDetails {
    ... on PackagedBeerDetails {
      ...packagedBeerDetails
    }
    ... on PackagedShowcaseDetails {
      ...packagedShowcaseDetails
    }
    ... on PackagedLampDetails {
      ...packagedLampDetails
    }
    ... on PackagedPosDisplayDetails {
      ...packagedPosDisplayDetails
    }
    ... on PackagedTapColumnDetails {
      ...packagedTapColumnDetails
    }
  }
}
    ${ImageFragmentDoc}
${SlideFragmentDoc}
${PackagedBeerDetailsFragmentDoc}
${PackagedShowcaseDetailsFragmentDoc}
${PackagedLampDetailsFragmentDoc}
${PackagedPosDisplayDetailsFragmentDoc}
${PackagedTapColumnDetailsFragmentDoc}`;
export const BeerDetailsFragmentDoc = gql`
    fragment beerDetails on BeerDetails {
  id
  description
  graduation
  ibu
  category
}
    `;
export const ProductFragmentDoc = gql`
    fragment product on Product {
  id
  name
  shortCode
  productCode
  tags
  category
  isBookmarked
  isHidden
  isPriceCustomizable
  augmentedRealityUrl
  brand {
    ...miniBrand
  }
  slide {
    ...slide
  }
  kegSlideImage {
    ...image
  }
  image {
    ...image
  }
  packagedProducts {
    ...packagedProductWithoutProduct
  }
  details {
    ... on BeerDetails {
      ...beerDetails
    }
  }
}
    ${MiniBrandFragmentDoc}
${SlideFragmentDoc}
${ImageFragmentDoc}
${PackagedProductWithoutProductFragmentDoc}
${BeerDetailsFragmentDoc}`;
export const BrandWithProductsFragmentDoc = gql`
    fragment brandWithProducts on Brand {
  id
  name
  isMainBrand
  abbreviation
  order
  products {
    ...product
  }
}
    ${ProductFragmentDoc}`;
export const IdNameFragmentDoc = gql`
    fragment idName on IdName {
  id
  name
}
    `;
export const ImageLowestFragmentDoc = gql`
    fragment imageLowest on Image {
  id
  st {
    ...media
  }
}
    ${MediaFragmentDoc}`;
export const ImageHighFragmentDoc = gql`
    fragment imageHigh on Image {
  id
  hd {
    ...media
  }
}
    ${MediaFragmentDoc}`;
export const LevelFragmentDoc = gql`
    fragment level on Level {
  id
  pointsThreshold
  spanishName
  englishName
  order
}
    `;
export const KpiFragmentDoc = gql`
    fragment kpi on KPI {
  averagePricePerHectoliter
  averagePricePerHectoliterByManager
}
    `;
export const MeFragmentDoc = gql`
    fragment me on User {
  id
  hasAccessToPilotFeatures
  externalId: userCode
  kpi {
    ...kpi
  }
}
    ${KpiFragmentDoc}`;
export const NewFragmentDoc = gql`
    fragment new on News {
  id
  order
  title
  description
  createdAt
  media {
    ...media
  }
  image {
    ...image
  }
  thumbnail {
    ...image
  }
}
    ${MediaFragmentDoc}
${ImageFragmentDoc}`;
export const SaleMiniFragmentDoc = gql`
    fragment saleMini on Sale {
  packagedProductId
  unitsNb
  date
}
    `;
export const ProductWithoutPackagedFragmentDoc = gql`
    fragment productWithoutPackaged on Product {
  id
  name
  shortCode
  productCode
  tags
  category
  augmentedRealityUrl
  isPriceCustomizable
  brand {
    ...miniBrand
  }
  slide {
    ...slide
  }
  image {
    ...image
  }
  details {
    ... on BeerDetails {
      ...beerDetails
    }
  }
}
    ${MiniBrandFragmentDoc}
${SlideFragmentDoc}
${ImageFragmentDoc}
${BeerDetailsFragmentDoc}`;
export const PackagedProductFragmentDoc = gql`
    fragment packagedProduct on PackagedProduct {
  ...packagedProductWithoutProduct
  product {
    ...productWithoutPackaged
  }
}
    ${PackagedProductWithoutProductFragmentDoc}
${ProductWithoutPackagedFragmentDoc}`;
export const SaleFragmentDoc = gql`
    fragment sale on Sale {
  ...saleMini
  packagedProduct {
    ...packagedProduct
  }
}
    ${SaleMiniFragmentDoc}
${PackagedProductFragmentDoc}`;
export const BrandFragmentDoc = gql`
    fragment brand on Brand {
  id
  name
  isMainBrand
  abbreviation
  order
  bannerImage {
    ...image
  }
  image {
    ...image
  }
}
    ${ImageFragmentDoc}`;
export const AssortmentPointOfSaleFragmentDoc = gql`
    fragment assortmentPointOfSale on PointOfSale {
  id
  sales {
    ...sale
  }
  brand {
    ...brand
  }
  externalId
  ownerExternalId
  provinceNumber
}
    ${SaleFragmentDoc}
${BrandFragmentDoc}`;
export const LocationFragmentDoc = gql`
    fragment location on Location {
  id
  address
  latitude
  longitude
  pointOfSaleId
  isBuyer
}
    `;
export const ContactFragmentDoc = gql`
    fragment contact on Contact {
  id
  firstName
  lastName
  phone
  mobilePhone
  email
  externalId
}
    `;
export const PointOfSaleMiniFragmentDoc = gql`
    fragment pointOfSaleMini on PointOfSale {
  id
  name
  brand {
    ...brand
  }
  location {
    ...location
  }
  sales {
    ...saleMini
  }
  taxId
  segmentType
  segment
  underContract
  lastVisitDate
  averagePricePerHectoliter
  isActive
  externalId
  ownerExternalId
  laLiga
  rentabilibar
  ownerName
  email
  contact {
    ...contact
  }
  provinceNumber
  parentPointOfSaleId
  childPointOfSales {
    id
  }
}
    ${BrandFragmentDoc}
${LocationFragmentDoc}
${SaleMiniFragmentDoc}
${ContactFragmentDoc}`;
export const ContractFragmentDoc = gql`
    fragment contract on Contract {
  id
  startDate
  endDate
  payedAmount
  totalAmount
  type
}
    `;
export const PointOfSaleFragmentDoc = gql`
    fragment pointOfSale on PointOfSale {
  ...pointOfSaleMini
  beerLiterAnnualSalesPotential
  beerTAM
  waterTAM
  phone
  taxId
  contracts {
    ...contract
  }
  sales {
    ...sale
  }
}
    ${PointOfSaleMiniFragmentDoc}
${ContractFragmentDoc}
${SaleFragmentDoc}`;
export const PointOfSaleMapFragmentDoc = gql`
    fragment pointOfSaleMap on PointOfSale {
  id
  name
  brand {
    ...brand
  }
  location {
    ...location
  }
  segmentType
  segment
  underContract
  isActive
  sales {
    id
  }
  ownerExternalId
  lastVisitDate
  parentPointOfSaleId
  childPointOfSales {
    id
  }
}
    ${BrandFragmentDoc}
${LocationFragmentDoc}`;
export const PointOfSaleOverviewFragmentDoc = gql`
    fragment pointOfSaleOverview on PointOfSale {
  id
  location {
    ...location
  }
  contracts {
    ...contract
  }
  brand {
    ...miniBrand
  }
  contact {
    ...contact
  }
  beerCompliancePercentage
  waterCompliancePercentage
  segment
  laLiga
  rentabilibar
  underContract
  beerLiterAnnualSalesPotential
  lastVisitDate
  externalId
  companyName
  typeName
  taxId
  ownerName
  phone
  email
  ownerExternalId
  competitionVolume
  classificationType
  lastSaleDate
  type
  parentPointOfSaleId
  childPointOfSales {
    id
  }
}
    ${LocationFragmentDoc}
${ContractFragmentDoc}
${MiniBrandFragmentDoc}
${ContactFragmentDoc}`;
export const PointOfSaleMicroFragmentDoc = gql`
    fragment pointOfSaleMicro on PointOfSale {
  id
  isActive
  name
  externalId
  ownerExternalId
  brand {
    ...brand
  }
  childPointOfSales {
    id
  }
}
    ${BrandFragmentDoc}`;
export const ProductWithoutPackagedWithoutImagesWithoutBrandFragmentDoc = gql`
    fragment productWithoutPackagedWithoutImagesWithoutBrand on Product {
  id
  name
  shortCode
  productCode
  tags
  category
  augmentedRealityUrl
  isPriceCustomizable
  details {
    ... on BeerDetails {
      ...beerDetails
    }
  }
}
    ${BeerDetailsFragmentDoc}`;
export const PackagedProductBeerFragmentDoc = gql`
    fragment packagedProductBeer on PackagedProduct {
  id
  name
  commercialName
  productId
  isMain
  isActive
  product {
    ...productWithoutPackagedWithoutImagesWithoutBrand
  }
  packagedDetails {
    ... on PackagedBeerDetails {
      ...packagedBeerDetails
    }
  }
}
    ${ProductWithoutPackagedWithoutImagesWithoutBrandFragmentDoc}
${PackagedBeerDetailsFragmentDoc}`;
export const SaleVolumeFragmentDoc = gql`
    fragment saleVolume on Sale {
  ...saleMini
  packagedProduct {
    ...packagedProductBeer
  }
}
    ${SaleMiniFragmentDoc}
${PackagedProductBeerFragmentDoc}`;
export const PointOfSaleVolumeFragmentDoc = gql`
    fragment pointOfSaleVolume on PointOfSale {
  id
  name
  ownerExternalId
  sales {
    ...saleVolume
  }
}
    ${SaleVolumeFragmentDoc}`;
export const PointOfSaleKpiFragmentDoc = gql`
    fragment pointOfSaleKPI on PointOfSale {
  id
  ownerExternalId
  contracts {
    ...contract
  }
  averagePricePerHectoliter
  ownerAveragePriceByHectoliters
}
    ${ContractFragmentDoc}`;
export const PointOfSaleListItemFragmentDoc = gql`
    fragment pointOfSaleListItem on PointOfSale {
  id
  name
  isActive
  underContract
  lastVisitDate
  parentPointOfSaleId
  brand {
    ...brand
  }
  location {
    ...location
  }
  childPointOfSales {
    id
  }
}
    ${BrandFragmentDoc}
${LocationFragmentDoc}`;
export const PointOfSaleSlideFragmentDoc = gql`
    fragment pointOfSaleSlide on PointOfSaleSlide {
  id
  pointOfSaleId
  type
  slideId
  order
  slide {
    ...image
  }
}
    ${ImageFragmentDoc}`;
export const PointOfSaleSlideNewFragmentDoc = gql`
    fragment pointOfSaleSlideNew on DynamicSlide {
  slideId
  order
  slide {
    ...image
  }
}
    ${ImageFragmentDoc}`;
export const ProposalSlideFragmentDoc = gql`
    fragment proposalSlide on ProposalSlide {
  id
  proposalId
  imageId
  type
  image {
    ...image
  }
}
    ${ImageFragmentDoc}`;
export const PointOfSaleVisitFragmentDoc = gql`
    fragment pointOfSaleVisit on PointOfSaleVisit {
  externalId
  name
  status
  mode
  type
  topic
  startDate
  endDate
  description
  companion
  wholesaleContactExternalId
  contactUserExternalId
}
    `;
export const MiniSlideFragmentDoc = gql`
    fragment miniSlide on Slide {
  id
  slideImageId
  image {
    ...imageLow
  }
}
    ${ImageLowFragmentDoc}`;
export const PackagedProductWithoutProductWithPriceFragmentDoc = gql`
    fragment packagedProductWithoutProductWithPrice on PackagedProduct {
  id
  productId
  externalId
  name
  commercialName
  imageId
  packagedProductPrice(
    pointOfSaleId: $pointOfSaleId
    provinceNumber: $provinceNumber
  ) {
    price
    provinceNumber
    directBilling
    greenTax
    taxes
  }
  isMain
  isActive
  image {
    ...image
  }
  slide {
    ...slide
  }
  croppedImage {
    ...image
  }
  packagedDetails {
    ... on PackagedBeerDetails {
      ...packagedBeerDetails
    }
    ... on PackagedShowcaseDetails {
      ...packagedShowcaseDetails
    }
    ... on PackagedLampDetails {
      ...packagedLampDetails
    }
    ... on PackagedPosDisplayDetails {
      ...packagedPosDisplayDetails
    }
    ... on PackagedTapColumnDetails {
      ...packagedTapColumnDetails
    }
  }
}
    ${ImageFragmentDoc}
${SlideFragmentDoc}
${PackagedBeerDetailsFragmentDoc}
${PackagedShowcaseDetailsFragmentDoc}
${PackagedLampDetailsFragmentDoc}
${PackagedPosDisplayDetailsFragmentDoc}
${PackagedTapColumnDetailsFragmentDoc}`;
export const ProductWithPricesFragmentDoc = gql`
    fragment productWithPrices on Product {
  id
  name
  shortCode
  productCode
  tags
  category
  isPriceCustomizable
  brand {
    ...miniBrand
  }
  slide {
    ...miniSlide
  }
  image {
    ...image
  }
  packagedProducts {
    ...packagedProductWithoutProductWithPrice
  }
  details {
    ... on BeerDetails {
      ...beerDetails
    }
  }
  shortCode
}
    ${MiniBrandFragmentDoc}
${MiniSlideFragmentDoc}
${ImageFragmentDoc}
${PackagedProductWithoutProductWithPriceFragmentDoc}
${BeerDetailsFragmentDoc}`;
export const PriceFragmentFragmentDoc = gql`
    fragment priceFragment on Product {
  packagedProducts {
    packagedProductPrice(
      pointOfSaleId: $pointOfSaleId
      provinceNumber: $provinceNumber
    ) {
      price
      provinceNumber
      directBilling
      greenTax
      taxes
    }
  }
}
    `;
export const ProductWithoutSlideFragmentDoc = gql`
    fragment productWithoutSlide on Product {
  id
  name
  isPriceCustomizable
  brand {
    ...miniBrand
  }
  packagedProducts {
    ...packagedProductWithoutProduct
  }
}
    ${MiniBrandFragmentDoc}
${PackagedProductWithoutProductFragmentDoc}`;
export const MiniProductWithCategoryFragmentDoc = gql`
    fragment miniProductWithCategory on Product {
  id
  name
  category
  isPriceCustomizable
  packagedProducts {
    ...packagedProductWithoutProduct
  }
}
    ${PackagedProductWithoutProductFragmentDoc}`;
export const ProposalFragmentDoc = gql`
    fragment proposal on Proposal {
  id
  title
  format
  createdAt
  updatedAt
  expireAt
  brandId
  pointOfSaleId
  uuid
  sherpaState
  sherpaExternalId
  isShortProposal
  isVisible
  user {
    firstName
    lastName
    profilePicture
  }
  pdf {
    ...media
  }
  state
  proposalSlides {
    type
    image {
      hd {
        blobUrl
      }
    }
  }
  firstSlideTmp {
    hd {
      blobUrl
    }
  }
}
    ${MediaFragmentDoc}`;
export const ShortProposalFragmentDoc = gql`
    fragment shortProposal on Proposal {
  id
  pointOfSaleId
  createdAt
  updatedAt
  uuid
  sherpaState
  sherpaExternalId
  isShortProposal
  pdf {
    ...media
  }
  user {
    firstName
    lastName
    profilePicture
  }
  state
}
    ${MediaFragmentDoc}`;
export const ProposalInfoFragmentDoc = gql`
    fragment proposalInfo on Proposal {
  id
  title
  brandId
  themeId
  pointOfSaleId
  sherpaState
  sherpaExternalId
  expireAt
  provinceNumber
  isShortProposal
  state
  commercialConditions {
    freePackagedProductUnitsNb
    packagedProductId
    discountValue
    discountType
    recallValue
    recallType
    recallX
    recallY
    amortizationValue
    amortizationType
    amortizationX
    amortizationY
    packagedProductPrice
    packagedProductUnitsNb
    x
    y
    packagedProduct {
      productId
      product {
        category
        isPriceCustomizable
      }
      packagedDetails {
        ... on PackagedBeerDetails {
          ...packagedBeerDetails
        }
      }
    }
  }
  proposalAssortments {
    productId
    container
    order
  }
  customCommercialCondition {
    proposalId
    name
    price
    unitsNb
  }
  synthesis {
    id
    proposalId
    discountOther
    adsImport
    adsMonth
    adsLiters
    contributionOther
    loanImport
    loanMonth
    loanLiters
    loanLitersPerYear
    rappelImport
    rappelMonth
    rappelLiters
    discountRappelMonth
    discountRappelLiters
    firstGuaranteeType
    firstGuaranteePercent
    secondGuaranteeType
    secondGuaranteePercent
    adsFirstGuaranteeType
    adsFirstGuaranteePercent
    adsSecondGuaranteeType
    adsSecondGuaranteePercent
    rappel
    discount
    noChargeProducts
    marketingSupport
    pointOfSaleSupport
    plvSupport
    specialDecoration
    estimatedLiters
    notes
  }
  proposalSlides {
    id
    imageId
    type
    order
    proposalId
    image {
      ...image
    }
  }
}
    ${PackagedBeerDetailsFragmentDoc}
${ImageFragmentDoc}`;
export const ProvinceFragmentDoc = gql`
    fragment province on Province {
  id
  name
  code
}
    `;
export const PackagedProductBeerWithImageFragmentDoc = gql`
    fragment packagedProductBeerWithImage on PackagedProduct {
  id
  name
  commercialName
  productId
  imageId
  isMain
  isActive
  image {
    ...image
  }
  slide {
    ...slide
  }
  croppedImage {
    ...image
  }
  packagedDetails {
    ... on PackagedBeerDetails {
      ...packagedBeerDetails
    }
  }
}
    ${ImageFragmentDoc}
${SlideFragmentDoc}
${PackagedBeerDetailsFragmentDoc}`;
export const RecommendedPackagedProductFragmentDoc = gql`
    fragment recommendedPackagedProduct on RecommendedPackagedProduct {
  soldInLastFourMonths
  highlyRecommended
  category
  packagedProduct {
    ...packagedProductBeerWithImage
    product {
      brandId
    }
  }
}
    ${PackagedProductBeerWithImageFragmentDoc}`;
export const ReportingFragmentDoc = gql`
    fragment reporting on Reporting {
  url
}
    `;
export const SherpaProposalSummaryFragmentDoc = gql`
    fragment sherpaProposalSummary on SherpaProposalSummary {
  title
  sherpaExternalId
  pointOfSaleExternalId
  createdAt
  updatedAt
  expireAt
  employeeNumber
}
    `;
export const SherpaProposalFragmentDoc = gql`
    fragment sherpaProposal on SherpaProposal {
  title
  sherpaExternalId
  pointOfSaleExternalId
  createdAt
  updatedAt
  expireAt
  employeeNumber
  reason
  supportSummary {
    marketingSupport
    pointOfSaleSupport
    plvSupport
    specialDecoration
  }
  commercialConditions {
    packagedProductCode
    discountValue
    discountType
    amortizationValue
    amortizationType
    amortizationX
    amortizationY
    recallValue
    recallType
    recallX
    recallY
    packagedProductPrice
    packagedProductUnitsNb
    x
    y
    freePackagedProductUnitsNb
    isNew
    comments
    contract {
      contractExternalId
      operationType
      loanAmount
      durationMonths
      mortgageCoveredAmount
      loanBankGuaranteeAmount
      loanPersonalGuaranteeAmount
      advertisingBankGuaranteeAmount
      advertisingPersonalGuaranteeAmount
    }
    advertisingContract {
      contractExternalId
      operationType
      loanAmount
      durationMonths
      mortgageCoveredAmount
      loanBankGuaranteeAmount
      loanPersonalGuaranteeAmount
      advertisingBankGuaranteeAmount
      advertisingPersonalGuaranteeAmount
    }
  }
}
    `;
export const SherpaConditionFragmentDoc = gql`
    fragment sherpaCondition on SherpaLastAcceptedCondition {
  packagedProductExternalId
  conditionType
  discountType
  x
  y
  startDate
  endDate
  packagedProductPrice
  packagedProduct {
    id
    productId
    name
    commercialName
    image {
      source {
        blobUrl
      }
    }
    packagedDetails {
      ... on PackagedBeerDetails {
        volume
        container
        unitsNb
      }
    }
    product {
      productCode
      image {
        source {
          blobUrl
        }
      }
    }
  }
}
    `;
export const TrainingFragmentDoc = gql`
    fragment training on Training {
  id
  contentId
  order
  title
  description
  createdAt
  media {
    ...media
  }
  image {
    ...image
  }
  thumbnail {
    ...image
  }
}
    ${MediaFragmentDoc}
${ImageFragmentDoc}`;
export const UserFragmentDoc = gql`
    fragment user on User {
  id
  firstName
  lastName
  role
  title
  email
  phoneNumber
  profilePicture
  externalId: userCode
  hasAccessToPilotFeatures
  userScore {
    id
    totalPoints
  }
  activityArea
  position
  proposalStreak
  userPreference {
    isDirectBilling
    isTankDirectBilling
    displayLitersInProposal
    volumesDisplayPeriod
  }
}
    `;
export const GetProductAccompanimentDocument = gql`
    query GetProductAccompaniment($productId: Int!) {
  products(where: {id: {in: [$productId]}}) {
    accompaniments {
      ...accompaniment
    }
  }
}
    ${AccompanimentFragmentDoc}`;

/**
 * __useGetProductAccompanimentQuery__
 *
 * To run a query within a React component, call `useGetProductAccompanimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductAccompanimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductAccompanimentQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductAccompanimentQuery(baseOptions: Apollo.QueryHookOptions<GetProductAccompanimentQuery, GetProductAccompanimentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductAccompanimentQuery, GetProductAccompanimentQueryVariables>(GetProductAccompanimentDocument, options);
      }
export function useGetProductAccompanimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductAccompanimentQuery, GetProductAccompanimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductAccompanimentQuery, GetProductAccompanimentQueryVariables>(GetProductAccompanimentDocument, options);
        }
export type GetProductAccompanimentQueryHookResult = ReturnType<typeof useGetProductAccompanimentQuery>;
export type GetProductAccompanimentLazyQueryHookResult = ReturnType<typeof useGetProductAccompanimentLazyQuery>;
export type GetProductAccompanimentQueryResult = Apollo.QueryResult<GetProductAccompanimentQuery, GetProductAccompanimentQueryVariables>;
export const GetProductsAccompanimentDocument = gql`
    query GetProductsAccompaniment($productIds: [Int!]) {
  products(where: {id: {in: $productIds}}) {
    id
    accompaniments {
      ...accompaniment
    }
  }
}
    ${AccompanimentFragmentDoc}`;

/**
 * __useGetProductsAccompanimentQuery__
 *
 * To run a query within a React component, call `useGetProductsAccompanimentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsAccompanimentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsAccompanimentQuery({
 *   variables: {
 *      productIds: // value for 'productIds'
 *   },
 * });
 */
export function useGetProductsAccompanimentQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsAccompanimentQuery, GetProductsAccompanimentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsAccompanimentQuery, GetProductsAccompanimentQueryVariables>(GetProductsAccompanimentDocument, options);
      }
export function useGetProductsAccompanimentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsAccompanimentQuery, GetProductsAccompanimentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsAccompanimentQuery, GetProductsAccompanimentQueryVariables>(GetProductsAccompanimentDocument, options);
        }
export type GetProductsAccompanimentQueryHookResult = ReturnType<typeof useGetProductsAccompanimentQuery>;
export type GetProductsAccompanimentLazyQueryHookResult = ReturnType<typeof useGetProductsAccompanimentLazyQuery>;
export type GetProductsAccompanimentQueryResult = Apollo.QueryResult<GetProductsAccompanimentQuery, GetProductsAccompanimentQueryVariables>;
export const RecordActionDocument = gql`
    mutation RecordAction($data: RecordActionInput!) {
  recordAction(data: $data) {
    id
  }
}
    `;
export type RecordActionMutationFn = Apollo.MutationFunction<RecordActionMutation, RecordActionMutationVariables>;

/**
 * __useRecordActionMutation__
 *
 * To run a mutation, you first call `useRecordActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordActionMutation, { data, loading, error }] = useRecordActionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useRecordActionMutation(baseOptions?: Apollo.MutationHookOptions<RecordActionMutation, RecordActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordActionMutation, RecordActionMutationVariables>(RecordActionDocument, options);
      }
export type RecordActionMutationHookResult = ReturnType<typeof useRecordActionMutation>;
export type RecordActionMutationResult = Apollo.MutationResult<RecordActionMutation>;
export type RecordActionMutationOptions = Apollo.BaseMutationOptions<RecordActionMutation, RecordActionMutationVariables>;
export const GetBadgesDocument = gql`
    query GetBadges($where: BadgesWhereInput) {
  badges(where: $where) {
    ...badge
  }
}
    ${BadgeFragmentDoc}`;

/**
 * __useGetBadgesQuery__
 *
 * To run a query within a React component, call `useGetBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBadgesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetBadgesQuery(baseOptions?: Apollo.QueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, options);
      }
export function useGetBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBadgesQuery, GetBadgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBadgesQuery, GetBadgesQueryVariables>(GetBadgesDocument, options);
        }
export type GetBadgesQueryHookResult = ReturnType<typeof useGetBadgesQuery>;
export type GetBadgesLazyQueryHookResult = ReturnType<typeof useGetBadgesLazyQuery>;
export type GetBadgesQueryResult = Apollo.QueryResult<GetBadgesQuery, GetBadgesQueryVariables>;
export const GetWonBadgesDocument = gql`
    query GetWonBadges {
  wonBadges {
    ...badge
  }
}
    ${BadgeFragmentDoc}`;

/**
 * __useGetWonBadgesQuery__
 *
 * To run a query within a React component, call `useGetWonBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWonBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWonBadgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWonBadgesQuery(baseOptions?: Apollo.QueryHookOptions<GetWonBadgesQuery, GetWonBadgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWonBadgesQuery, GetWonBadgesQueryVariables>(GetWonBadgesDocument, options);
      }
export function useGetWonBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWonBadgesQuery, GetWonBadgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWonBadgesQuery, GetWonBadgesQueryVariables>(GetWonBadgesDocument, options);
        }
export type GetWonBadgesQueryHookResult = ReturnType<typeof useGetWonBadgesQuery>;
export type GetWonBadgesLazyQueryHookResult = ReturnType<typeof useGetWonBadgesLazyQuery>;
export type GetWonBadgesQueryResult = Apollo.QueryResult<GetWonBadgesQuery, GetWonBadgesQueryVariables>;
export const GetAllBrandsDocument = gql`
    query GetAllBrands($where: BrandWhereInput) {
  brands(where: $where) {
    ...brand
  }
}
    ${BrandFragmentDoc}`;

/**
 * __useGetAllBrandsQuery__
 *
 * To run a query within a React component, call `useGetAllBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBrandsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBrandsQuery, GetAllBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBrandsQuery, GetAllBrandsQueryVariables>(GetAllBrandsDocument, options);
      }
export function useGetAllBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBrandsQuery, GetAllBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBrandsQuery, GetAllBrandsQueryVariables>(GetAllBrandsDocument, options);
        }
export type GetAllBrandsQueryHookResult = ReturnType<typeof useGetAllBrandsQuery>;
export type GetAllBrandsLazyQueryHookResult = ReturnType<typeof useGetAllBrandsLazyQuery>;
export type GetAllBrandsQueryResult = Apollo.QueryResult<GetAllBrandsQuery, GetAllBrandsQueryVariables>;
export const GetAllMiniBrandsDocument = gql`
    query GetAllMiniBrands($where: BrandWhereInput) {
  brands(where: $where) {
    ...miniBrand
  }
}
    ${MiniBrandFragmentDoc}`;

/**
 * __useGetAllMiniBrandsQuery__
 *
 * To run a query within a React component, call `useGetAllMiniBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMiniBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMiniBrandsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllMiniBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMiniBrandsQuery, GetAllMiniBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMiniBrandsQuery, GetAllMiniBrandsQueryVariables>(GetAllMiniBrandsDocument, options);
      }
export function useGetAllMiniBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMiniBrandsQuery, GetAllMiniBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMiniBrandsQuery, GetAllMiniBrandsQueryVariables>(GetAllMiniBrandsDocument, options);
        }
export type GetAllMiniBrandsQueryHookResult = ReturnType<typeof useGetAllMiniBrandsQuery>;
export type GetAllMiniBrandsLazyQueryHookResult = ReturnType<typeof useGetAllMiniBrandsLazyQuery>;
export type GetAllMiniBrandsQueryResult = Apollo.QueryResult<GetAllMiniBrandsQuery, GetAllMiniBrandsQueryVariables>;
export const GetAllBrandsWithProductsDocument = gql`
    query GetAllBrandsWithProducts($where: BrandWhereInput) {
  brands(where: $where) {
    ...brandWithProducts
  }
}
    ${BrandWithProductsFragmentDoc}`;

/**
 * __useGetAllBrandsWithProductsQuery__
 *
 * To run a query within a React component, call `useGetAllBrandsWithProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllBrandsWithProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllBrandsWithProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllBrandsWithProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllBrandsWithProductsQuery, GetAllBrandsWithProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllBrandsWithProductsQuery, GetAllBrandsWithProductsQueryVariables>(GetAllBrandsWithProductsDocument, options);
      }
export function useGetAllBrandsWithProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllBrandsWithProductsQuery, GetAllBrandsWithProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllBrandsWithProductsQuery, GetAllBrandsWithProductsQueryVariables>(GetAllBrandsWithProductsDocument, options);
        }
export type GetAllBrandsWithProductsQueryHookResult = ReturnType<typeof useGetAllBrandsWithProductsQuery>;
export type GetAllBrandsWithProductsLazyQueryHookResult = ReturnType<typeof useGetAllBrandsWithProductsLazyQuery>;
export type GetAllBrandsWithProductsQueryResult = Apollo.QueryResult<GetAllBrandsWithProductsQuery, GetAllBrandsWithProductsQueryVariables>;
export const CreateImagesPresentationDocument = gql`
    mutation createImagesPresentation($imageIds: [Int!]!, $title: String) {
  imagesPresentation(imageIds: $imageIds, title: $title) {
    title
    pdf {
      ...media
    }
  }
}
    ${MediaFragmentDoc}`;
export type CreateImagesPresentationMutationFn = Apollo.MutationFunction<CreateImagesPresentationMutation, CreateImagesPresentationMutationVariables>;

/**
 * __useCreateImagesPresentationMutation__
 *
 * To run a mutation, you first call `useCreateImagesPresentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImagesPresentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImagesPresentationMutation, { data, loading, error }] = useCreateImagesPresentationMutation({
 *   variables: {
 *      imageIds: // value for 'imageIds'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateImagesPresentationMutation(baseOptions?: Apollo.MutationHookOptions<CreateImagesPresentationMutation, CreateImagesPresentationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateImagesPresentationMutation, CreateImagesPresentationMutationVariables>(CreateImagesPresentationDocument, options);
      }
export type CreateImagesPresentationMutationHookResult = ReturnType<typeof useCreateImagesPresentationMutation>;
export type CreateImagesPresentationMutationResult = Apollo.MutationResult<CreateImagesPresentationMutation>;
export type CreateImagesPresentationMutationOptions = Apollo.BaseMutationOptions<CreateImagesPresentationMutation, CreateImagesPresentationMutationVariables>;
export const GetAllCatalogsDocument = gql`
    query GetAllCatalogs($where: AdminCatalogsWhereInput) {
  catalogs(where: $where) {
    id
    title
    brandId
    image {
      ...image
    }
    brand {
      ...brand
    }
  }
}
    ${ImageFragmentDoc}
${BrandFragmentDoc}`;

/**
 * __useGetAllCatalogsQuery__
 *
 * To run a query within a React component, call `useGetAllCatalogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCatalogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCatalogsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllCatalogsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllCatalogsQuery, GetAllCatalogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCatalogsQuery, GetAllCatalogsQueryVariables>(GetAllCatalogsDocument, options);
      }
export function useGetAllCatalogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCatalogsQuery, GetAllCatalogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCatalogsQuery, GetAllCatalogsQueryVariables>(GetAllCatalogsDocument, options);
        }
export type GetAllCatalogsQueryHookResult = ReturnType<typeof useGetAllCatalogsQuery>;
export type GetAllCatalogsLazyQueryHookResult = ReturnType<typeof useGetAllCatalogsLazyQuery>;
export type GetAllCatalogsQueryResult = Apollo.QueryResult<GetAllCatalogsQuery, GetAllCatalogsQueryVariables>;
export const SetCommercialConditionsDocument = gql`
    mutation setCommercialConditions($proposalId: Int!, $isDirectBilling: Boolean!, $isTankDirectBilling: Boolean, $generateSlides: Boolean!, $commercialConditions: [UpsertCommercialConditionInput!]!, $resumeFields: SynthesisInput, $customCommercialCondition: [CustomCommercialConditionsInput!], $provinceNumber: Int) {
  upsertCommercialConditions(
    proposalId: $proposalId
    isDirectBilling: $isDirectBilling
    isTankDirectBilling: $isTankDirectBilling
    commercialConditions: $commercialConditions
    generateSlides: $generateSlides
    synthesis: $resumeFields
    customCommercialCondition: $customCommercialCondition
    provinceNumber: $provinceNumber
  ) {
    ...proposalSlide
  }
}
    ${ProposalSlideFragmentDoc}`;
export type SetCommercialConditionsMutationFn = Apollo.MutationFunction<SetCommercialConditionsMutation, SetCommercialConditionsMutationVariables>;

/**
 * __useSetCommercialConditionsMutation__
 *
 * To run a mutation, you first call `useSetCommercialConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCommercialConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCommercialConditionsMutation, { data, loading, error }] = useSetCommercialConditionsMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      isDirectBilling: // value for 'isDirectBilling'
 *      isTankDirectBilling: // value for 'isTankDirectBilling'
 *      generateSlides: // value for 'generateSlides'
 *      commercialConditions: // value for 'commercialConditions'
 *      resumeFields: // value for 'resumeFields'
 *      customCommercialCondition: // value for 'customCommercialCondition'
 *      provinceNumber: // value for 'provinceNumber'
 *   },
 * });
 */
export function useSetCommercialConditionsMutation(baseOptions?: Apollo.MutationHookOptions<SetCommercialConditionsMutation, SetCommercialConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCommercialConditionsMutation, SetCommercialConditionsMutationVariables>(SetCommercialConditionsDocument, options);
      }
export type SetCommercialConditionsMutationHookResult = ReturnType<typeof useSetCommercialConditionsMutation>;
export type SetCommercialConditionsMutationResult = Apollo.MutationResult<SetCommercialConditionsMutation>;
export type SetCommercialConditionsMutationOptions = Apollo.BaseMutationOptions<SetCommercialConditionsMutation, SetCommercialConditionsMutationVariables>;
export const GetLevelsDocument = gql`
    query GetLevels {
  levels {
    ...level
  }
}
    ${LevelFragmentDoc}`;

/**
 * __useGetLevelsQuery__
 *
 * To run a query within a React component, call `useGetLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLevelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLevelsQuery(baseOptions?: Apollo.QueryHookOptions<GetLevelsQuery, GetLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLevelsQuery, GetLevelsQueryVariables>(GetLevelsDocument, options);
      }
export function useGetLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLevelsQuery, GetLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLevelsQuery, GetLevelsQueryVariables>(GetLevelsDocument, options);
        }
export type GetLevelsQueryHookResult = ReturnType<typeof useGetLevelsQuery>;
export type GetLevelsLazyQueryHookResult = ReturnType<typeof useGetLevelsLazyQuery>;
export type GetLevelsQueryResult = Apollo.QueryResult<GetLevelsQuery, GetLevelsQueryVariables>;
export const GetAllLocationsDocument = gql`
    query GetAllLocations($skip: Int, $take: Int, $isOwner: Boolean, $search: [PointOfSaleWhereInput!], $segmentType: SegmentTypeFilter, $segment: SegmentFilter, $brandId: IntFilter, $rentabilibar: Boolean, $beerTAM: FloatFilter, $laLiga: Boolean, $underContract: Boolean, $isActive: Boolean, $soldProducts: SoldProductRelationFilter, $latitude: FloatFilter, $longitude: FloatFilter, $address: StringFilter, $clientType: ClientTypeFilter, $OR: [LocationWhereInput!], $and: [PointOfSaleWhereInput!]) {
  locations(
    take: $take
    skip: $skip
    isOwner: $isOwner
    where: {OR: $OR, AND: {latitude: $latitude, longitude: $longitude, address: $address, pointOfSale: {AND: $and, OR: $search, segmentType: $segmentType, segment: $segment, brandId: $brandId, rentabilibar: $rentabilibar, beerTAM: $beerTAM, laLiga: $laLiga, underContract: $underContract, isActive: $isActive, soldProducts: $soldProducts, clientType: $clientType}}}
  ) {
    ...location
  }
}
    ${LocationFragmentDoc}`;

/**
 * __useGetAllLocationsQuery__
 *
 * To run a query within a React component, call `useGetAllLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLocationsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      isOwner: // value for 'isOwner'
 *      search: // value for 'search'
 *      segmentType: // value for 'segmentType'
 *      segment: // value for 'segment'
 *      brandId: // value for 'brandId'
 *      rentabilibar: // value for 'rentabilibar'
 *      beerTAM: // value for 'beerTAM'
 *      laLiga: // value for 'laLiga'
 *      underContract: // value for 'underContract'
 *      isActive: // value for 'isActive'
 *      soldProducts: // value for 'soldProducts'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      address: // value for 'address'
 *      clientType: // value for 'clientType'
 *      OR: // value for 'OR'
 *      and: // value for 'and'
 *   },
 * });
 */
export function useGetAllLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLocationsQuery, GetAllLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLocationsQuery, GetAllLocationsQueryVariables>(GetAllLocationsDocument, options);
      }
export function useGetAllLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLocationsQuery, GetAllLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLocationsQuery, GetAllLocationsQueryVariables>(GetAllLocationsDocument, options);
        }
export type GetAllLocationsQueryHookResult = ReturnType<typeof useGetAllLocationsQuery>;
export type GetAllLocationsLazyQueryHookResult = ReturnType<typeof useGetAllLocationsLazyQuery>;
export type GetAllLocationsQueryResult = Apollo.QueryResult<GetAllLocationsQuery, GetAllLocationsQueryVariables>;
export const BookmarkProductsDocument = gql`
    mutation bookmarkProducts($data: BookmarkedProductsInput!) {
  bookmarkProducts(data: $data) {
    id
  }
}
    `;
export type BookmarkProductsMutationFn = Apollo.MutationFunction<BookmarkProductsMutation, BookmarkProductsMutationVariables>;

/**
 * __useBookmarkProductsMutation__
 *
 * To run a mutation, you first call `useBookmarkProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookmarkProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookmarkProductsMutation, { data, loading, error }] = useBookmarkProductsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBookmarkProductsMutation(baseOptions?: Apollo.MutationHookOptions<BookmarkProductsMutation, BookmarkProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BookmarkProductsMutation, BookmarkProductsMutationVariables>(BookmarkProductsDocument, options);
      }
export type BookmarkProductsMutationHookResult = ReturnType<typeof useBookmarkProductsMutation>;
export type BookmarkProductsMutationResult = Apollo.MutationResult<BookmarkProductsMutation>;
export type BookmarkProductsMutationOptions = Apollo.BaseMutationOptions<BookmarkProductsMutation, BookmarkProductsMutationVariables>;
export const HideProductsDocument = gql`
    mutation hideProducts($data: HiddenProductsInput!) {
  hideProducts(data: $data) {
    id
  }
}
    `;
export type HideProductsMutationFn = Apollo.MutationFunction<HideProductsMutation, HideProductsMutationVariables>;

/**
 * __useHideProductsMutation__
 *
 * To run a mutation, you first call `useHideProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideProductsMutation, { data, loading, error }] = useHideProductsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useHideProductsMutation(baseOptions?: Apollo.MutationHookOptions<HideProductsMutation, HideProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideProductsMutation, HideProductsMutationVariables>(HideProductsDocument, options);
      }
export type HideProductsMutationHookResult = ReturnType<typeof useHideProductsMutation>;
export type HideProductsMutationResult = Apollo.MutationResult<HideProductsMutation>;
export type HideProductsMutationOptions = Apollo.BaseMutationOptions<HideProductsMutation, HideProductsMutationVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetMediaDocument = gql`
    query GetMedia($mediaId: Int!) {
  media(id: $mediaId) {
    ...media
  }
}
    ${MediaFragmentDoc}`;

/**
 * __useGetMediaQuery__
 *
 * To run a query within a React component, call `useGetMediaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaQuery({
 *   variables: {
 *      mediaId: // value for 'mediaId'
 *   },
 * });
 */
export function useGetMediaQuery(baseOptions: Apollo.QueryHookOptions<GetMediaQuery, GetMediaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaQuery, GetMediaQueryVariables>(GetMediaDocument, options);
      }
export function useGetMediaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaQuery, GetMediaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaQuery, GetMediaQueryVariables>(GetMediaDocument, options);
        }
export type GetMediaQueryHookResult = ReturnType<typeof useGetMediaQuery>;
export type GetMediaLazyQueryHookResult = ReturnType<typeof useGetMediaLazyQuery>;
export type GetMediaQueryResult = Apollo.QueryResult<GetMediaQuery, GetMediaQueryVariables>;
export const UpdateNbaDocument = gql`
    mutation UpdateNba($input: UpdateNextBestActionInput!) {
  updateNba(input: $input)
}
    `;
export type UpdateNbaMutationFn = Apollo.MutationFunction<UpdateNbaMutation, UpdateNbaMutationVariables>;

/**
 * __useUpdateNbaMutation__
 *
 * To run a mutation, you first call `useUpdateNbaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNbaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNbaMutation, { data, loading, error }] = useUpdateNbaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNbaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNbaMutation, UpdateNbaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNbaMutation, UpdateNbaMutationVariables>(UpdateNbaDocument, options);
      }
export type UpdateNbaMutationHookResult = ReturnType<typeof useUpdateNbaMutation>;
export type UpdateNbaMutationResult = Apollo.MutationResult<UpdateNbaMutation>;
export type UpdateNbaMutationOptions = Apollo.BaseMutationOptions<UpdateNbaMutation, UpdateNbaMutationVariables>;
export const GetNextBestActionsDocument = gql`
    query GetNextBestActions($externalId: String!) {
  nextBestActions(input: {externalId: $externalId}) {
    id
    category
    channel
  }
}
    `;

/**
 * __useGetNextBestActionsQuery__
 *
 * To run a query within a React component, call `useGetNextBestActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextBestActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextBestActionsQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useGetNextBestActionsQuery(baseOptions: Apollo.QueryHookOptions<GetNextBestActionsQuery, GetNextBestActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextBestActionsQuery, GetNextBestActionsQueryVariables>(GetNextBestActionsDocument, options);
      }
export function useGetNextBestActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextBestActionsQuery, GetNextBestActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextBestActionsQuery, GetNextBestActionsQueryVariables>(GetNextBestActionsDocument, options);
        }
export type GetNextBestActionsQueryHookResult = ReturnType<typeof useGetNextBestActionsQuery>;
export type GetNextBestActionsLazyQueryHookResult = ReturnType<typeof useGetNextBestActionsLazyQuery>;
export type GetNextBestActionsQueryResult = Apollo.QueryResult<GetNextBestActionsQuery, GetNextBestActionsQueryVariables>;
export const GetAllNewsDocument = gql`
    query GetAllNews {
  news {
    ...new
  }
}
    ${NewFragmentDoc}`;

/**
 * __useGetAllNewsQuery__
 *
 * To run a query within a React component, call `useGetAllNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllNewsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNewsQuery, GetAllNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNewsQuery, GetAllNewsQueryVariables>(GetAllNewsDocument, options);
      }
export function useGetAllNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNewsQuery, GetAllNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNewsQuery, GetAllNewsQueryVariables>(GetAllNewsDocument, options);
        }
export type GetAllNewsQueryHookResult = ReturnType<typeof useGetAllNewsQuery>;
export type GetAllNewsLazyQueryHookResult = ReturnType<typeof useGetAllNewsLazyQuery>;
export type GetAllNewsQueryResult = Apollo.QueryResult<GetAllNewsQuery, GetAllNewsQueryVariables>;
export const MarkOneNotificationAsReadDocument = gql`
    mutation MarkOneNotificationAsRead($id: Float!) {
  markNotificationAsRead(id: $id) {
    id
    read
  }
}
    `;
export type MarkOneNotificationAsReadMutationFn = Apollo.MutationFunction<MarkOneNotificationAsReadMutation, MarkOneNotificationAsReadMutationVariables>;

/**
 * __useMarkOneNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkOneNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkOneNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markOneNotificationAsReadMutation, { data, loading, error }] = useMarkOneNotificationAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkOneNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkOneNotificationAsReadMutation, MarkOneNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkOneNotificationAsReadMutation, MarkOneNotificationAsReadMutationVariables>(MarkOneNotificationAsReadDocument, options);
      }
export type MarkOneNotificationAsReadMutationHookResult = ReturnType<typeof useMarkOneNotificationAsReadMutation>;
export type MarkOneNotificationAsReadMutationResult = Apollo.MutationResult<MarkOneNotificationAsReadMutation>;
export type MarkOneNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkOneNotificationAsReadMutation, MarkOneNotificationAsReadMutationVariables>;
export const GetAllNotificationsDocument = gql`
    query GetAllNotifications($where: NotificationWhereInput) {
  notifications(where: $where) {
    id
    createdAt
    type
    read
    title
    content
    proposalId
    pointOfSaleId
    releaseNote {
      id
      content
      title
      version
    }
  }
}
    `;

/**
 * __useGetAllNotificationsQuery__
 *
 * To run a query within a React component, call `useGetAllNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNotificationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>(GetAllNotificationsDocument, options);
      }
export function useGetAllNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>(GetAllNotificationsDocument, options);
        }
export type GetAllNotificationsQueryHookResult = ReturnType<typeof useGetAllNotificationsQuery>;
export type GetAllNotificationsLazyQueryHookResult = ReturnType<typeof useGetAllNotificationsLazyQuery>;
export type GetAllNotificationsQueryResult = Apollo.QueryResult<GetAllNotificationsQuery, GetAllNotificationsQueryVariables>;
export const GetOneNotificationsDocument = gql`
    query GetOneNotifications($where: NotificationWhereInput) {
  notifications(where: $where) {
    id
    type
    read
    proposalId
    pointOfSaleId
    releaseNote {
      id
      content
      title
      version
    }
  }
}
    `;

/**
 * __useGetOneNotificationsQuery__
 *
 * To run a query within a React component, call `useGetOneNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneNotificationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetOneNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOneNotificationsQuery, GetOneNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneNotificationsQuery, GetOneNotificationsQueryVariables>(GetOneNotificationsDocument, options);
      }
export function useGetOneNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneNotificationsQuery, GetOneNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneNotificationsQuery, GetOneNotificationsQueryVariables>(GetOneNotificationsDocument, options);
        }
export type GetOneNotificationsQueryHookResult = ReturnType<typeof useGetOneNotificationsQuery>;
export type GetOneNotificationsLazyQueryHookResult = ReturnType<typeof useGetOneNotificationsLazyQuery>;
export type GetOneNotificationsQueryResult = Apollo.QueryResult<GetOneNotificationsQuery, GetOneNotificationsQueryVariables>;
export const GetUnreadNotificationsCountDocument = gql`
    query GetUnreadNotificationsCount {
  unreadNotificationsCount
}
    `;

/**
 * __useGetUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>(GetUnreadNotificationsCountDocument, options);
      }
export function useGetUnreadNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>(GetUnreadNotificationsCountDocument, options);
        }
export type GetUnreadNotificationsCountQueryHookResult = ReturnType<typeof useGetUnreadNotificationsCountQuery>;
export type GetUnreadNotificationsCountLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationsCountLazyQuery>;
export type GetUnreadNotificationsCountQueryResult = Apollo.QueryResult<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>;
export const GetPackagedProductPriceDocument = gql`
    query GetPackagedProductPrice($where: PackagedProductPriceWhereInput) {
  packagedProductPrices(where: $where) {
    packagedProductId
    price
  }
}
    `;

/**
 * __useGetPackagedProductPriceQuery__
 *
 * To run a query within a React component, call `useGetPackagedProductPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagedProductPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagedProductPriceQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPackagedProductPriceQuery(baseOptions?: Apollo.QueryHookOptions<GetPackagedProductPriceQuery, GetPackagedProductPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagedProductPriceQuery, GetPackagedProductPriceQueryVariables>(GetPackagedProductPriceDocument, options);
      }
export function useGetPackagedProductPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagedProductPriceQuery, GetPackagedProductPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagedProductPriceQuery, GetPackagedProductPriceQueryVariables>(GetPackagedProductPriceDocument, options);
        }
export type GetPackagedProductPriceQueryHookResult = ReturnType<typeof useGetPackagedProductPriceQuery>;
export type GetPackagedProductPriceLazyQueryHookResult = ReturnType<typeof useGetPackagedProductPriceLazyQuery>;
export type GetPackagedProductPriceQueryResult = Apollo.QueryResult<GetPackagedProductPriceQuery, GetPackagedProductPriceQueryVariables>;
export const GetPackagedProductsDocument = gql`
    query GetPackagedProducts($where: PackagedProductWhereInput) {
  packagedProducts(where: $where) {
    id
    productId
    externalId
    product {
      brandId
    }
    packagedDetails {
      ... on PackagedBeerDetails {
        ...packagedBeerDetails
      }
    }
  }
}
    ${PackagedBeerDetailsFragmentDoc}`;

/**
 * __useGetPackagedProductsQuery__
 *
 * To run a query within a React component, call `useGetPackagedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagedProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPackagedProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetPackagedProductsQuery, GetPackagedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagedProductsQuery, GetPackagedProductsQueryVariables>(GetPackagedProductsDocument, options);
      }
export function useGetPackagedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagedProductsQuery, GetPackagedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagedProductsQuery, GetPackagedProductsQueryVariables>(GetPackagedProductsDocument, options);
        }
export type GetPackagedProductsQueryHookResult = ReturnType<typeof useGetPackagedProductsQuery>;
export type GetPackagedProductsLazyQueryHookResult = ReturnType<typeof useGetPackagedProductsLazyQuery>;
export type GetPackagedProductsQueryResult = Apollo.QueryResult<GetPackagedProductsQuery, GetPackagedProductsQueryVariables>;
export const GetPackagedProductMicroDocument = gql`
    query GetPackagedProductMicro($where: PackagedProductWhereInput) {
  packagedProducts(where: $where) {
    id
    name
    commercialName
    externalId
  }
}
    `;

/**
 * __useGetPackagedProductMicroQuery__
 *
 * To run a query within a React component, call `useGetPackagedProductMicroQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPackagedProductMicroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPackagedProductMicroQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPackagedProductMicroQuery(baseOptions?: Apollo.QueryHookOptions<GetPackagedProductMicroQuery, GetPackagedProductMicroQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPackagedProductMicroQuery, GetPackagedProductMicroQueryVariables>(GetPackagedProductMicroDocument, options);
      }
export function useGetPackagedProductMicroLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPackagedProductMicroQuery, GetPackagedProductMicroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPackagedProductMicroQuery, GetPackagedProductMicroQueryVariables>(GetPackagedProductMicroDocument, options);
        }
export type GetPackagedProductMicroQueryHookResult = ReturnType<typeof useGetPackagedProductMicroQuery>;
export type GetPackagedProductMicroLazyQueryHookResult = ReturnType<typeof useGetPackagedProductMicroLazyQuery>;
export type GetPackagedProductMicroQueryResult = Apollo.QueryResult<GetPackagedProductMicroQuery, GetPackagedProductMicroQueryVariables>;
export const ImportPointOfSaleDocument = gql`
    mutation importPointOfSale($externalId: String!) {
  importPointOfSaleFromSherpa(externalId: $externalId) {
    ...pointOfSaleMini
  }
}
    ${PointOfSaleMiniFragmentDoc}`;
export type ImportPointOfSaleMutationFn = Apollo.MutationFunction<ImportPointOfSaleMutation, ImportPointOfSaleMutationVariables>;

/**
 * __useImportPointOfSaleMutation__
 *
 * To run a mutation, you first call `useImportPointOfSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPointOfSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPointOfSaleMutation, { data, loading, error }] = useImportPointOfSaleMutation({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useImportPointOfSaleMutation(baseOptions?: Apollo.MutationHookOptions<ImportPointOfSaleMutation, ImportPointOfSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPointOfSaleMutation, ImportPointOfSaleMutationVariables>(ImportPointOfSaleDocument, options);
      }
export type ImportPointOfSaleMutationHookResult = ReturnType<typeof useImportPointOfSaleMutation>;
export type ImportPointOfSaleMutationResult = Apollo.MutationResult<ImportPointOfSaleMutation>;
export type ImportPointOfSaleMutationOptions = Apollo.BaseMutationOptions<ImportPointOfSaleMutation, ImportPointOfSaleMutationVariables>;
export const UpdateSherpaPointOfSaleDocument = gql`
    mutation updateSherpaPointOfSale($externalId: String!, $data: PointOfSaleUpdateInput!) {
  updateSherpaPointOfSale(externalId: $externalId, data: $data) {
    externalId
  }
}
    `;
export type UpdateSherpaPointOfSaleMutationFn = Apollo.MutationFunction<UpdateSherpaPointOfSaleMutation, UpdateSherpaPointOfSaleMutationVariables>;

/**
 * __useUpdateSherpaPointOfSaleMutation__
 *
 * To run a mutation, you first call `useUpdateSherpaPointOfSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSherpaPointOfSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSherpaPointOfSaleMutation, { data, loading, error }] = useUpdateSherpaPointOfSaleMutation({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateSherpaPointOfSaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSherpaPointOfSaleMutation, UpdateSherpaPointOfSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSherpaPointOfSaleMutation, UpdateSherpaPointOfSaleMutationVariables>(UpdateSherpaPointOfSaleDocument, options);
      }
export type UpdateSherpaPointOfSaleMutationHookResult = ReturnType<typeof useUpdateSherpaPointOfSaleMutation>;
export type UpdateSherpaPointOfSaleMutationResult = Apollo.MutationResult<UpdateSherpaPointOfSaleMutation>;
export type UpdateSherpaPointOfSaleMutationOptions = Apollo.BaseMutationOptions<UpdateSherpaPointOfSaleMutation, UpdateSherpaPointOfSaleMutationVariables>;
export const UpdatePosMainContactDocument = gql`
    mutation updatePosMainContact($data: UpdateContactInput!) {
  updateContact(data: $data)
}
    `;
export type UpdatePosMainContactMutationFn = Apollo.MutationFunction<UpdatePosMainContactMutation, UpdatePosMainContactMutationVariables>;

/**
 * __useUpdatePosMainContactMutation__
 *
 * To run a mutation, you first call `useUpdatePosMainContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePosMainContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePosMainContactMutation, { data, loading, error }] = useUpdatePosMainContactMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePosMainContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePosMainContactMutation, UpdatePosMainContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePosMainContactMutation, UpdatePosMainContactMutationVariables>(UpdatePosMainContactDocument, options);
      }
export type UpdatePosMainContactMutationHookResult = ReturnType<typeof useUpdatePosMainContactMutation>;
export type UpdatePosMainContactMutationResult = Apollo.MutationResult<UpdatePosMainContactMutation>;
export type UpdatePosMainContactMutationOptions = Apollo.BaseMutationOptions<UpdatePosMainContactMutation, UpdatePosMainContactMutationVariables>;
export const CreateSherpaPointOfSaleDocument = gql`
    mutation createSherpaPointOfSale($data: PointOfSaleCreateInput!) {
  createSherpaPointOfSale(data: $data) {
    ...pointOfSaleMini
  }
}
    ${PointOfSaleMiniFragmentDoc}`;
export type CreateSherpaPointOfSaleMutationFn = Apollo.MutationFunction<CreateSherpaPointOfSaleMutation, CreateSherpaPointOfSaleMutationVariables>;

/**
 * __useCreateSherpaPointOfSaleMutation__
 *
 * To run a mutation, you first call `useCreateSherpaPointOfSaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSherpaPointOfSaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSherpaPointOfSaleMutation, { data, loading, error }] = useCreateSherpaPointOfSaleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateSherpaPointOfSaleMutation(baseOptions?: Apollo.MutationHookOptions<CreateSherpaPointOfSaleMutation, CreateSherpaPointOfSaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSherpaPointOfSaleMutation, CreateSherpaPointOfSaleMutationVariables>(CreateSherpaPointOfSaleDocument, options);
      }
export type CreateSherpaPointOfSaleMutationHookResult = ReturnType<typeof useCreateSherpaPointOfSaleMutation>;
export type CreateSherpaPointOfSaleMutationResult = Apollo.MutationResult<CreateSherpaPointOfSaleMutation>;
export type CreateSherpaPointOfSaleMutationOptions = Apollo.BaseMutationOptions<CreateSherpaPointOfSaleMutation, CreateSherpaPointOfSaleMutationVariables>;
export const PointOfSaleVolumeDetailsDocument = gql`
    mutation pointOfSaleVolumeDetails($data: PointOfSaleVolumeDetailsInput!) {
  pointOfSaleVolumeDetails(data: $data)
}
    `;
export type PointOfSaleVolumeDetailsMutationFn = Apollo.MutationFunction<PointOfSaleVolumeDetailsMutation, PointOfSaleVolumeDetailsMutationVariables>;

/**
 * __usePointOfSaleVolumeDetailsMutation__
 *
 * To run a mutation, you first call `usePointOfSaleVolumeDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePointOfSaleVolumeDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pointOfSaleVolumeDetailsMutation, { data, loading, error }] = usePointOfSaleVolumeDetailsMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePointOfSaleVolumeDetailsMutation(baseOptions?: Apollo.MutationHookOptions<PointOfSaleVolumeDetailsMutation, PointOfSaleVolumeDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PointOfSaleVolumeDetailsMutation, PointOfSaleVolumeDetailsMutationVariables>(PointOfSaleVolumeDetailsDocument, options);
      }
export type PointOfSaleVolumeDetailsMutationHookResult = ReturnType<typeof usePointOfSaleVolumeDetailsMutation>;
export type PointOfSaleVolumeDetailsMutationResult = Apollo.MutationResult<PointOfSaleVolumeDetailsMutation>;
export type PointOfSaleVolumeDetailsMutationOptions = Apollo.BaseMutationOptions<PointOfSaleVolumeDetailsMutation, PointOfSaleVolumeDetailsMutationVariables>;
export const GetAllPosDocument = gql`
    query GetAllPOS($search: String) {
  pointOfSales(where: {name: {contains: $search}}) {
    ...pointOfSaleMini
  }
}
    ${PointOfSaleMiniFragmentDoc}`;

/**
 * __useGetAllPosQuery__
 *
 * To run a query within a React component, call `useGetAllPosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPosQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAllPosQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPosQuery, GetAllPosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPosQuery, GetAllPosQueryVariables>(GetAllPosDocument, options);
      }
export function useGetAllPosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPosQuery, GetAllPosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPosQuery, GetAllPosQueryVariables>(GetAllPosDocument, options);
        }
export type GetAllPosQueryHookResult = ReturnType<typeof useGetAllPosQuery>;
export type GetAllPosLazyQueryHookResult = ReturnType<typeof useGetAllPosLazyQuery>;
export type GetAllPosQueryResult = Apollo.QueryResult<GetAllPosQuery, GetAllPosQueryVariables>;
export const GetPosDocument = gql`
    query GetPOS($id: Int!) {
  pointOfSales(where: {id: {in: [$id]}}) {
    ...pointOfSale
  }
}
    ${PointOfSaleFragmentDoc}`;

/**
 * __useGetPosQuery__
 *
 * To run a query within a React component, call `useGetPosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPosQuery(baseOptions: Apollo.QueryHookOptions<GetPosQuery, GetPosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosQuery, GetPosQueryVariables>(GetPosDocument, options);
      }
export function useGetPosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosQuery, GetPosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosQuery, GetPosQueryVariables>(GetPosDocument, options);
        }
export type GetPosQueryHookResult = ReturnType<typeof useGetPosQuery>;
export type GetPosLazyQueryHookResult = ReturnType<typeof useGetPosLazyQuery>;
export type GetPosQueryResult = Apollo.QueryResult<GetPosQuery, GetPosQueryVariables>;
export const GetAssortmentPointOfSaleDocument = gql`
    query GetAssortmentPointOfSale($id: Int!) {
  pointOfSales(where: {id: {in: [$id]}}) {
    ...assortmentPointOfSale
  }
}
    ${AssortmentPointOfSaleFragmentDoc}`;

/**
 * __useGetAssortmentPointOfSaleQuery__
 *
 * To run a query within a React component, call `useGetAssortmentPointOfSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssortmentPointOfSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssortmentPointOfSaleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssortmentPointOfSaleQuery(baseOptions: Apollo.QueryHookOptions<GetAssortmentPointOfSaleQuery, GetAssortmentPointOfSaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssortmentPointOfSaleQuery, GetAssortmentPointOfSaleQueryVariables>(GetAssortmentPointOfSaleDocument, options);
      }
export function useGetAssortmentPointOfSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssortmentPointOfSaleQuery, GetAssortmentPointOfSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssortmentPointOfSaleQuery, GetAssortmentPointOfSaleQueryVariables>(GetAssortmentPointOfSaleDocument, options);
        }
export type GetAssortmentPointOfSaleQueryHookResult = ReturnType<typeof useGetAssortmentPointOfSaleQuery>;
export type GetAssortmentPointOfSaleLazyQueryHookResult = ReturnType<typeof useGetAssortmentPointOfSaleLazyQuery>;
export type GetAssortmentPointOfSaleQueryResult = Apollo.QueryResult<GetAssortmentPointOfSaleQuery, GetAssortmentPointOfSaleQueryVariables>;
export const GetSingleMapPosDocument = gql`
    query GetSingleMapPos($id: Int!) {
  pointOfSales(where: {id: {in: [$id]}}) {
    ...pointOfSaleMap
  }
}
    ${PointOfSaleMapFragmentDoc}`;

/**
 * __useGetSingleMapPosQuery__
 *
 * To run a query within a React component, call `useGetSingleMapPosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleMapPosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleMapPosQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSingleMapPosQuery(baseOptions: Apollo.QueryHookOptions<GetSingleMapPosQuery, GetSingleMapPosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleMapPosQuery, GetSingleMapPosQueryVariables>(GetSingleMapPosDocument, options);
      }
export function useGetSingleMapPosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleMapPosQuery, GetSingleMapPosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleMapPosQuery, GetSingleMapPosQueryVariables>(GetSingleMapPosDocument, options);
        }
export type GetSingleMapPosQueryHookResult = ReturnType<typeof useGetSingleMapPosQuery>;
export type GetSingleMapPosLazyQueryHookResult = ReturnType<typeof useGetSingleMapPosLazyQuery>;
export type GetSingleMapPosQueryResult = Apollo.QueryResult<GetSingleMapPosQuery, GetSingleMapPosQueryVariables>;
export const GetPosOverviewDocument = gql`
    query GetPosOverview($id: Int!) {
  pointOfSale(where: {id: $id}) {
    ...pointOfSaleOverview
  }
}
    ${PointOfSaleOverviewFragmentDoc}`;

/**
 * __useGetPosOverviewQuery__
 *
 * To run a query within a React component, call `useGetPosOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPosOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetPosOverviewQuery, GetPosOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosOverviewQuery, GetPosOverviewQueryVariables>(GetPosOverviewDocument, options);
      }
export function useGetPosOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosOverviewQuery, GetPosOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosOverviewQuery, GetPosOverviewQueryVariables>(GetPosOverviewDocument, options);
        }
export type GetPosOverviewQueryHookResult = ReturnType<typeof useGetPosOverviewQuery>;
export type GetPosOverviewLazyQueryHookResult = ReturnType<typeof useGetPosOverviewLazyQuery>;
export type GetPosOverviewQueryResult = Apollo.QueryResult<GetPosOverviewQuery, GetPosOverviewQueryVariables>;
export const GetPosMicroDocument = gql`
    query GetPosMicro($id: Int!) {
  pointOfSale(where: {id: $id}) {
    ...pointOfSaleMicro
  }
}
    ${PointOfSaleMicroFragmentDoc}`;

/**
 * __useGetPosMicroQuery__
 *
 * To run a query within a React component, call `useGetPosMicroQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosMicroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosMicroQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPosMicroQuery(baseOptions: Apollo.QueryHookOptions<GetPosMicroQuery, GetPosMicroQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosMicroQuery, GetPosMicroQueryVariables>(GetPosMicroDocument, options);
      }
export function useGetPosMicroLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosMicroQuery, GetPosMicroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosMicroQuery, GetPosMicroQueryVariables>(GetPosMicroDocument, options);
        }
export type GetPosMicroQueryHookResult = ReturnType<typeof useGetPosMicroQuery>;
export type GetPosMicroLazyQueryHookResult = ReturnType<typeof useGetPosMicroLazyQuery>;
export type GetPosMicroQueryResult = Apollo.QueryResult<GetPosMicroQuery, GetPosMicroQueryVariables>;
export const GetPosVolumeDocument = gql`
    query GetPosVolume($id: Int!) {
  pointOfSale(where: {id: $id}) {
    ...pointOfSaleVolume
  }
}
    ${PointOfSaleVolumeFragmentDoc}`;

/**
 * __useGetPosVolumeQuery__
 *
 * To run a query within a React component, call `useGetPosVolumeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosVolumeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosVolumeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPosVolumeQuery(baseOptions: Apollo.QueryHookOptions<GetPosVolumeQuery, GetPosVolumeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosVolumeQuery, GetPosVolumeQueryVariables>(GetPosVolumeDocument, options);
      }
export function useGetPosVolumeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosVolumeQuery, GetPosVolumeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosVolumeQuery, GetPosVolumeQueryVariables>(GetPosVolumeDocument, options);
        }
export type GetPosVolumeQueryHookResult = ReturnType<typeof useGetPosVolumeQuery>;
export type GetPosVolumeLazyQueryHookResult = ReturnType<typeof useGetPosVolumeLazyQuery>;
export type GetPosVolumeQueryResult = Apollo.QueryResult<GetPosVolumeQuery, GetPosVolumeQueryVariables>;
export const GetPosKpiDocument = gql`
    query GetPosKpi($id: Int!) {
  pointOfSale(where: {id: $id}) {
    ...pointOfSaleKPI
  }
}
    ${PointOfSaleKpiFragmentDoc}`;

/**
 * __useGetPosKpiQuery__
 *
 * To run a query within a React component, call `useGetPosKpiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosKpiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosKpiQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPosKpiQuery(baseOptions: Apollo.QueryHookOptions<GetPosKpiQuery, GetPosKpiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosKpiQuery, GetPosKpiQueryVariables>(GetPosKpiDocument, options);
      }
export function useGetPosKpiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosKpiQuery, GetPosKpiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosKpiQuery, GetPosKpiQueryVariables>(GetPosKpiDocument, options);
        }
export type GetPosKpiQueryHookResult = ReturnType<typeof useGetPosKpiQuery>;
export type GetPosKpiLazyQueryHookResult = ReturnType<typeof useGetPosKpiLazyQuery>;
export type GetPosKpiQueryResult = Apollo.QueryResult<GetPosKpiQuery, GetPosKpiQueryVariables>;
export const GetPosComplianceDocument = gql`
    query GetPosCompliance($id: Int!) {
  pointOfSale(where: {id: $id}) {
    beerCompliancePercentage
    waterCompliancePercentage
  }
}
    `;

/**
 * __useGetPosComplianceQuery__
 *
 * To run a query within a React component, call `useGetPosComplianceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosComplianceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosComplianceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPosComplianceQuery(baseOptions: Apollo.QueryHookOptions<GetPosComplianceQuery, GetPosComplianceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosComplianceQuery, GetPosComplianceQueryVariables>(GetPosComplianceDocument, options);
      }
export function useGetPosComplianceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosComplianceQuery, GetPosComplianceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosComplianceQuery, GetPosComplianceQueryVariables>(GetPosComplianceDocument, options);
        }
export type GetPosComplianceQueryHookResult = ReturnType<typeof useGetPosComplianceQuery>;
export type GetPosComplianceLazyQueryHookResult = ReturnType<typeof useGetPosComplianceLazyQuery>;
export type GetPosComplianceQueryResult = Apollo.QueryResult<GetPosComplianceQuery, GetPosComplianceQueryVariables>;
export const GetPointOfSalesDocument = gql`
    query GetPointOfSales($id: Int!) {
  pointOfSales(where: {id: {in: [$id]}}) {
    ...pointOfSaleMini
  }
}
    ${PointOfSaleMiniFragmentDoc}`;

/**
 * __useGetPointOfSalesQuery__
 *
 * To run a query within a React component, call `useGetPointOfSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointOfSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointOfSalesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPointOfSalesQuery(baseOptions: Apollo.QueryHookOptions<GetPointOfSalesQuery, GetPointOfSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointOfSalesQuery, GetPointOfSalesQueryVariables>(GetPointOfSalesDocument, options);
      }
export function useGetPointOfSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointOfSalesQuery, GetPointOfSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointOfSalesQuery, GetPointOfSalesQueryVariables>(GetPointOfSalesDocument, options);
        }
export type GetPointOfSalesQueryHookResult = ReturnType<typeof useGetPointOfSalesQuery>;
export type GetPointOfSalesLazyQueryHookResult = ReturnType<typeof useGetPointOfSalesLazyQuery>;
export type GetPointOfSalesQueryResult = Apollo.QueryResult<GetPointOfSalesQuery, GetPointOfSalesQueryVariables>;
export const GetPointOfSalesExternalDocument = gql`
    query GetPointOfSalesExternal($externalId: String!) {
  pointOfSales(where: {externalId: {in: [$externalId]}}) {
    ...pointOfSaleMini
  }
}
    ${PointOfSaleMiniFragmentDoc}`;

/**
 * __useGetPointOfSalesExternalQuery__
 *
 * To run a query within a React component, call `useGetPointOfSalesExternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointOfSalesExternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointOfSalesExternalQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *   },
 * });
 */
export function useGetPointOfSalesExternalQuery(baseOptions: Apollo.QueryHookOptions<GetPointOfSalesExternalQuery, GetPointOfSalesExternalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointOfSalesExternalQuery, GetPointOfSalesExternalQueryVariables>(GetPointOfSalesExternalDocument, options);
      }
export function useGetPointOfSalesExternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointOfSalesExternalQuery, GetPointOfSalesExternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointOfSalesExternalQuery, GetPointOfSalesExternalQueryVariables>(GetPointOfSalesExternalDocument, options);
        }
export type GetPointOfSalesExternalQueryHookResult = ReturnType<typeof useGetPointOfSalesExternalQuery>;
export type GetPointOfSalesExternalLazyQueryHookResult = ReturnType<typeof useGetPointOfSalesExternalLazyQuery>;
export type GetPointOfSalesExternalQueryResult = Apollo.QueryResult<GetPointOfSalesExternalQuery, GetPointOfSalesExternalQueryVariables>;
export const GetMultiplePointOfSalesDocument = gql`
    query GetMultiplePointOfSales($ids: [Int!]) {
  pointOfSales(where: {id: {in: $ids}}) {
    ...pointOfSaleMini
  }
}
    ${PointOfSaleMiniFragmentDoc}`;

/**
 * __useGetMultiplePointOfSalesQuery__
 *
 * To run a query within a React component, call `useGetMultiplePointOfSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMultiplePointOfSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMultiplePointOfSalesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetMultiplePointOfSalesQuery(baseOptions?: Apollo.QueryHookOptions<GetMultiplePointOfSalesQuery, GetMultiplePointOfSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMultiplePointOfSalesQuery, GetMultiplePointOfSalesQueryVariables>(GetMultiplePointOfSalesDocument, options);
      }
export function useGetMultiplePointOfSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMultiplePointOfSalesQuery, GetMultiplePointOfSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMultiplePointOfSalesQuery, GetMultiplePointOfSalesQueryVariables>(GetMultiplePointOfSalesDocument, options);
        }
export type GetMultiplePointOfSalesQueryHookResult = ReturnType<typeof useGetMultiplePointOfSalesQuery>;
export type GetMultiplePointOfSalesLazyQueryHookResult = ReturnType<typeof useGetMultiplePointOfSalesLazyQuery>;
export type GetMultiplePointOfSalesQueryResult = Apollo.QueryResult<GetMultiplePointOfSalesQuery, GetMultiplePointOfSalesQueryVariables>;
export const GetPointOfSalesTypesDocument = gql`
    query GetPointOfSalesTypes {
  pointOfSaleType {
    value
    label
  }
}
    `;

/**
 * __useGetPointOfSalesTypesQuery__
 *
 * To run a query within a React component, call `useGetPointOfSalesTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointOfSalesTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointOfSalesTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPointOfSalesTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetPointOfSalesTypesQuery, GetPointOfSalesTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointOfSalesTypesQuery, GetPointOfSalesTypesQueryVariables>(GetPointOfSalesTypesDocument, options);
      }
export function useGetPointOfSalesTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointOfSalesTypesQuery, GetPointOfSalesTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointOfSalesTypesQuery, GetPointOfSalesTypesQueryVariables>(GetPointOfSalesTypesDocument, options);
        }
export type GetPointOfSalesTypesQueryHookResult = ReturnType<typeof useGetPointOfSalesTypesQuery>;
export type GetPointOfSalesTypesLazyQueryHookResult = ReturnType<typeof useGetPointOfSalesTypesLazyQuery>;
export type GetPointOfSalesTypesQueryResult = Apollo.QueryResult<GetPointOfSalesTypesQuery, GetPointOfSalesTypesQueryVariables>;
export const GetPointOfSalesClassificationDocument = gql`
    query GetPointOfSalesClassification {
  pointOfSaleClassification {
    value
    label
  }
}
    `;

/**
 * __useGetPointOfSalesClassificationQuery__
 *
 * To run a query within a React component, call `useGetPointOfSalesClassificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointOfSalesClassificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointOfSalesClassificationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPointOfSalesClassificationQuery(baseOptions?: Apollo.QueryHookOptions<GetPointOfSalesClassificationQuery, GetPointOfSalesClassificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointOfSalesClassificationQuery, GetPointOfSalesClassificationQueryVariables>(GetPointOfSalesClassificationDocument, options);
      }
export function useGetPointOfSalesClassificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointOfSalesClassificationQuery, GetPointOfSalesClassificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointOfSalesClassificationQuery, GetPointOfSalesClassificationQueryVariables>(GetPointOfSalesClassificationDocument, options);
        }
export type GetPointOfSalesClassificationQueryHookResult = ReturnType<typeof useGetPointOfSalesClassificationQuery>;
export type GetPointOfSalesClassificationLazyQueryHookResult = ReturnType<typeof useGetPointOfSalesClassificationLazyQuery>;
export type GetPointOfSalesClassificationQueryResult = Apollo.QueryResult<GetPointOfSalesClassificationQuery, GetPointOfSalesClassificationQueryVariables>;
export const GetPointOfSaleListDocument = gql`
    query GetPointOfSaleList($skip: Int, $take: Int, $isOwner: Boolean, $search: [PointOfSaleWhereInput!], $segmentType: SegmentTypeFilter, $segment: SegmentFilter, $brandId: IntFilter, $rentabilibar: Boolean, $beerTAM: FloatFilter, $laLiga: Boolean, $underContract: Boolean, $isActive: Boolean, $and: [PointOfSaleWhereInput!], $soldProducts: SoldProductRelationFilter, $userLocation: UserLocationInput, $location: LocationWhereInput, $clientType: ClientTypeFilter, $lastVisitDate: DateFilter) {
  pointOfSales(
    where: {OR: $search, AND: $and, segmentType: $segmentType, segment: $segment, brandId: $brandId, rentabilibar: $rentabilibar, beerTAM: $beerTAM, laLiga: $laLiga, underContract: $underContract, isActive: $isActive, soldProducts: $soldProducts, location: $location, clientType: $clientType, lastVisitDate: $lastVisitDate}
    skip: $skip
    take: $take
    isOwner: $isOwner
    userLocation: $userLocation
  ) {
    ...pointOfSaleListItem
  }
}
    ${PointOfSaleListItemFragmentDoc}`;

/**
 * __useGetPointOfSaleListQuery__
 *
 * To run a query within a React component, call `useGetPointOfSaleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointOfSaleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointOfSaleListQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      isOwner: // value for 'isOwner'
 *      search: // value for 'search'
 *      segmentType: // value for 'segmentType'
 *      segment: // value for 'segment'
 *      brandId: // value for 'brandId'
 *      rentabilibar: // value for 'rentabilibar'
 *      beerTAM: // value for 'beerTAM'
 *      laLiga: // value for 'laLiga'
 *      underContract: // value for 'underContract'
 *      isActive: // value for 'isActive'
 *      and: // value for 'and'
 *      soldProducts: // value for 'soldProducts'
 *      userLocation: // value for 'userLocation'
 *      location: // value for 'location'
 *      clientType: // value for 'clientType'
 *      lastVisitDate: // value for 'lastVisitDate'
 *   },
 * });
 */
export function useGetPointOfSaleListQuery(baseOptions?: Apollo.QueryHookOptions<GetPointOfSaleListQuery, GetPointOfSaleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPointOfSaleListQuery, GetPointOfSaleListQueryVariables>(GetPointOfSaleListDocument, options);
      }
export function useGetPointOfSaleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPointOfSaleListQuery, GetPointOfSaleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPointOfSaleListQuery, GetPointOfSaleListQueryVariables>(GetPointOfSaleListDocument, options);
        }
export type GetPointOfSaleListQueryHookResult = ReturnType<typeof useGetPointOfSaleListQuery>;
export type GetPointOfSaleListLazyQueryHookResult = ReturnType<typeof useGetPointOfSaleListLazyQuery>;
export type GetPointOfSaleListQueryResult = Apollo.QueryResult<GetPointOfSaleListQuery, GetPointOfSaleListQueryVariables>;
export const CreatePointOfSaleSlidesDocument = gql`
    mutation createPointOfSaleSlides($pointOfSaleId: Int!, $type: [PointOfSaleSlideType!], $monthlyFiltres: MonthlyPointOfSaleVolumeCustomInput) {
  createPointOfSaleSlides(
    pointOfSaleId: $pointOfSaleId
    type: $type
    monthlyPointOfSaleVolumeCustomInput: $monthlyFiltres
  ) {
    ...pointOfSaleSlide
  }
}
    ${PointOfSaleSlideFragmentDoc}`;
export type CreatePointOfSaleSlidesMutationFn = Apollo.MutationFunction<CreatePointOfSaleSlidesMutation, CreatePointOfSaleSlidesMutationVariables>;

/**
 * __useCreatePointOfSaleSlidesMutation__
 *
 * To run a mutation, you first call `useCreatePointOfSaleSlidesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointOfSaleSlidesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointOfSaleSlidesMutation, { data, loading, error }] = useCreatePointOfSaleSlidesMutation({
 *   variables: {
 *      pointOfSaleId: // value for 'pointOfSaleId'
 *      type: // value for 'type'
 *      monthlyFiltres: // value for 'monthlyFiltres'
 *   },
 * });
 */
export function useCreatePointOfSaleSlidesMutation(baseOptions?: Apollo.MutationHookOptions<CreatePointOfSaleSlidesMutation, CreatePointOfSaleSlidesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePointOfSaleSlidesMutation, CreatePointOfSaleSlidesMutationVariables>(CreatePointOfSaleSlidesDocument, options);
      }
export type CreatePointOfSaleSlidesMutationHookResult = ReturnType<typeof useCreatePointOfSaleSlidesMutation>;
export type CreatePointOfSaleSlidesMutationResult = Apollo.MutationResult<CreatePointOfSaleSlidesMutation>;
export type CreatePointOfSaleSlidesMutationOptions = Apollo.BaseMutationOptions<CreatePointOfSaleSlidesMutation, CreatePointOfSaleSlidesMutationVariables>;
export const CreateNotBeerSlidesDocument = gql`
    mutation createNotBeerSlides($proposalId: Int!) {
  createNotBeerSlides(proposalId: $proposalId) {
    ...pointOfSaleSlide
  }
}
    ${PointOfSaleSlideFragmentDoc}`;
export type CreateNotBeerSlidesMutationFn = Apollo.MutationFunction<CreateNotBeerSlidesMutation, CreateNotBeerSlidesMutationVariables>;

/**
 * __useCreateNotBeerSlidesMutation__
 *
 * To run a mutation, you first call `useCreateNotBeerSlidesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotBeerSlidesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotBeerSlidesMutation, { data, loading, error }] = useCreateNotBeerSlidesMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCreateNotBeerSlidesMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotBeerSlidesMutation, CreateNotBeerSlidesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotBeerSlidesMutation, CreateNotBeerSlidesMutationVariables>(CreateNotBeerSlidesDocument, options);
      }
export type CreateNotBeerSlidesMutationHookResult = ReturnType<typeof useCreateNotBeerSlidesMutation>;
export type CreateNotBeerSlidesMutationResult = Apollo.MutationResult<CreateNotBeerSlidesMutation>;
export type CreateNotBeerSlidesMutationOptions = Apollo.BaseMutationOptions<CreateNotBeerSlidesMutation, CreateNotBeerSlidesMutationVariables>;
export const CreateNotBeerSlidesNewDocument = gql`
    mutation createNotBeerSlidesNew($proposalId: Int!) {
  createNotBeerSlidesNew(proposalId: $proposalId) {
    ...pointOfSaleSlideNew
  }
}
    ${PointOfSaleSlideNewFragmentDoc}`;
export type CreateNotBeerSlidesNewMutationFn = Apollo.MutationFunction<CreateNotBeerSlidesNewMutation, CreateNotBeerSlidesNewMutationVariables>;

/**
 * __useCreateNotBeerSlidesNewMutation__
 *
 * To run a mutation, you first call `useCreateNotBeerSlidesNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotBeerSlidesNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotBeerSlidesNewMutation, { data, loading, error }] = useCreateNotBeerSlidesNewMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCreateNotBeerSlidesNewMutation(baseOptions?: Apollo.MutationHookOptions<CreateNotBeerSlidesNewMutation, CreateNotBeerSlidesNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNotBeerSlidesNewMutation, CreateNotBeerSlidesNewMutationVariables>(CreateNotBeerSlidesNewDocument, options);
      }
export type CreateNotBeerSlidesNewMutationHookResult = ReturnType<typeof useCreateNotBeerSlidesNewMutation>;
export type CreateNotBeerSlidesNewMutationResult = Apollo.MutationResult<CreateNotBeerSlidesNewMutation>;
export type CreateNotBeerSlidesNewMutationOptions = Apollo.BaseMutationOptions<CreateNotBeerSlidesNewMutation, CreateNotBeerSlidesNewMutationVariables>;
export const UpdateProposalSlidesDocument = gql`
    mutation updateProposalSlides($proposalId: Int!, $slides: [ProposalSlideInput!]!) {
  updateProposalSlides(proposalId: $proposalId, slides: $slides) {
    id
  }
}
    `;
export type UpdateProposalSlidesMutationFn = Apollo.MutationFunction<UpdateProposalSlidesMutation, UpdateProposalSlidesMutationVariables>;

/**
 * __useUpdateProposalSlidesMutation__
 *
 * To run a mutation, you first call `useUpdateProposalSlidesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalSlidesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalSlidesMutation, { data, loading, error }] = useUpdateProposalSlidesMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      slides: // value for 'slides'
 *   },
 * });
 */
export function useUpdateProposalSlidesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalSlidesMutation, UpdateProposalSlidesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalSlidesMutation, UpdateProposalSlidesMutationVariables>(UpdateProposalSlidesDocument, options);
      }
export type UpdateProposalSlidesMutationHookResult = ReturnType<typeof useUpdateProposalSlidesMutation>;
export type UpdateProposalSlidesMutationResult = Apollo.MutationResult<UpdateProposalSlidesMutation>;
export type UpdateProposalSlidesMutationOptions = Apollo.BaseMutationOptions<UpdateProposalSlidesMutation, UpdateProposalSlidesMutationVariables>;
export const AddProposalProductsDocument = gql`
    mutation addProposalProducts($proposalId: Int!, $themeId: Int, $brandId: Int!, $products: [ProductIdAndType!]!) {
  addProposalProducts(
    proposalId: $proposalId
    themeId: $themeId
    brandId: $brandId
    products: $products
  ) {
    ...proposalSlide
  }
}
    ${ProposalSlideFragmentDoc}`;
export type AddProposalProductsMutationFn = Apollo.MutationFunction<AddProposalProductsMutation, AddProposalProductsMutationVariables>;

/**
 * __useAddProposalProductsMutation__
 *
 * To run a mutation, you first call `useAddProposalProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProposalProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProposalProductsMutation, { data, loading, error }] = useAddProposalProductsMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      themeId: // value for 'themeId'
 *      brandId: // value for 'brandId'
 *      products: // value for 'products'
 *   },
 * });
 */
export function useAddProposalProductsMutation(baseOptions?: Apollo.MutationHookOptions<AddProposalProductsMutation, AddProposalProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProposalProductsMutation, AddProposalProductsMutationVariables>(AddProposalProductsDocument, options);
      }
export type AddProposalProductsMutationHookResult = ReturnType<typeof useAddProposalProductsMutation>;
export type AddProposalProductsMutationResult = Apollo.MutationResult<AddProposalProductsMutation>;
export type AddProposalProductsMutationOptions = Apollo.BaseMutationOptions<AddProposalProductsMutation, AddProposalProductsMutationVariables>;
export const UpdateProposalProductsDocument = gql`
    mutation updateProposalProducts($kegBaseId: Int!, $themeId: Int, $proposalId: Int!, $products: [ProductIdAndType!]!) {
  updateProposalProducts(
    brandId: $kegBaseId
    themeId: $themeId
    proposalId: $proposalId
    products: $products
  ) {
    id
  }
}
    `;
export type UpdateProposalProductsMutationFn = Apollo.MutationFunction<UpdateProposalProductsMutation, UpdateProposalProductsMutationVariables>;

/**
 * __useUpdateProposalProductsMutation__
 *
 * To run a mutation, you first call `useUpdateProposalProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalProductsMutation, { data, loading, error }] = useUpdateProposalProductsMutation({
 *   variables: {
 *      kegBaseId: // value for 'kegBaseId'
 *      themeId: // value for 'themeId'
 *      proposalId: // value for 'proposalId'
 *      products: // value for 'products'
 *   },
 * });
 */
export function useUpdateProposalProductsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalProductsMutation, UpdateProposalProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalProductsMutation, UpdateProposalProductsMutationVariables>(UpdateProposalProductsDocument, options);
      }
export type UpdateProposalProductsMutationHookResult = ReturnType<typeof useUpdateProposalProductsMutation>;
export type UpdateProposalProductsMutationResult = Apollo.MutationResult<UpdateProposalProductsMutation>;
export type UpdateProposalProductsMutationOptions = Apollo.BaseMutationOptions<UpdateProposalProductsMutation, UpdateProposalProductsMutationVariables>;
export const CreatePointOfSaleVisitDocument = gql`
    mutation createPointOfSaleVisit($pointOfSaleId: Int!, $data: PointOfSaleVisitInput!) {
  createPointOfSaleVisit(where: {id: $pointOfSaleId}, data: $data)
}
    `;
export type CreatePointOfSaleVisitMutationFn = Apollo.MutationFunction<CreatePointOfSaleVisitMutation, CreatePointOfSaleVisitMutationVariables>;

/**
 * __useCreatePointOfSaleVisitMutation__
 *
 * To run a mutation, you first call `useCreatePointOfSaleVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePointOfSaleVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPointOfSaleVisitMutation, { data, loading, error }] = useCreatePointOfSaleVisitMutation({
 *   variables: {
 *      pointOfSaleId: // value for 'pointOfSaleId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePointOfSaleVisitMutation(baseOptions?: Apollo.MutationHookOptions<CreatePointOfSaleVisitMutation, CreatePointOfSaleVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePointOfSaleVisitMutation, CreatePointOfSaleVisitMutationVariables>(CreatePointOfSaleVisitDocument, options);
      }
export type CreatePointOfSaleVisitMutationHookResult = ReturnType<typeof useCreatePointOfSaleVisitMutation>;
export type CreatePointOfSaleVisitMutationResult = Apollo.MutationResult<CreatePointOfSaleVisitMutation>;
export type CreatePointOfSaleVisitMutationOptions = Apollo.BaseMutationOptions<CreatePointOfSaleVisitMutation, CreatePointOfSaleVisitMutationVariables>;
export const UpdatePointOfSaleVisitDocument = gql`
    mutation updatePointOfSaleVisit($visitExternalId: String!, $data: PointOfSaleVisitInput!) {
  updatePointOfSaleVisit(externalId: $visitExternalId, data: $data)
}
    `;
export type UpdatePointOfSaleVisitMutationFn = Apollo.MutationFunction<UpdatePointOfSaleVisitMutation, UpdatePointOfSaleVisitMutationVariables>;

/**
 * __useUpdatePointOfSaleVisitMutation__
 *
 * To run a mutation, you first call `useUpdatePointOfSaleVisitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePointOfSaleVisitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePointOfSaleVisitMutation, { data, loading, error }] = useUpdatePointOfSaleVisitMutation({
 *   variables: {
 *      visitExternalId: // value for 'visitExternalId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePointOfSaleVisitMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePointOfSaleVisitMutation, UpdatePointOfSaleVisitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePointOfSaleVisitMutation, UpdatePointOfSaleVisitMutationVariables>(UpdatePointOfSaleVisitDocument, options);
      }
export type UpdatePointOfSaleVisitMutationHookResult = ReturnType<typeof useUpdatePointOfSaleVisitMutation>;
export type UpdatePointOfSaleVisitMutationResult = Apollo.MutationResult<UpdatePointOfSaleVisitMutation>;
export type UpdatePointOfSaleVisitMutationOptions = Apollo.BaseMutationOptions<UpdatePointOfSaleVisitMutation, UpdatePointOfSaleVisitMutationVariables>;
export const PointOfSaleVisitsDocument = gql`
    query pointOfSaleVisits($externalId: String!, $startDate: DateFilter) {
  pointOfSaleVisits(where: {externalId: $externalId, startDate: $startDate}) {
    ...pointOfSaleVisit
  }
}
    ${PointOfSaleVisitFragmentDoc}`;

/**
 * __usePointOfSaleVisitsQuery__
 *
 * To run a query within a React component, call `usePointOfSaleVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfSaleVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfSaleVisitsQuery({
 *   variables: {
 *      externalId: // value for 'externalId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function usePointOfSaleVisitsQuery(baseOptions: Apollo.QueryHookOptions<PointOfSaleVisitsQuery, PointOfSaleVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfSaleVisitsQuery, PointOfSaleVisitsQueryVariables>(PointOfSaleVisitsDocument, options);
      }
export function usePointOfSaleVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfSaleVisitsQuery, PointOfSaleVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfSaleVisitsQuery, PointOfSaleVisitsQueryVariables>(PointOfSaleVisitsDocument, options);
        }
export type PointOfSaleVisitsQueryHookResult = ReturnType<typeof usePointOfSaleVisitsQuery>;
export type PointOfSaleVisitsLazyQueryHookResult = ReturnType<typeof usePointOfSaleVisitsLazyQuery>;
export type PointOfSaleVisitsQueryResult = Apollo.QueryResult<PointOfSaleVisitsQuery, PointOfSaleVisitsQueryVariables>;
export const PointOfSaleVisitWholesaleContactDocument = gql`
    query pointOfSaleVisitWholesaleContact($posId: Int!) {
  pointOfSaleVisitWholesaleContact(where: {id: $posId}) {
    label
    externalId: value
  }
}
    `;

/**
 * __usePointOfSaleVisitWholesaleContactQuery__
 *
 * To run a query within a React component, call `usePointOfSaleVisitWholesaleContactQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointOfSaleVisitWholesaleContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointOfSaleVisitWholesaleContactQuery({
 *   variables: {
 *      posId: // value for 'posId'
 *   },
 * });
 */
export function usePointOfSaleVisitWholesaleContactQuery(baseOptions: Apollo.QueryHookOptions<PointOfSaleVisitWholesaleContactQuery, PointOfSaleVisitWholesaleContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PointOfSaleVisitWholesaleContactQuery, PointOfSaleVisitWholesaleContactQueryVariables>(PointOfSaleVisitWholesaleContactDocument, options);
      }
export function usePointOfSaleVisitWholesaleContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PointOfSaleVisitWholesaleContactQuery, PointOfSaleVisitWholesaleContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PointOfSaleVisitWholesaleContactQuery, PointOfSaleVisitWholesaleContactQueryVariables>(PointOfSaleVisitWholesaleContactDocument, options);
        }
export type PointOfSaleVisitWholesaleContactQueryHookResult = ReturnType<typeof usePointOfSaleVisitWholesaleContactQuery>;
export type PointOfSaleVisitWholesaleContactLazyQueryHookResult = ReturnType<typeof usePointOfSaleVisitWholesaleContactLazyQuery>;
export type PointOfSaleVisitWholesaleContactQueryResult = Apollo.QueryResult<PointOfSaleVisitWholesaleContactQuery, PointOfSaleVisitWholesaleContactQueryVariables>;
export const GetProductsDocument = gql`
    query GetProducts($where: ProductsWhereInput, $take: Int, $skip: Int) {
  products(where: $where, take: $take, skip: $skip) {
    ...product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetProductsWithPricesDocument = gql`
    query GetProductsWithPrices($where: ProductsWhereInput, $take: Int, $skip: Int, $pointOfSaleId: Float, $provinceNumber: Int) {
  products(where: $where, take: $take, skip: $skip) {
    ...productWithPrices
  }
}
    ${ProductWithPricesFragmentDoc}`;

/**
 * __useGetProductsWithPricesQuery__
 *
 * To run a query within a React component, call `useGetProductsWithPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsWithPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsWithPricesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      pointOfSaleId: // value for 'pointOfSaleId'
 *      provinceNumber: // value for 'provinceNumber'
 *   },
 * });
 */
export function useGetProductsWithPricesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsWithPricesQuery, GetProductsWithPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsWithPricesQuery, GetProductsWithPricesQueryVariables>(GetProductsWithPricesDocument, options);
      }
export function useGetProductsWithPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsWithPricesQuery, GetProductsWithPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsWithPricesQuery, GetProductsWithPricesQueryVariables>(GetProductsWithPricesDocument, options);
        }
export type GetProductsWithPricesQueryHookResult = ReturnType<typeof useGetProductsWithPricesQuery>;
export type GetProductsWithPricesLazyQueryHookResult = ReturnType<typeof useGetProductsWithPricesLazyQuery>;
export type GetProductsWithPricesQueryResult = Apollo.QueryResult<GetProductsWithPricesQuery, GetProductsWithPricesQueryVariables>;
export const GetProductDocument = gql`
    query GetProduct($id: Int!, $name: String, $take: Int, $skip: Int) {
  products(
    where: {id: {in: [$id]}, name: {contains: $name}}
    take: $take
    skip: $skip
  ) {
    ...product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export const GetProductWithPriceDocument = gql`
    query GetProductWithPrice($id: Int!, $name: String, $take: Int, $skip: Int, $pointOfSaleId: Float, $provinceNumber: Int) {
  products(
    where: {id: {in: [$id]}, name: {contains: $name}}
    take: $take
    skip: $skip
  ) {
    ...productWithPrices
  }
}
    ${ProductWithPricesFragmentDoc}`;

/**
 * __useGetProductWithPriceQuery__
 *
 * To run a query within a React component, call `useGetProductWithPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductWithPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductWithPriceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      pointOfSaleId: // value for 'pointOfSaleId'
 *      provinceNumber: // value for 'provinceNumber'
 *   },
 * });
 */
export function useGetProductWithPriceQuery(baseOptions: Apollo.QueryHookOptions<GetProductWithPriceQuery, GetProductWithPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductWithPriceQuery, GetProductWithPriceQueryVariables>(GetProductWithPriceDocument, options);
      }
export function useGetProductWithPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductWithPriceQuery, GetProductWithPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductWithPriceQuery, GetProductWithPriceQueryVariables>(GetProductWithPriceDocument, options);
        }
export type GetProductWithPriceQueryHookResult = ReturnType<typeof useGetProductWithPriceQuery>;
export type GetProductWithPriceLazyQueryHookResult = ReturnType<typeof useGetProductWithPriceLazyQuery>;
export type GetProductWithPriceQueryResult = Apollo.QueryResult<GetProductWithPriceQuery, GetProductWithPriceQueryVariables>;
export const GetProductsWithPriceDocument = gql`
    query GetProductsWithPrice($ids: [Int!], $name: String, $take: Int, $skip: Int, $pointOfSaleId: Float, $provinceNumber: Int) {
  products(
    where: {id: {in: $ids}, name: {contains: $name}}
    take: $take
    skip: $skip
  ) {
    ...productWithPrices
  }
}
    ${ProductWithPricesFragmentDoc}`;

/**
 * __useGetProductsWithPriceQuery__
 *
 * To run a query within a React component, call `useGetProductsWithPriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsWithPriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsWithPriceQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      name: // value for 'name'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      pointOfSaleId: // value for 'pointOfSaleId'
 *      provinceNumber: // value for 'provinceNumber'
 *   },
 * });
 */
export function useGetProductsWithPriceQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsWithPriceQuery, GetProductsWithPriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsWithPriceQuery, GetProductsWithPriceQueryVariables>(GetProductsWithPriceDocument, options);
      }
export function useGetProductsWithPriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsWithPriceQuery, GetProductsWithPriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsWithPriceQuery, GetProductsWithPriceQueryVariables>(GetProductsWithPriceDocument, options);
        }
export type GetProductsWithPriceQueryHookResult = ReturnType<typeof useGetProductsWithPriceQuery>;
export type GetProductsWithPriceLazyQueryHookResult = ReturnType<typeof useGetProductsWithPriceLazyQuery>;
export type GetProductsWithPriceQueryResult = Apollo.QueryResult<GetProductsWithPriceQuery, GetProductsWithPriceQueryVariables>;
export const GetMiniProductsWithCategoryDocument = gql`
    query GetMiniProductsWithCategory($ids: [Int!]) {
  products(where: {id: {in: $ids}}) {
    ...miniProductWithCategory
  }
}
    ${MiniProductWithCategoryFragmentDoc}`;

/**
 * __useGetMiniProductsWithCategoryQuery__
 *
 * To run a query within a React component, call `useGetMiniProductsWithCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiniProductsWithCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiniProductsWithCategoryQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetMiniProductsWithCategoryQuery(baseOptions?: Apollo.QueryHookOptions<GetMiniProductsWithCategoryQuery, GetMiniProductsWithCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMiniProductsWithCategoryQuery, GetMiniProductsWithCategoryQueryVariables>(GetMiniProductsWithCategoryDocument, options);
      }
export function useGetMiniProductsWithCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMiniProductsWithCategoryQuery, GetMiniProductsWithCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMiniProductsWithCategoryQuery, GetMiniProductsWithCategoryQueryVariables>(GetMiniProductsWithCategoryDocument, options);
        }
export type GetMiniProductsWithCategoryQueryHookResult = ReturnType<typeof useGetMiniProductsWithCategoryQuery>;
export type GetMiniProductsWithCategoryLazyQueryHookResult = ReturnType<typeof useGetMiniProductsWithCategoryLazyQuery>;
export type GetMiniProductsWithCategoryQueryResult = Apollo.QueryResult<GetMiniProductsWithCategoryQuery, GetMiniProductsWithCategoryQueryVariables>;
export const GetProductsWithoutSlidesDocument = gql`
    query GetProductsWithoutSlides($where: ProductsWhereInput) {
  products(where: $where) {
    ...productWithoutSlide
  }
}
    ${ProductWithoutSlideFragmentDoc}`;

/**
 * __useGetProductsWithoutSlidesQuery__
 *
 * To run a query within a React component, call `useGetProductsWithoutSlidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsWithoutSlidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsWithoutSlidesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetProductsWithoutSlidesQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsWithoutSlidesQuery, GetProductsWithoutSlidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsWithoutSlidesQuery, GetProductsWithoutSlidesQueryVariables>(GetProductsWithoutSlidesDocument, options);
      }
export function useGetProductsWithoutSlidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsWithoutSlidesQuery, GetProductsWithoutSlidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsWithoutSlidesQuery, GetProductsWithoutSlidesQueryVariables>(GetProductsWithoutSlidesDocument, options);
        }
export type GetProductsWithoutSlidesQueryHookResult = ReturnType<typeof useGetProductsWithoutSlidesQuery>;
export type GetProductsWithoutSlidesLazyQueryHookResult = ReturnType<typeof useGetProductsWithoutSlidesLazyQuery>;
export type GetProductsWithoutSlidesQueryResult = Apollo.QueryResult<GetProductsWithoutSlidesQuery, GetProductsWithoutSlidesQueryVariables>;
export const UpsertSpecialOffersDocument = gql`
    mutation UpsertSpecialOffers($proposalId: Int!, $specialOffers: [UpsertSpecialOfferInput!]!) {
  upsertSpecialOffers(proposalId: $proposalId, specialOffers: $specialOffers) {
    ...proposalSlide
  }
}
    ${ProposalSlideFragmentDoc}`;
export type UpsertSpecialOffersMutationFn = Apollo.MutationFunction<UpsertSpecialOffersMutation, UpsertSpecialOffersMutationVariables>;

/**
 * __useUpsertSpecialOffersMutation__
 *
 * To run a mutation, you first call `useUpsertSpecialOffersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSpecialOffersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSpecialOffersMutation, { data, loading, error }] = useUpsertSpecialOffersMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      specialOffers: // value for 'specialOffers'
 *   },
 * });
 */
export function useUpsertSpecialOffersMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSpecialOffersMutation, UpsertSpecialOffersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSpecialOffersMutation, UpsertSpecialOffersMutationVariables>(UpsertSpecialOffersDocument, options);
      }
export type UpsertSpecialOffersMutationHookResult = ReturnType<typeof useUpsertSpecialOffersMutation>;
export type UpsertSpecialOffersMutationResult = Apollo.MutationResult<UpsertSpecialOffersMutation>;
export type UpsertSpecialOffersMutationOptions = Apollo.BaseMutationOptions<UpsertSpecialOffersMutation, UpsertSpecialOffersMutationVariables>;
export const UpdateProposalDocument = gql`
    mutation updateProposal($id: Int!, $data: UpdateProposalDataInput!) {
  updateProposal(id: $id, data: $data) {
    ...proposal
  }
}
    ${ProposalFragmentDoc}`;
export type UpdateProposalMutationFn = Apollo.MutationFunction<UpdateProposalMutation, UpdateProposalMutationVariables>;

/**
 * __useUpdateProposalMutation__
 *
 * To run a mutation, you first call `useUpdateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalMutation, { data, loading, error }] = useUpdateProposalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateProposalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalMutation, UpdateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalMutation, UpdateProposalMutationVariables>(UpdateProposalDocument, options);
      }
export type UpdateProposalMutationHookResult = ReturnType<typeof useUpdateProposalMutation>;
export type UpdateProposalMutationResult = Apollo.MutationResult<UpdateProposalMutation>;
export type UpdateProposalMutationOptions = Apollo.BaseMutationOptions<UpdateProposalMutation, UpdateProposalMutationVariables>;
export const UpdateManyProposalsDocument = gql`
    mutation updateManyProposals($where: WhereManyProposalInput!, $data: UpdateProposalDataInput!) {
  updateManyProposals(where: $where, data: $data) {
    count
  }
}
    `;
export type UpdateManyProposalsMutationFn = Apollo.MutationFunction<UpdateManyProposalsMutation, UpdateManyProposalsMutationVariables>;

/**
 * __useUpdateManyProposalsMutation__
 *
 * To run a mutation, you first call `useUpdateManyProposalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManyProposalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManyProposalsMutation, { data, loading, error }] = useUpdateManyProposalsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateManyProposalsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManyProposalsMutation, UpdateManyProposalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManyProposalsMutation, UpdateManyProposalsMutationVariables>(UpdateManyProposalsDocument, options);
      }
export type UpdateManyProposalsMutationHookResult = ReturnType<typeof useUpdateManyProposalsMutation>;
export type UpdateManyProposalsMutationResult = Apollo.MutationResult<UpdateManyProposalsMutation>;
export type UpdateManyProposalsMutationOptions = Apollo.BaseMutationOptions<UpdateManyProposalsMutation, UpdateManyProposalsMutationVariables>;
export const GetAllProposalsDocument = gql`
    query GetAllProposals {
  proposals {
    ...proposal
  }
}
    ${ProposalFragmentDoc}`;

/**
 * __useGetAllProposalsQuery__
 *
 * To run a query within a React component, call `useGetAllProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProposalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllProposalsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllProposalsQuery, GetAllProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProposalsQuery, GetAllProposalsQueryVariables>(GetAllProposalsDocument, options);
      }
export function useGetAllProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProposalsQuery, GetAllProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProposalsQuery, GetAllProposalsQueryVariables>(GetAllProposalsDocument, options);
        }
export type GetAllProposalsQueryHookResult = ReturnType<typeof useGetAllProposalsQuery>;
export type GetAllProposalsLazyQueryHookResult = ReturnType<typeof useGetAllProposalsLazyQuery>;
export type GetAllProposalsQueryResult = Apollo.QueryResult<GetAllProposalsQuery, GetAllProposalsQueryVariables>;
export const GetMeProposalsDocument = gql`
    query GetMeProposals($state: ProposalStates) {
  proposals(where: {state: $state}) {
    ...proposal
  }
}
    ${ProposalFragmentDoc}`;

/**
 * __useGetMeProposalsQuery__
 *
 * To run a query within a React component, call `useGetMeProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeProposalsQuery({
 *   variables: {
 *      state: // value for 'state'
 *   },
 * });
 */
export function useGetMeProposalsQuery(baseOptions?: Apollo.QueryHookOptions<GetMeProposalsQuery, GetMeProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeProposalsQuery, GetMeProposalsQueryVariables>(GetMeProposalsDocument, options);
      }
export function useGetMeProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeProposalsQuery, GetMeProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeProposalsQuery, GetMeProposalsQueryVariables>(GetMeProposalsDocument, options);
        }
export type GetMeProposalsQueryHookResult = ReturnType<typeof useGetMeProposalsQuery>;
export type GetMeProposalsLazyQueryHookResult = ReturnType<typeof useGetMeProposalsLazyQuery>;
export type GetMeProposalsQueryResult = Apollo.QueryResult<GetMeProposalsQuery, GetMeProposalsQueryVariables>;
export const GetPosProposalsDocument = gql`
    query GetPOSProposals($take: Int, $skip: Int, $where: WhereManyProposalInput) {
  proposals(where: $where, take: $take, skip: $skip) {
    ...proposal
  }
}
    ${ProposalFragmentDoc}`;

/**
 * __useGetPosProposalsQuery__
 *
 * To run a query within a React component, call `useGetPosProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosProposalsQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetPosProposalsQuery(baseOptions?: Apollo.QueryHookOptions<GetPosProposalsQuery, GetPosProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosProposalsQuery, GetPosProposalsQueryVariables>(GetPosProposalsDocument, options);
      }
export function useGetPosProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosProposalsQuery, GetPosProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosProposalsQuery, GetPosProposalsQueryVariables>(GetPosProposalsDocument, options);
        }
export type GetPosProposalsQueryHookResult = ReturnType<typeof useGetPosProposalsQuery>;
export type GetPosProposalsLazyQueryHookResult = ReturnType<typeof useGetPosProposalsLazyQuery>;
export type GetPosProposalsQueryResult = Apollo.QueryResult<GetPosProposalsQuery, GetPosProposalsQueryVariables>;
export const GetProposalsWithSherpaDocument = gql`
    query GetProposalsWithSherpa($sherpaExternalId: String!) {
  proposals(where: {sherpaExternalId: {in: [$sherpaExternalId]}}) {
    ...proposal
  }
}
    ${ProposalFragmentDoc}`;

/**
 * __useGetProposalsWithSherpaQuery__
 *
 * To run a query within a React component, call `useGetProposalsWithSherpaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalsWithSherpaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalsWithSherpaQuery({
 *   variables: {
 *      sherpaExternalId: // value for 'sherpaExternalId'
 *   },
 * });
 */
export function useGetProposalsWithSherpaQuery(baseOptions: Apollo.QueryHookOptions<GetProposalsWithSherpaQuery, GetProposalsWithSherpaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalsWithSherpaQuery, GetProposalsWithSherpaQueryVariables>(GetProposalsWithSherpaDocument, options);
      }
export function useGetProposalsWithSherpaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalsWithSherpaQuery, GetProposalsWithSherpaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalsWithSherpaQuery, GetProposalsWithSherpaQueryVariables>(GetProposalsWithSherpaDocument, options);
        }
export type GetProposalsWithSherpaQueryHookResult = ReturnType<typeof useGetProposalsWithSherpaQuery>;
export type GetProposalsWithSherpaLazyQueryHookResult = ReturnType<typeof useGetProposalsWithSherpaLazyQuery>;
export type GetProposalsWithSherpaQueryResult = Apollo.QueryResult<GetProposalsWithSherpaQuery, GetProposalsWithSherpaQueryVariables>;
export const GetProposalByIdDocument = gql`
    query GetProposalById($where: WhereProposalInput!) {
  proposal(where: $where) {
    ...proposal
  }
}
    ${ProposalFragmentDoc}`;

/**
 * __useGetProposalByIdQuery__
 *
 * To run a query within a React component, call `useGetProposalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalByIdQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetProposalByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProposalByIdQuery, GetProposalByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalByIdQuery, GetProposalByIdQueryVariables>(GetProposalByIdDocument, options);
      }
export function useGetProposalByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalByIdQuery, GetProposalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalByIdQuery, GetProposalByIdQueryVariables>(GetProposalByIdDocument, options);
        }
export type GetProposalByIdQueryHookResult = ReturnType<typeof useGetProposalByIdQuery>;
export type GetProposalByIdLazyQueryHookResult = ReturnType<typeof useGetProposalByIdLazyQuery>;
export type GetProposalByIdQueryResult = Apollo.QueryResult<GetProposalByIdQuery, GetProposalByIdQueryVariables>;
export const GetPosProposalsLastDocument = gql`
    query GetPOSProposalsLast($posIds: [Int!], $take: Int, $skip: Int) {
  proposals(where: {pointOfSaleId: {in: $posIds}}, take: $take, skip: $skip) {
    ...proposal
  }
}
    ${ProposalFragmentDoc}`;

/**
 * __useGetPosProposalsLastQuery__
 *
 * To run a query within a React component, call `useGetPosProposalsLastQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosProposalsLastQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosProposalsLastQuery({
 *   variables: {
 *      posIds: // value for 'posIds'
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetPosProposalsLastQuery(baseOptions?: Apollo.QueryHookOptions<GetPosProposalsLastQuery, GetPosProposalsLastQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosProposalsLastQuery, GetPosProposalsLastQueryVariables>(GetPosProposalsLastDocument, options);
      }
export function useGetPosProposalsLastLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosProposalsLastQuery, GetPosProposalsLastQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosProposalsLastQuery, GetPosProposalsLastQueryVariables>(GetPosProposalsLastDocument, options);
        }
export type GetPosProposalsLastQueryHookResult = ReturnType<typeof useGetPosProposalsLastQuery>;
export type GetPosProposalsLastLazyQueryHookResult = ReturnType<typeof useGetPosProposalsLastLazyQuery>;
export type GetPosProposalsLastQueryResult = Apollo.QueryResult<GetPosProposalsLastQuery, GetPosProposalsLastQueryVariables>;
export const GetProposalInformationDocument = gql`
    query GetProposalInformation($proposalId: Int!) {
  proposal(where: {id: $proposalId}) {
    ...proposalInfo
  }
}
    ${ProposalInfoFragmentDoc}`;

/**
 * __useGetProposalInformationQuery__
 *
 * To run a query within a React component, call `useGetProposalInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalInformationQuery({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useGetProposalInformationQuery(baseOptions: Apollo.QueryHookOptions<GetProposalInformationQuery, GetProposalInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalInformationQuery, GetProposalInformationQueryVariables>(GetProposalInformationDocument, options);
      }
export function useGetProposalInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalInformationQuery, GetProposalInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalInformationQuery, GetProposalInformationQueryVariables>(GetProposalInformationDocument, options);
        }
export type GetProposalInformationQueryHookResult = ReturnType<typeof useGetProposalInformationQuery>;
export type GetProposalInformationLazyQueryHookResult = ReturnType<typeof useGetProposalInformationLazyQuery>;
export type GetProposalInformationQueryResult = Apollo.QueryResult<GetProposalInformationQuery, GetProposalInformationQueryVariables>;
export const GetProposalsCountDocument = gql`
    query GetProposalsCount($where: WhereManyProposalInput, $take: Int) {
  proposalsCount(where: $where, take: $take)
}
    `;

/**
 * __useGetProposalsCountQuery__
 *
 * To run a query within a React component, call `useGetProposalsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalsCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetProposalsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetProposalsCountQuery, GetProposalsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalsCountQuery, GetProposalsCountQueryVariables>(GetProposalsCountDocument, options);
      }
export function useGetProposalsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalsCountQuery, GetProposalsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalsCountQuery, GetProposalsCountQueryVariables>(GetProposalsCountDocument, options);
        }
export type GetProposalsCountQueryHookResult = ReturnType<typeof useGetProposalsCountQuery>;
export type GetProposalsCountLazyQueryHookResult = ReturnType<typeof useGetProposalsCountLazyQuery>;
export type GetProposalsCountQueryResult = Apollo.QueryResult<GetProposalsCountQuery, GetProposalsCountQueryVariables>;
export const CreateProposalDocument = gql`
    mutation createProposal($title: String!, $pointOfSaleId: Int, $displayedTitle: String, $expireAt: DateTime!, $provinceNumber: Int, $isShortProposal: Boolean!, $sherpaExternalId: String) {
  createProposal(
    pointOfSaleId: $pointOfSaleId
    displayedTitle: $displayedTitle
    title: $title
    expireAt: $expireAt
    provinceNumber: $provinceNumber
    isShortProposal: $isShortProposal
    sherpaExternalId: $sherpaExternalId
  ) {
    id
    pointOfSaleId
    createdAt
    updatedAt
    state
  }
}
    `;
export type CreateProposalMutationFn = Apollo.MutationFunction<CreateProposalMutation, CreateProposalMutationVariables>;

/**
 * __useCreateProposalMutation__
 *
 * To run a mutation, you first call `useCreateProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProposalMutation, { data, loading, error }] = useCreateProposalMutation({
 *   variables: {
 *      title: // value for 'title'
 *      pointOfSaleId: // value for 'pointOfSaleId'
 *      displayedTitle: // value for 'displayedTitle'
 *      expireAt: // value for 'expireAt'
 *      provinceNumber: // value for 'provinceNumber'
 *      isShortProposal: // value for 'isShortProposal'
 *      sherpaExternalId: // value for 'sherpaExternalId'
 *   },
 * });
 */
export function useCreateProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateProposalMutation, CreateProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProposalMutation, CreateProposalMutationVariables>(CreateProposalDocument, options);
      }
export type CreateProposalMutationHookResult = ReturnType<typeof useCreateProposalMutation>;
export type CreateProposalMutationResult = Apollo.MutationResult<CreateProposalMutation>;
export type CreateProposalMutationOptions = Apollo.BaseMutationOptions<CreateProposalMutation, CreateProposalMutationVariables>;
export const CreateProposalMediasDocument = gql`
    mutation createProposalMedias($proposalId: Int!) {
  generateProposalPdf(where: {id: $proposalId}) {
    ...shortProposal
    pdf {
      ...media
    }
    pptx {
      ...media
    }
  }
}
    ${ShortProposalFragmentDoc}
${MediaFragmentDoc}`;
export type CreateProposalMediasMutationFn = Apollo.MutationFunction<CreateProposalMediasMutation, CreateProposalMediasMutationVariables>;

/**
 * __useCreateProposalMediasMutation__
 *
 * To run a mutation, you first call `useCreateProposalMediasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProposalMediasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProposalMediasMutation, { data, loading, error }] = useCreateProposalMediasMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *   },
 * });
 */
export function useCreateProposalMediasMutation(baseOptions?: Apollo.MutationHookOptions<CreateProposalMediasMutation, CreateProposalMediasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProposalMediasMutation, CreateProposalMediasMutationVariables>(CreateProposalMediasDocument, options);
      }
export type CreateProposalMediasMutationHookResult = ReturnType<typeof useCreateProposalMediasMutation>;
export type CreateProposalMediasMutationResult = Apollo.MutationResult<CreateProposalMediasMutation>;
export type CreateProposalMediasMutationOptions = Apollo.BaseMutationOptions<CreateProposalMediasMutation, CreateProposalMediasMutationVariables>;
export const CreateShortProposalDocument = gql`
    mutation createShortProposal($pointOfSaleId: Int, $provinceNumber: Int, $displayedTitle: String, $products: [ShortProposalProductInput!]!, $isDirectBilling: Boolean!, $isTankDirectBilling: Boolean, $specialOffers: [UpsertSpecialOfferInput!]) {
  createShortProposal(
    pointOfSaleId: $pointOfSaleId
    provinceNumber: $provinceNumber
    displayedTitle: $displayedTitle
    products: $products
    isDirectBilling: $isDirectBilling
    isTankDirectBilling: $isTankDirectBilling
    specialOffers: $specialOffers
  ) {
    ...shortProposal
  }
}
    ${ShortProposalFragmentDoc}`;
export type CreateShortProposalMutationFn = Apollo.MutationFunction<CreateShortProposalMutation, CreateShortProposalMutationVariables>;

/**
 * __useCreateShortProposalMutation__
 *
 * To run a mutation, you first call `useCreateShortProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShortProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShortProposalMutation, { data, loading, error }] = useCreateShortProposalMutation({
 *   variables: {
 *      pointOfSaleId: // value for 'pointOfSaleId'
 *      provinceNumber: // value for 'provinceNumber'
 *      displayedTitle: // value for 'displayedTitle'
 *      products: // value for 'products'
 *      isDirectBilling: // value for 'isDirectBilling'
 *      isTankDirectBilling: // value for 'isTankDirectBilling'
 *      specialOffers: // value for 'specialOffers'
 *   },
 * });
 */
export function useCreateShortProposalMutation(baseOptions?: Apollo.MutationHookOptions<CreateShortProposalMutation, CreateShortProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShortProposalMutation, CreateShortProposalMutationVariables>(CreateShortProposalDocument, options);
      }
export type CreateShortProposalMutationHookResult = ReturnType<typeof useCreateShortProposalMutation>;
export type CreateShortProposalMutationResult = Apollo.MutationResult<CreateShortProposalMutation>;
export type CreateShortProposalMutationOptions = Apollo.BaseMutationOptions<CreateShortProposalMutation, CreateShortProposalMutationVariables>;
export const GetProposalThemeDocument = gql`
    query GetProposalTheme($where: AdminProposalThemesWhereInput, $orderBy: AdminProposalThemeOrderByWithRelationInput) {
  proposalThemes(where: $where, orderBy: $orderBy) {
    id
    order
    name
    brandId
    firstSlideImageId
  }
}
    `;

/**
 * __useGetProposalThemeQuery__
 *
 * To run a query within a React component, call `useGetProposalThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalThemeQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetProposalThemeQuery(baseOptions?: Apollo.QueryHookOptions<GetProposalThemeQuery, GetProposalThemeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalThemeQuery, GetProposalThemeQueryVariables>(GetProposalThemeDocument, options);
      }
export function useGetProposalThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalThemeQuery, GetProposalThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalThemeQuery, GetProposalThemeQueryVariables>(GetProposalThemeDocument, options);
        }
export type GetProposalThemeQueryHookResult = ReturnType<typeof useGetProposalThemeQuery>;
export type GetProposalThemeLazyQueryHookResult = ReturnType<typeof useGetProposalThemeLazyQuery>;
export type GetProposalThemeQueryResult = Apollo.QueryResult<GetProposalThemeQuery, GetProposalThemeQueryVariables>;
export const GetProvincesDocument = gql`
    query GetProvinces($take: Int) {
  provinces(take: $take) {
    ...province
  }
}
    ${ProvinceFragmentDoc}`;

/**
 * __useGetProvincesQuery__
 *
 * To run a query within a React component, call `useGetProvincesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProvincesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProvincesQuery({
 *   variables: {
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetProvincesQuery(baseOptions?: Apollo.QueryHookOptions<GetProvincesQuery, GetProvincesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProvincesQuery, GetProvincesQueryVariables>(GetProvincesDocument, options);
      }
export function useGetProvincesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProvincesQuery, GetProvincesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProvincesQuery, GetProvincesQueryVariables>(GetProvincesDocument, options);
        }
export type GetProvincesQueryHookResult = ReturnType<typeof useGetProvincesQuery>;
export type GetProvincesLazyQueryHookResult = ReturnType<typeof useGetProvincesLazyQuery>;
export type GetProvincesQueryResult = Apollo.QueryResult<GetProvincesQuery, GetProvincesQueryVariables>;
export const GetRecommendedAssortmentDocument = gql`
    query GetRecommendedAssortment($id: Int!) {
  recommendedAssortment(pointOfSaleId: $id) {
    ...recommendedPackagedProduct
  }
}
    ${RecommendedPackagedProductFragmentDoc}`;

/**
 * __useGetRecommendedAssortmentQuery__
 *
 * To run a query within a React component, call `useGetRecommendedAssortmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedAssortmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedAssortmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRecommendedAssortmentQuery(baseOptions: Apollo.QueryHookOptions<GetRecommendedAssortmentQuery, GetRecommendedAssortmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecommendedAssortmentQuery, GetRecommendedAssortmentQueryVariables>(GetRecommendedAssortmentDocument, options);
      }
export function useGetRecommendedAssortmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecommendedAssortmentQuery, GetRecommendedAssortmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecommendedAssortmentQuery, GetRecommendedAssortmentQueryVariables>(GetRecommendedAssortmentDocument, options);
        }
export type GetRecommendedAssortmentQueryHookResult = ReturnType<typeof useGetRecommendedAssortmentQuery>;
export type GetRecommendedAssortmentLazyQueryHookResult = ReturnType<typeof useGetRecommendedAssortmentLazyQuery>;
export type GetRecommendedAssortmentQueryResult = Apollo.QueryResult<GetRecommendedAssortmentQuery, GetRecommendedAssortmentQueryVariables>;
export const RecommendedAssortmentBatchExecutionDocument = gql`
    query recommendedAssortmentBatchExecution {
  recommendedAssortmentBatchExecution {
    date
  }
}
    `;

/**
 * __useRecommendedAssortmentBatchExecutionQuery__
 *
 * To run a query within a React component, call `useRecommendedAssortmentBatchExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedAssortmentBatchExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedAssortmentBatchExecutionQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedAssortmentBatchExecutionQuery(baseOptions?: Apollo.QueryHookOptions<RecommendedAssortmentBatchExecutionQuery, RecommendedAssortmentBatchExecutionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedAssortmentBatchExecutionQuery, RecommendedAssortmentBatchExecutionQueryVariables>(RecommendedAssortmentBatchExecutionDocument, options);
      }
export function useRecommendedAssortmentBatchExecutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedAssortmentBatchExecutionQuery, RecommendedAssortmentBatchExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedAssortmentBatchExecutionQuery, RecommendedAssortmentBatchExecutionQueryVariables>(RecommendedAssortmentBatchExecutionDocument, options);
        }
export type RecommendedAssortmentBatchExecutionQueryHookResult = ReturnType<typeof useRecommendedAssortmentBatchExecutionQuery>;
export type RecommendedAssortmentBatchExecutionLazyQueryHookResult = ReturnType<typeof useRecommendedAssortmentBatchExecutionLazyQuery>;
export type RecommendedAssortmentBatchExecutionQueryResult = Apollo.QueryResult<RecommendedAssortmentBatchExecutionQuery, RecommendedAssortmentBatchExecutionQueryVariables>;
export const GetReleaseNoteDocument = gql`
    query GetReleaseNote($where: ReleaseNoteWhereUniqueInput!) {
  releaseNote(where: $where) {
    id
    version
    content
    title
  }
}
    `;

/**
 * __useGetReleaseNoteQuery__
 *
 * To run a query within a React component, call `useGetReleaseNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReleaseNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReleaseNoteQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetReleaseNoteQuery(baseOptions: Apollo.QueryHookOptions<GetReleaseNoteQuery, GetReleaseNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReleaseNoteQuery, GetReleaseNoteQueryVariables>(GetReleaseNoteDocument, options);
      }
export function useGetReleaseNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReleaseNoteQuery, GetReleaseNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReleaseNoteQuery, GetReleaseNoteQueryVariables>(GetReleaseNoteDocument, options);
        }
export type GetReleaseNoteQueryHookResult = ReturnType<typeof useGetReleaseNoteQuery>;
export type GetReleaseNoteLazyQueryHookResult = ReturnType<typeof useGetReleaseNoteLazyQuery>;
export type GetReleaseNoteQueryResult = Apollo.QueryResult<GetReleaseNoteQuery, GetReleaseNoteQueryVariables>;
export const GetReportingDocument = gql`
    query GetReporting {
  reporting {
    ...reporting
  }
}
    ${ReportingFragmentDoc}`;

/**
 * __useGetReportingQuery__
 *
 * To run a query within a React component, call `useGetReportingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportingQuery(baseOptions?: Apollo.QueryHookOptions<GetReportingQuery, GetReportingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingQuery, GetReportingQueryVariables>(GetReportingDocument, options);
      }
export function useGetReportingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingQuery, GetReportingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingQuery, GetReportingQueryVariables>(GetReportingDocument, options);
        }
export type GetReportingQueryHookResult = ReturnType<typeof useGetReportingQuery>;
export type GetReportingLazyQueryHookResult = ReturnType<typeof useGetReportingLazyQuery>;
export type GetReportingQueryResult = Apollo.QueryResult<GetReportingQuery, GetReportingQueryVariables>;
export const GetLastSalesBatchDateDocument = gql`
    query GetLastSalesBatchDate {
  lastSalesBatchDate
}
    `;

/**
 * __useGetLastSalesBatchDateQuery__
 *
 * To run a query within a React component, call `useGetLastSalesBatchDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastSalesBatchDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastSalesBatchDateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastSalesBatchDateQuery(baseOptions?: Apollo.QueryHookOptions<GetLastSalesBatchDateQuery, GetLastSalesBatchDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastSalesBatchDateQuery, GetLastSalesBatchDateQueryVariables>(GetLastSalesBatchDateDocument, options);
      }
export function useGetLastSalesBatchDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastSalesBatchDateQuery, GetLastSalesBatchDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastSalesBatchDateQuery, GetLastSalesBatchDateQueryVariables>(GetLastSalesBatchDateDocument, options);
        }
export type GetLastSalesBatchDateQueryHookResult = ReturnType<typeof useGetLastSalesBatchDateQuery>;
export type GetLastSalesBatchDateLazyQueryHookResult = ReturnType<typeof useGetLastSalesBatchDateLazyQuery>;
export type GetLastSalesBatchDateQueryResult = Apollo.QueryResult<GetLastSalesBatchDateQuery, GetLastSalesBatchDateQueryVariables>;
export const UpdateProposalSherpaStateDocument = gql`
    mutation updateProposalSherpaState($proposalId: Int!, $state: SherpaProposalState!) {
  updateProposalSherpaState(proposalId: $proposalId, state: $state) {
    ...proposal
  }
}
    ${ProposalFragmentDoc}`;
export type UpdateProposalSherpaStateMutationFn = Apollo.MutationFunction<UpdateProposalSherpaStateMutation, UpdateProposalSherpaStateMutationVariables>;

/**
 * __useUpdateProposalSherpaStateMutation__
 *
 * To run a mutation, you first call `useUpdateProposalSherpaStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProposalSherpaStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProposalSherpaStateMutation, { data, loading, error }] = useUpdateProposalSherpaStateMutation({
 *   variables: {
 *      proposalId: // value for 'proposalId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateProposalSherpaStateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProposalSherpaStateMutation, UpdateProposalSherpaStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProposalSherpaStateMutation, UpdateProposalSherpaStateMutationVariables>(UpdateProposalSherpaStateDocument, options);
      }
export type UpdateProposalSherpaStateMutationHookResult = ReturnType<typeof useUpdateProposalSherpaStateMutation>;
export type UpdateProposalSherpaStateMutationResult = Apollo.MutationResult<UpdateProposalSherpaStateMutation>;
export type UpdateProposalSherpaStateMutationOptions = Apollo.BaseMutationOptions<UpdateProposalSherpaStateMutation, UpdateProposalSherpaStateMutationVariables>;
export const GetAllSherpaProposalsDocument = gql`
    query GetAllSherpaProposals($pointOfSaleExternalId: String!) {
  sherpaProposals(pointOfSaleExternalId: $pointOfSaleExternalId) {
    ...sherpaProposalSummary
  }
}
    ${SherpaProposalSummaryFragmentDoc}`;

/**
 * __useGetAllSherpaProposalsQuery__
 *
 * To run a query within a React component, call `useGetAllSherpaProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSherpaProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSherpaProposalsQuery({
 *   variables: {
 *      pointOfSaleExternalId: // value for 'pointOfSaleExternalId'
 *   },
 * });
 */
export function useGetAllSherpaProposalsQuery(baseOptions: Apollo.QueryHookOptions<GetAllSherpaProposalsQuery, GetAllSherpaProposalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSherpaProposalsQuery, GetAllSherpaProposalsQueryVariables>(GetAllSherpaProposalsDocument, options);
      }
export function useGetAllSherpaProposalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSherpaProposalsQuery, GetAllSherpaProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSherpaProposalsQuery, GetAllSherpaProposalsQueryVariables>(GetAllSherpaProposalsDocument, options);
        }
export type GetAllSherpaProposalsQueryHookResult = ReturnType<typeof useGetAllSherpaProposalsQuery>;
export type GetAllSherpaProposalsLazyQueryHookResult = ReturnType<typeof useGetAllSherpaProposalsLazyQuery>;
export type GetAllSherpaProposalsQueryResult = Apollo.QueryResult<GetAllSherpaProposalsQuery, GetAllSherpaProposalsQueryVariables>;
export const GetSherpaProposalDocument = gql`
    query GetSherpaProposal($sherpaExternalId: String!) {
  sherpaProposal(sherpaExternalId: $sherpaExternalId) {
    ...sherpaProposal
  }
}
    ${SherpaProposalFragmentDoc}`;

/**
 * __useGetSherpaProposalQuery__
 *
 * To run a query within a React component, call `useGetSherpaProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSherpaProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSherpaProposalQuery({
 *   variables: {
 *      sherpaExternalId: // value for 'sherpaExternalId'
 *   },
 * });
 */
export function useGetSherpaProposalQuery(baseOptions: Apollo.QueryHookOptions<GetSherpaProposalQuery, GetSherpaProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSherpaProposalQuery, GetSherpaProposalQueryVariables>(GetSherpaProposalDocument, options);
      }
export function useGetSherpaProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSherpaProposalQuery, GetSherpaProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSherpaProposalQuery, GetSherpaProposalQueryVariables>(GetSherpaProposalDocument, options);
        }
export type GetSherpaProposalQueryHookResult = ReturnType<typeof useGetSherpaProposalQuery>;
export type GetSherpaProposalLazyQueryHookResult = ReturnType<typeof useGetSherpaProposalLazyQuery>;
export type GetSherpaProposalQueryResult = Apollo.QueryResult<GetSherpaProposalQuery, GetSherpaProposalQueryVariables>;
export const GetSherpaProposalStatusDocument = gql`
    query GetSherpaProposalStatus($sherpaExternalId: String!) {
  sherpaProposalStatus(sherpaExternalId: $sherpaExternalId)
}
    `;

/**
 * __useGetSherpaProposalStatusQuery__
 *
 * To run a query within a React component, call `useGetSherpaProposalStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSherpaProposalStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSherpaProposalStatusQuery({
 *   variables: {
 *      sherpaExternalId: // value for 'sherpaExternalId'
 *   },
 * });
 */
export function useGetSherpaProposalStatusQuery(baseOptions: Apollo.QueryHookOptions<GetSherpaProposalStatusQuery, GetSherpaProposalStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSherpaProposalStatusQuery, GetSherpaProposalStatusQueryVariables>(GetSherpaProposalStatusDocument, options);
      }
export function useGetSherpaProposalStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSherpaProposalStatusQuery, GetSherpaProposalStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSherpaProposalStatusQuery, GetSherpaProposalStatusQueryVariables>(GetSherpaProposalStatusDocument, options);
        }
export type GetSherpaProposalStatusQueryHookResult = ReturnType<typeof useGetSherpaProposalStatusQuery>;
export type GetSherpaProposalStatusLazyQueryHookResult = ReturnType<typeof useGetSherpaProposalStatusLazyQuery>;
export type GetSherpaProposalStatusQueryResult = Apollo.QueryResult<GetSherpaProposalStatusQuery, GetSherpaProposalStatusQueryVariables>;
export const GetLastAcceptedSherpaConditionsDocument = gql`
    query GetLastAcceptedSherpaConditions($posId: Int!) {
  lastAcceptedSherpaConditions(pointOfSaleId: $posId) {
    ...sherpaCondition
  }
}
    ${SherpaConditionFragmentDoc}`;

/**
 * __useGetLastAcceptedSherpaConditionsQuery__
 *
 * To run a query within a React component, call `useGetLastAcceptedSherpaConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastAcceptedSherpaConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastAcceptedSherpaConditionsQuery({
 *   variables: {
 *      posId: // value for 'posId'
 *   },
 * });
 */
export function useGetLastAcceptedSherpaConditionsQuery(baseOptions: Apollo.QueryHookOptions<GetLastAcceptedSherpaConditionsQuery, GetLastAcceptedSherpaConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastAcceptedSherpaConditionsQuery, GetLastAcceptedSherpaConditionsQueryVariables>(GetLastAcceptedSherpaConditionsDocument, options);
      }
export function useGetLastAcceptedSherpaConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastAcceptedSherpaConditionsQuery, GetLastAcceptedSherpaConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastAcceptedSherpaConditionsQuery, GetLastAcceptedSherpaConditionsQueryVariables>(GetLastAcceptedSherpaConditionsDocument, options);
        }
export type GetLastAcceptedSherpaConditionsQueryHookResult = ReturnType<typeof useGetLastAcceptedSherpaConditionsQuery>;
export type GetLastAcceptedSherpaConditionsLazyQueryHookResult = ReturnType<typeof useGetLastAcceptedSherpaConditionsLazyQuery>;
export type GetLastAcceptedSherpaConditionsQueryResult = Apollo.QueryResult<GetLastAcceptedSherpaConditionsQuery, GetLastAcceptedSherpaConditionsQueryVariables>;
export const GetAllSlidesDocument = gql`
    query GetAllSlides($where: SlideWhereInput) {
  slides(where: $where) {
    ...slide
  }
}
    ${SlideFragmentDoc}`;

/**
 * __useGetAllSlidesQuery__
 *
 * To run a query within a React component, call `useGetAllSlidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSlidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSlidesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAllSlidesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllSlidesQuery, GetAllSlidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllSlidesQuery, GetAllSlidesQueryVariables>(GetAllSlidesDocument, options);
      }
export function useGetAllSlidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllSlidesQuery, GetAllSlidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllSlidesQuery, GetAllSlidesQueryVariables>(GetAllSlidesDocument, options);
        }
export type GetAllSlidesQueryHookResult = ReturnType<typeof useGetAllSlidesQuery>;
export type GetAllSlidesLazyQueryHookResult = ReturnType<typeof useGetAllSlidesLazyQuery>;
export type GetAllSlidesQueryResult = Apollo.QueryResult<GetAllSlidesQuery, GetAllSlidesQueryVariables>;
export const GetStaticSlidesDocument = gql`
    query GetStaticSlides {
  staticSlides {
    id
    type
    order
    imageId
    image {
      ...image
    }
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useGetStaticSlidesQuery__
 *
 * To run a query within a React component, call `useGetStaticSlidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaticSlidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaticSlidesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStaticSlidesQuery(baseOptions?: Apollo.QueryHookOptions<GetStaticSlidesQuery, GetStaticSlidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaticSlidesQuery, GetStaticSlidesQueryVariables>(GetStaticSlidesDocument, options);
      }
export function useGetStaticSlidesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaticSlidesQuery, GetStaticSlidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaticSlidesQuery, GetStaticSlidesQueryVariables>(GetStaticSlidesDocument, options);
        }
export type GetStaticSlidesQueryHookResult = ReturnType<typeof useGetStaticSlidesQuery>;
export type GetStaticSlidesLazyQueryHookResult = ReturnType<typeof useGetStaticSlidesLazyQuery>;
export type GetStaticSlidesQueryResult = Apollo.QueryResult<GetStaticSlidesQuery, GetStaticSlidesQueryVariables>;
export const GetStaticSlideTypesDocument = gql`
    query GetStaticSlideTypes($where: StaticSlideTypeWhereInput, $whereSlides: StaticSlideWhereInput, $orderBy: StaticSlideTypeOrderByWithRelationInput) {
  staticSlideTypes(where: $where, orderBy: $orderBy) {
    id
    type
    order
    editable
    productCategory
    provinces {
      id
      name
      code
    }
    staticSlides(where: $whereSlides) {
      id
      image {
        ...image
      }
      type
      order
      enabledByDefault
      brandId
      typeId
    }
  }
}
    ${ImageFragmentDoc}`;

/**
 * __useGetStaticSlideTypesQuery__
 *
 * To run a query within a React component, call `useGetStaticSlideTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaticSlideTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaticSlideTypesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      whereSlides: // value for 'whereSlides'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetStaticSlideTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetStaticSlideTypesQuery, GetStaticSlideTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaticSlideTypesQuery, GetStaticSlideTypesQueryVariables>(GetStaticSlideTypesDocument, options);
      }
export function useGetStaticSlideTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaticSlideTypesQuery, GetStaticSlideTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaticSlideTypesQuery, GetStaticSlideTypesQueryVariables>(GetStaticSlideTypesDocument, options);
        }
export type GetStaticSlideTypesQueryHookResult = ReturnType<typeof useGetStaticSlideTypesQuery>;
export type GetStaticSlideTypesLazyQueryHookResult = ReturnType<typeof useGetStaticSlideTypesLazyQuery>;
export type GetStaticSlideTypesQueryResult = Apollo.QueryResult<GetStaticSlideTypesQuery, GetStaticSlideTypesQueryVariables>;
export const GetAllTrainingDocument = gql`
    query GetAllTraining {
  trainings {
    ...training
  }
}
    ${TrainingFragmentDoc}`;

/**
 * __useGetAllTrainingQuery__
 *
 * To run a query within a React component, call `useGetAllTrainingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTrainingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTrainingQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllTrainingQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTrainingQuery, GetAllTrainingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTrainingQuery, GetAllTrainingQueryVariables>(GetAllTrainingDocument, options);
      }
export function useGetAllTrainingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTrainingQuery, GetAllTrainingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTrainingQuery, GetAllTrainingQueryVariables>(GetAllTrainingDocument, options);
        }
export type GetAllTrainingQueryHookResult = ReturnType<typeof useGetAllTrainingQuery>;
export type GetAllTrainingLazyQueryHookResult = ReturnType<typeof useGetAllTrainingLazyQuery>;
export type GetAllTrainingQueryResult = Apollo.QueryResult<GetAllTrainingQuery, GetAllTrainingQueryVariables>;
export const GetAllUsersDocument = gql`
    query GetAllUsers($where: AdminUsersWhereInput, $take: Int) {
  users(take: $take, where: $where) {
    ...user
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetUserScoresDocument = gql`
    query GetUserScores($take: Int, $skip: Int, $where: UserScoreWhereInput, $orderBy: UserScoreOrderByWithRelationInput) {
  userScores(take: $take, skip: $skip, where: $where, orderBy: $orderBy) {
    id
    totalPoints
    user {
      ...user
    }
  }
}
    ${UserFragmentDoc}`;

/**
 * __useGetUserScoresQuery__
 *
 * To run a query within a React component, call `useGetUserScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserScoresQuery({
 *   variables: {
 *      take: // value for 'take'
 *      skip: // value for 'skip'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetUserScoresQuery(baseOptions?: Apollo.QueryHookOptions<GetUserScoresQuery, GetUserScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserScoresQuery, GetUserScoresQueryVariables>(GetUserScoresDocument, options);
      }
export function useGetUserScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserScoresQuery, GetUserScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserScoresQuery, GetUserScoresQueryVariables>(GetUserScoresDocument, options);
        }
export type GetUserScoresQueryHookResult = ReturnType<typeof useGetUserScoresQuery>;
export type GetUserScoresLazyQueryHookResult = ReturnType<typeof useGetUserScoresLazyQuery>;
export type GetUserScoresQueryResult = Apollo.QueryResult<GetUserScoresQuery, GetUserScoresQueryVariables>;
export const UpdateUserPreferenceDocument = gql`
    mutation updateUserPreference($updateUserPreferenceInput: UpdateUserPreferenceInput!) {
  updateUserPreference(updateUserPreferenceInput: $updateUserPreferenceInput) {
    id
  }
}
    `;
export type UpdateUserPreferenceMutationFn = Apollo.MutationFunction<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;

/**
 * __useUpdateUserPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateUserPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPreferenceMutation, { data, loading, error }] = useUpdateUserPreferenceMutation({
 *   variables: {
 *      updateUserPreferenceInput: // value for 'updateUserPreferenceInput'
 *   },
 * });
 */
export function useUpdateUserPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>(UpdateUserPreferenceDocument, options);
      }
export type UpdateUserPreferenceMutationHookResult = ReturnType<typeof useUpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationResult = Apollo.MutationResult<UpdateUserPreferenceMutation>;
export type UpdateUserPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateUserPreferenceMutation, UpdateUserPreferenceMutationVariables>;